import React, { useState, useEffect, useRef, useMemo } from 'react';
import { aplicarFaixaQtd } from '../../utils/comissaoPorQtd';
import { useNavigate, useSearchParams, useParams, useLocation } from 'react-router-dom';
import {
  ArrowLeft, ArrowRight, Save, ChevronRight, ChevronLeft, Check,
  Hash, Users, Scale, DollarSign, Calendar,
  User, MapPin, Video, FileText, Baby, Heart, Zap, Plus, AlertTriangle, X, Crown, Copy, SplitSquareHorizontal,
  ShieldOff, ShieldCheck, Gift
} from 'lucide-react';
import { lotesService } from '../../services/lotesService';
import { ordemEntradaService } from '../../services/ordemEntradaService';
import clientesService from '../../services/clientesService';
import NovaFazendaInline from '../../components/lotes/NovaFazendaInline';
import { comissoesService } from '../../services/comissoesService';
import { useToast } from '../../hooks/useToast';
import { useOrganizador } from '../../contexts/OrganizadorContext';
import NovoClienteModal from '../../components/modals/NovoClienteModal';
import NovaComissaoModal from '../../components/modals/NovaComissaoModal';
import IsentarGTAModal from '../../components/modals/IsentarGTAModal';
import ContratoUmaVia from '../../components/contratos/ContratoUmaVia';
import ContratoUnicoButton from '../../components/contratos/ContratoUnicoButton';
import NotaPromissoriaButton from '../../components/contratos/NotaPromissoriaButton';
import NotaCompromissoButton from '../../components/contratos/NotaCompromissoButton';
import ContratoNotaButton from '../../components/contratos/ContratoNotaButton';
import Contrato3ViasButton from '../../components/contratos/Contrato3ViasButton';
import FichaLeiloeiroButton from '../../components/contratos/FichaLeiloeiroButton';
import ModalImpressaoPosFaturamento from '../../components/contratos/ModalImpressaoPosFaturamento';
import { useLabelCurral } from '../../hooks/useLabelCurral';
import DespesasLote from '../../components/lotes/DespesasLote';
import RefugarModal from '../../components/lotes/RefugarModal';
import DoarNovamenteModal from '../../components/lotes/DoarNovamenteModal';
import RefugoBadge from '../../components/lotes/RefugoBadge';
import VideoUploadLote from '../../components/lotes/VideoUploadLote';
import despesasService from '../../services/despesasService';
import organizadoresService from '../../services/organizadoresService';
import leiloesService from '../../services/leiloesService';
import { meiosPagamentoService } from '../../services/meiosPagamentoService';
import { faturamentoService } from '../../services/faturamentoService';
import { gestaoService } from '../../services/gestaoService';

import { contratoService } from '../../services/contratoService';
import mapasService from '../../services/mapasService';
import PisteiroSelect from '../../components/PisteiroSelect';
import leiloeiroService from '../../services/leiloeiroService';
import PercentualPisteiroInput from '../../components/PercentualPisteiroInput';
import { contem } from '../../utils/texto'

// N parcelas iguais, já "abertas" (1 linha por parcela) — usado nos defaults
// de dadosFinanceiros antes de flattenGrupos existir (declarada dentro do
// componente) estar disponível.
const parcelasIguais = (n, dias = 30) => Array.from({ length: n }, () => ({ quantidade: 1, peso: 1, dias }));

const NovoLote = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { id: loteId } = useParams();
  const leilaoId      = searchParams.get('leilao');
  const preNumerLote  = searchParams.get('numero_lote') || '';
  const preCurral     = searchParams.get('curral') || '';
  const { organizadorAtivo } = useOrganizador();
  const toast = useToast();
  const isEditMode = !!loteId;
  const labelCurral = useLabelCurral();

  const [formData, setFormData] = useState({
    numero_lote: preNumerLote,
    qtd: '',
    curral: preCurral,
    peso: '',
    valor_minimo_unidade: '',
    observacoes: '',
    link_video: '',
    video_url: '',
    video_poster_url: '',
    video_pending_key: '',
    poster_pending_key: '',
    vendedor_id: '',
    fazenda_id: '',
    fazenda_ficticia: '',
    usar_fazenda_ficticia: false,
    tipo_animal_id: '',
    idade_id: '',
    sexo: '',
    raca_id: '',
    qtd_crias_femeas: 0,
    qtd_crias_machos: 0,
    quem_trouxe_id: null,
    ordem: ''
  });

  const [opcoes, setOpcoes] = useState({
    tiposAnimais: [],
    idades: [],
    racas: [],
    clientes: [],
    fazendas: [],
    comissoes: []
  });

  // Comissões com a venda já resolvida pela faixa de qtd do lote (só as do tipo 'por_qtd'
  // mudam; as demais voltam idênticas). Ver utils/comissaoPorQtd.js.
  const comissoesQtd = useMemo(
    () => (Array.isArray(opcoes.comissoes) ? opcoes.comissoes.map(c => aplicarFaixaQtd(c, formData.qtd)) : opcoes.comissoes),
    [opcoes.comissoes, formData.qtd]
  );

  const [loading, setLoading] = useState(false);       // só bloqueia no modo edição (carregarLote)
  const [loadingOpcoes, setLoadingOpcoes] = useState(true); // tipos/idades/raças/comissões
  const [loadingClientes, setLoadingClientes] = useState(false); // carregamento lazy de clientes
  const [saving, setSaving] = useState(false);
  const [desfazendo, setDesfazendo] = useState(false);
  const [duplicar, setDuplicar] = useState(false);
  const [showCrias, setShowCrias] = useState(false);
  const [pesoTotalMode, setPesoTotalMode] = useState(false);
  const [pesoTotalValue, setPesoTotalValue] = useState('');
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const inputRefs = useRef({});
  const [searchStates, setSearchStates] = useState({
    tipo: { show: false, search: '' },
    raca: { show: false, search: '' },
    idade: { show: false, search: '' },
    vendedor: { show: false, search: '' }
  });
  const [fieldTouched, setFieldTouched] = useState({
    tipo_animal_id: false
  });
  const [quickCreateModals, setQuickCreateModals] = useState({
    tipo: false,
    raca: false,
    idade: false
  });
  const [showNovoClienteModal, setShowNovoClienteModal] = useState(false);
  const [quickCreateData, setQuickCreateData] = useState({ 
    nome: '', 
    sexo_padrao: '', 
    idade_padrao_id: '',
    cpf_cnpj: '',
    telefone: '',
    email: '',
    is_socio: false,
    cidade: '',
    estado: '',
    grupo: 'vendedor',
    fazenda_nome: '',
    fazenda_cidade: '',
    fazenda_estado: ''
  });
  const [quickCreateSaving, setQuickCreateSaving] = useState(false);
  const [numeroLoteError, setNumeroLoteError] = useState('');
  const [qtdError, setQtdError] = useState('');
  const [loteStatus, setLoteStatus] = useState('NOVO');
  const [defesaIsenta, setDefesaIsenta] = useState(false);
  const [showModalImpressao, setShowModalImpressao] = useState(false);
  const [valorVendaDefinido, setValorVendaDefinido] = useState(false);
  // Lote arrematado pelo módulo Pisteiro remoto (Painel V2) — "Quem Vendeu"
  // já veio definido automaticamente (PISTEIRO REMATEI) e não pode ser
  // trocado pela equipe, pra não divergir do que foi informado ao pisteiro.
  const [quemVendeuTravado, setQuemVendeuTravado] = useState(false);
  // Idem pro comprador — quando o pisteiro remoto já vinculou um comprador,
  // a equipe não pode trocar (evita desfazer o vínculo feito pelo app).
  const [compradorTravado, setCompradorTravado] = useState(false);
  const [dadosFinanceiros, setDadosFinanceiros] = useState({
    comprador_id: '',
    fazenda_comprador_id: '',
    modalidade_pagamento: 'A_VISTA', // A_VISTA como padrão
    dias_prazo: '',
    dias_prazo_comprador: '',
    dias_prazo_vendedor: '',
    parcelas: [],
    comissao_id: '',
    valor_total: 0,
    // Campos para parcelamento avançado
    primeira_parcela_tipo: 'A_VISTA', // 'A_VISTA' ou 'DIAS'
    primeira_parcela_dias: '',
    intervalo_dias: '30',
    data_segunda_parcela: '',
    grupos_parcelas: parcelasIguais(3), // Array de parcelas (1 por linha)
    // true: parcelas e valores digitados já são sobre o valor líquido (sem desconto extra na 1ª parcela)
    parcelar_sobre_liquido: false,
    // Desconto à vista
    desconto_tipo: '', // 'percentual' ou 'valor' ou '' (sem desconto)
    desconto_percentual: '',
    desconto_valor: '',
    // Pisteiros
    quem_vendeu_id: null,
    quem_vendeu_percentual: null,
    // Leiloeiro do lote
    leiloeiro_id: null,
    fora_do_leilao: false,
  });
  const [loteComissaoDefesaPct, setLoteComissaoDefesaPct] = useState(null);
  const [showValorVendaModal, setShowValorVendaModal] = useState(false);
  const [valorVendaExcecaoPorCabeca, setValorVendaExcecaoPorCabeca] = useState(false);
  const [valorVendaData, setValorVendaData] = useState({
    valor_venda_unidade: ''
  });
  const valorVendaInputRef = useRef(null);
  const compradorInputRef = useRef(null);
  const contratosDropdownRef = useRef(null);
  const notasDropdownRef = useRef(null);
  const valorVendaStateApplied = useRef(false);
  const [searchCompradorState, setSearchCompradorState] = useState({ show: false, search: '' });
  const [fazendasComprador, setFazendasComprador] = useState([]);
  const [showNovaComissaoModal, setShowNovaComissaoModal] = useState(false);
  const [comissaoSelecionada, setComissaoSelecionada] = useState(null);
  const [comissaoCalculada, setComissaoCalculada] = useState(null);
  const [compradorSelecionado, setCompradorSelecionado] = useState(null);
  const [compradorRestritoModal, setCompradorRestritoModal] = useState(null); // cliente restrito pendente de confirmação
  const [vendedorSelecionado, setVendedorSelecionado] = useState(null);
  const vendedorSearchRef = useRef(null);
  const compradorSearchRef = useRef(null);
  const [clientesComprador, setClientesComprador] = useState([]);
  const [loadingComprador, setLoadingComprador] = useState(false);
  const [comissaoAlteradaManualmente, setComissaoAlteradaManualmente] = useState(false);
  // Escolha de comissão independente por lado — cada uma reseta ao trocar de lote
  // (ver efeito abaixo, "Resetar flag quando loteId muda") pra nunca vazar de um
  // lote pro outro dentro da mesma sessão de faturamento.
  const [ignorarIndividualVenda, setIgnorarIndividualVenda] = useState(false);
  const [ignorarIndividualCompra, setIgnorarIndividualCompra] = useState(false);
  const [confirmacaoTroca, setConfirmacaoTroca] = useState(null); // { lado: 'venda'|'compra', pctAtual, pctNovo, label }
  const [dadosAlterados, setDadosAlterados] = useState(false);
  const [configuracoesFaturamento, setConfiguracoesFaturamento] = useState(null);
  const [mapasConfig, setMapasConfig] = useState(null);
  const [dataLeilao, setDataLeilao] = useState(null);
  const [meiosPagamento, setMeiosPagamento] = useState([]);
  const [showSalvarMeioPagamento, setShowSalvarMeioPagamento] = useState(false);
  const [nomeMeioPagamento, setNomeMeioPagamento] = useState('');
  const [showMeiosPagamentoModal, setShowMeiosPagamentoModal] = useState(false);
  // Índice da parcela (na lista de "Parcelas") que está com o campo de
  // vencimento no modo "data" em vez de "dias desde a anterior" — só afeta
  // qual input aparece, não é salvo.
  const [parcelasEmModoData, setParcelasEmModoData] = useState({});
  const [refugoInfo, setRefugoInfo] = useState({ foi_refugado: false, qtd_total_refugada: 0 });
  const [showDefesaModal, setShowDefesaModal] = useState(false);
  const [showRefugarModal, setShowRefugarModal] = useState(false);
  const [showDoarNovamenteModal, setShowDoarNovamenteModal] = useState(false);
  const [gtaNotaIsento, setGtaNotaIsento] = useState(false);
  const [gtaIsento, setGtaIsento] = useState(false);
  const [notaIsento, setNotaIsento] = useState(false);
  const [showIsentarGtaModal, setShowIsentarGtaModal] = useState(false);
  const [showContratosDropdown, setShowContratosDropdown] = useState(false);
  const [showNotasDropdown, setShowNotasDropdown] = useState(false);
  const [valorDefesa, setValorDefesa] = useState('');
  const [comissaoDefesa, setComissaoDefesa] = useState('');
  const [dadosLeilao, setDadosLeilao] = useState(null);
  // Leilão beneficente (sem "respeitar individuais"): a comissão zerada do leilão vale
  // sempre e a comissão individual do cliente é ignorada nos dois lados.
  const forcarComissaoLeilao = dadosLeilao?.tipo_leilao === 'beneficente'
    && !dadosLeilao?.comissao_respeitar_individual
    && !!dadosLeilao?.comissao_padrao_id;
  const [despesasLote, setDespesasLote] = useState([]); // despesas do lote para cálculo financeiro
  const [contratoConfig, setContratoConfig] = useState(null);
  const [loteAtualLeilaoId, setLoteAtualLeilaoId] = useState(null);
  const [leileirosDoLeilaoList, setLeileirosDoLeilaoList] = useState([]);
  const [comissaoCustom, setComissaoCustom] = useState({ compra: null, venda: null });
  const [comissaoAlteradaManualmenteFlag, setComissaoAlteradaManualmenteFlag] = useState(false);

  // Modal "Faturar outro lote"
  const [faturarOutroModal, setFaturarOutroModal] = useState(false);
  const [faturarOutroLotes, setFaturarOutroLotes] = useState([]);
  const [faturarOutroSearch, setFaturarOutroSearch] = useState('');
  const [faturarOutroSelecionado, setFaturarOutroSelecionado] = useState(null);
  const [faturarOutroValor, setFaturarOutroValor] = useState('');

  // Função para verificar se pode editar
  const podeEditar = () => {
    return loteStatus !== 'FATURADO' && loteStatus !== 'DEFESA';
  };

  // Funções auxiliares para parcelamento
  const calcularDataParcela = (dataBase, dias, tipoCalculo) => {
    const data = new Date(dataBase);
    if (tipoCalculo === 'DIAS_CORRIDOS') {
      data.setDate(data.getDate() + dias);
    } else {
      // DIA_FIXO_MENSAL — soma meses cheios mantendo o dia; se o mês de
      // destino não tiver esse dia (ex: dia 29/30/31 caindo em fevereiro),
      // usa o último dia válido do mês em vez de estourar pro mês seguinte
      // (comportamento padrão do Date.setMonth do JS).
      const mesesAdicionar = Math.floor(dias / 30);
      const diaOriginal = data.getDate();
      data.setDate(1); // evita overflow ao trocar de mês
      data.setMonth(data.getMonth() + mesesAdicionar);
      const ultimoDiaDoMes = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate();
      data.setDate(Math.min(diaOriginal, ultimoDiaDoMes));
    }
    return data;
  };

  // Sempre trabalha com 1 parcela por "grupo" (quantidade:1) — cada linha na
  // tela é uma parcela de verdade, com seu próprio dia/data editável. Grupos
  // antigos com quantidade > 1 (templates salvos antes dessa mudança, ou
  // atalhos como "12x iguais") são "abertos" em N linhas individuais aqui.
  const flattenGrupos = (grupos) => {
    const flat = [];
    (grupos || []).forEach(g => {
      const n = g.quantidade || 1;
      for (let i = 0; i < n; i++) {
        const item = { quantidade: 1, peso: g.peso || 1, dias: g.dias ?? 30 };
        if (g.valor_fixo != null && g.valor_fixo !== '') item.valor_fixo = g.valor_fixo;
        flat.push(item);
      }
    });
    return flat.length > 0 ? flat : [{ quantidade: 1, peso: 1, dias: 30 }];
  };

  // Fecha dropdowns ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (contratosDropdownRef.current && !contratosDropdownRef.current.contains(e.target)) {
        setShowContratosDropdown(false);
      }
      if (notasDropdownRef.current && !notasDropdownRef.current.contains(e.target)) {
        setShowNotasDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Recarrega despesas ao entrar no step Financeiro (step 5) para garantir cálculos atualizados
  useEffect(() => {
    if (currentStep === 5 && loteId && organizadorAtivo?.id) {
      despesasService.listar(organizadorAtivo.id, loteId)
        .then(d => setDespesasLote(d || []))
        .catch(() => {});
    }
  }, [currentStep]);

  // Calcula o valor líquido baseado no fluxo do organizador/leilão
  const calcularValorLiquido = () => {
    const vv = dadosFinanceiros.valor_total || 0;
    const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
    const isSeparada = ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));

    // Desconto à vista
    let desconto = 0;
    if (dadosFinanceiros.modalidade_pagamento === 'A_VISTA') {
      if (dadosFinanceiros.desconto_tipo === 'percentual' && dadosFinanceiros.desconto_percentual) {
        desconto = vv * parseFloat(dadosFinanceiros.desconto_percentual) / 100;
      } else if (dadosFinanceiros.desconto_tipo === 'valor' && dadosFinanceiros.desconto_valor) {
        desconto = parseFloat(dadosFinanceiros.desconto_valor);
      }
    }

    if (isSeparada) return vv - desconto; // fluxo separado: vendedor recebe valor cheio menos desconto
    // primeira_parcela / gta_nota: desconta comissão de venda + despesas + desconto
    const comissaoBase = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
    const comissaoEfetiva = comissaoCalculada || comissaoBase;
    const cvPct = (!ignorarIndividualVenda && vendedorSelecionado?.comissao_venda_pct != null)
      ? Number(vendedorSelecionado.comissao_venda_pct)
      : Number(comissaoEfetiva?.comissao_venda || 0);
    const cvVal = vv * cvPct / 100;
    const totalDespesas = despesasLote.reduce((s, d) => s + Number(d.valor || 0), 0);
    return vv - cvVal - totalDespesas - desconto;
  };

  const isFluxoSeparada = () => {
    const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
    return ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));
  };

  // No fluxo separada não há desconto na 1ª parcela, então a opção não se aplica
  const parcelarSobreLiquido = () => !!dadosFinanceiros.parcelar_sobre_liquido && !isFluxoSeparada();

  const calcularBrutosParcelas = (grupos, vv) => {
    const fixo = (g) => (g.valor_fixo !== undefined && g.valor_fixo !== null && g.valor_fixo !== '' ? Number(g.valor_fixo) : null);
    const totalFixo = grupos.reduce((acc, g) => acc + (fixo(g) ?? 0) * g.quantidade, 0);
    const unidadesRestantes = grupos.reduce((acc, g) => acc + (fixo(g) === null ? g.quantidade * g.peso : 0), 0);
    const porUnidade = unidadesRestantes > 0 ? (vv - totalFixo) / unidadesRestantes : 0;
    const brutos = [];
    grupos.forEach(g => {
      const f = fixo(g);
      for (let i = 0; i < g.quantidade; i++) brutos.push(f !== null ? f : porUnidade * g.peso);
    });
    return brutos;
  };

  const gerarParcelasAutomaticas = () => {
    if (!dadosFinanceiros.valor_total || dadosFinanceiros.grupos_parcelas.length === 0) return [];

    const vv = dadosFinanceiros.valor_total;

    // Desconto da comissão de venda + despesas que saem da primeira parcela
    const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
    const isSeparada = ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));
    const comissaoBase = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
    const comissaoEfetiva = comissaoCalculada || comissaoBase;
    const cvPct = (!ignorarIndividualVenda && vendedorSelecionado?.comissao_venda_pct != null)
      ? Number(vendedorSelecionado.comissao_venda_pct)
      : Number(comissaoEfetiva?.comissao_venda || 0);
    const cvVal = isSeparada ? 0 : (vv * cvPct / 100);
    // Despesas: só descontam na primeira parcela se fluxo não for separada
    const totalDespesas = isSeparada ? 0 : despesasLote.reduce((s, d) => s + Number(d.valor || 0), 0);
    const descontoFirstParcela = cvVal + totalDespesas;

    // Calcular total de "unidades de peso" para divisão proporcional sobre valor_total
    // Parcelas com valor digitado (valor_fixo) saem do rateio; as demais dividem
    // o restante proporcionalmente ao peso.
    // Parcelar sobre o líquido: a base do rateio já é o valor líquido e nenhuma
    // parcela sofre desconto adicional (valor digitado = valor que o cliente recebe)
    const sobreLiquido = parcelarSobreLiquido();
    const brutosParcelas = calcularBrutosParcelas(
      dadosFinanceiros.grupos_parcelas,
      sobreLiquido ? calcularValorLiquido() : vv
    );
    const modoExcedente = sobreLiquido ? 'NEGATIVA' : (configuracoesFaturamento?.comissao_excedente_modo || 'NEGATIVA');
    // NEGATIVA (padrão): desconta tudo da 1ª parcela, podendo ficar negativa.
    // PROXIMA_PARCELA: se a comissão passar da 1ª parcela, desconta o excedente
    // das seguintes, em ordem, até zerar.
    const valoresAjustados = [...brutosParcelas];
    if (modoExcedente === 'PROXIMA_PARCELA') {
      let restante = descontoFirstParcela;
      for (let i = 0; i < valoresAjustados.length && restante > 0; i++) {
        const novo = valoresAjustados[i] - restante;
        if (novo >= 0) {
          valoresAjustados[i] = novo;
          restante = 0;
        } else {
          valoresAjustados[i] = 0;
          restante = -novo;
        }
      }
      if (restante > 0 && valoresAjustados.length > 0) {
        valoresAjustados[valoresAjustados.length - 1] -= restante;
      }
    } else if (valoresAjustados.length > 0 && !sobreLiquido) {
      valoresAjustados[0] = valoresAjustados[0] - descontoFirstParcela;
    }
    const parcelas = [];
    
    // Data base para cálculo
    let dataBase;
    if (configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' && dataLeilao) {
      dataBase = new Date(dataLeilao);
    } else {
      dataBase = new Date();
    }
    
    // Ajustar data base se primeira parcela não for à vista
    if (dadosFinanceiros.primeira_parcela_tipo === 'DIAS' && dadosFinanceiros.primeira_parcela_dias) {
      dataBase = calcularDataParcela(dataBase, parseInt(dadosFinanceiros.primeira_parcela_dias), configuracoesFaturamento?.tipo_calculo_parcelas || 'DIAS_CORRIDOS');
    }
    
    let dataAtual = new Date(dataBase);

    // 1 linha = 1 parcela. A 1ª parcela usa a data base (definida acima por
    // "Vencimento da 1ª Parcela"); cada parcela seguinte usa o "dias" da sua
    // PRÓPRIA linha, contado a partir da parcela anterior — por isso a 1ª
    // linha não tem campo de dias (nada antes dela pra contar).
    dadosFinanceiros.grupos_parcelas.forEach((grupo, index) => {
      if (index > 0) {
        const intervaloDias = parseInt(grupo.dias ?? dadosFinanceiros.intervalo_dias) || 30;
        dataAtual = calcularDataParcela(dataAtual, intervaloDias, configuracoesFaturamento?.tipo_calculo_parcelas || 'DIAS_CORRIDOS');
      }

      const numeroParcela = index + 1;
      const valorFinal = valoresAjustados[index];
      const teveDesconto = valorFinal !== brutosParcelas[index];

      parcelas.push({
        numero: numeroParcela,
        valor: valorFinal,
        data: new Date(dataAtual),
        grupo: numeroParcela,
        peso: grupo.peso,
        descricao: `${numeroParcela}ª parcela (Peso ${grupo.peso})${teveDesconto ? ' *desc.com.venda+desp.' : ''}`
      });
    });

    return parcelas;
  };

  // Funções para meios de pagamento
  const salvarMeioPagamento = async () => {
    if (!nomeMeioPagamento.trim()) {
      toast.error('Digite um nome para o meio de pagamento');
      return;
    }
    
    try {
      const meioPagamento = {
        nome: nomeMeioPagamento.trim(),
        tipo: 'PARCELADO',
        primeira_parcela_tipo: dadosFinanceiros.primeira_parcela_tipo,
        primeira_parcela_dias: dadosFinanceiros.primeira_parcela_dias,
        grupos_parcelas: dadosFinanceiros.grupos_parcelas.map(({ valor_fixo, ...resto }) => resto),
        // Compat: telas antigas (ex: Gestão de Meios de Pagamento) ainda leem
        // esse campo pra montar a descrição resumida do modelo.
        intervalo_dias: dadosFinanceiros.grupos_parcelas[0]?.dias || 30
      };
      
      const novoMeio = await meiosPagamentoService.criar(organizadorAtivo.id, meioPagamento);
      setMeiosPagamento(prev => [...prev, novoMeio]);
      
      setNomeMeioPagamento('');
      setShowSalvarMeioPagamento(false);
      toast.success('Meio de pagamento salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar meio de pagamento:', error);
      toast.error('Erro ao salvar meio de pagamento');
    }
  };

  const carregarMeioPagamento = (meio) => {
    setDadosFinanceiros(prev => ({
      ...prev,
      modalidade_pagamento: meio.tipo,
      dias_prazo: meio.dias_prazo || '',
      primeira_parcela_tipo: meio.primeira_parcela_tipo || 'A_VISTA',
      primeira_parcela_dias: meio.primeira_parcela_dias || '',
      // Modelos antigos não tinham "dias" por grupo — cai no intervalo_dias
      // global salvo no modelo (ou 30) para manter o comportamento de antes.
      // Sempre abre em 1 linha por parcela (flattenGrupos).
      grupos_parcelas: flattenGrupos((meio.grupos_parcelas || [{ quantidade: 3, peso: 1 }])
        .map(g => ({ ...g, dias: g.dias ?? meio.intervalo_dias ?? 30 })))
    }));
    setShowMeiosPagamentoModal(false);
    toast.success(`Meio de pagamento "${meio.nome}" carregado!`, 1500);
  };

  const excluirMeioPagamento = async (meioId) => {
    try {
      await meiosPagamentoService.excluir(organizadorAtivo.id, meioId);
      setMeiosPagamento(prev => prev.filter(m => m.id !== meioId));
      toast.success('Meio de pagamento excluído!');
    } catch (error) {
      console.error('Erro ao excluir meio de pagamento:', error);
      toast.error('Erro ao excluir meio de pagamento');
    }
  };

  // Carregar meios de pagamento
  const carregarMeiosPagamento = async () => {
    try {
      const meios = await meiosPagamentoService.listar(organizadorAtivo.id);
      setMeiosPagamento(meios || []);
    } catch (error) {
      console.error('Erro ao carregar meios de pagamento:', error);
      // Se der erro (ex: organizador sem meios), definir array vazio
      setMeiosPagamento([]);
    }
  };

  const carregarContratoConfig = async () => {
    try {
      const config = await contratoService.getConfig(organizadorAtivo.id);
      setContratoConfig(config);
    } catch (error) {
      console.error('Erro ao carregar config de contrato:', error);
    }
  };

  // Funções de faturamento
  const faturarLote = async () => {
    try {
      let parcelasParaSalvar;
      if (dadosFinanceiros.modalidade_pagamento === 'A_VISTA') {
        // À Vista: uma única parcela com valor líquido
        const vv = dadosFinanceiros.valor_total;
        const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
        const isSeparada = ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));
        const comissaoBase = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
        const comissaoEfetiva = comissaoCalculada || comissaoBase;
        const cvPct = (!ignorarIndividualVenda && vendedorSelecionado?.comissao_venda_pct != null)
          ? Number(vendedorSelecionado.comissao_venda_pct)
          : Number(comissaoEfetiva?.comissao_venda || 0);
        const cvVal = isSeparada ? 0 : (vv * cvPct / 100);
        const totalDespesas = isSeparada ? 0 : despesasLote.reduce((s, d) => s + Number(d.valor || 0), 0);

        // Desconto à vista (aplicado sobre vv, NÃO afeta comissão)
        let desconto = 0;
        if (dadosFinanceiros.desconto_tipo === 'percentual' && dadosFinanceiros.desconto_percentual) {
          desconto = vv * parseFloat(dadosFinanceiros.desconto_percentual) / 100;
        } else if (dadosFinanceiros.desconto_tipo === 'valor' && dadosFinanceiros.desconto_valor) {
          desconto = parseFloat(dadosFinanceiros.desconto_valor);
        }

        const liquido = vv - cvVal - totalDespesas - desconto;

        let dataBase;
        if (configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' && dataLeilao) {
          dataBase = new Date(dataLeilao);
        } else {
          dataBase = new Date();
        }

        parcelasParaSalvar = [{
          numero: 1,
          valor: liquido,
          data: dataBase.toISOString(),
          grupo: 1,
          peso: 1,
          descricao: 'À vista'
        }];
      } else if (dadosFinanceiros.modalidade_pagamento === 'PRAZO') {
        // Prazo: uma única parcela com vencimento em X dias
        const vv = dadosFinanceiros.valor_total;
        const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
        const isSeparada = ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));
        const comissaoBase = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
        const comissaoEfetiva = comissaoCalculada || comissaoBase;
        const cvPct = (!ignorarIndividualVenda && vendedorSelecionado?.comissao_venda_pct != null)
          ? Number(vendedorSelecionado.comissao_venda_pct)
          : Number(comissaoEfetiva?.comissao_venda || 0);
        const cvVal = isSeparada ? 0 : (vv * cvPct / 100);
        const totalDespesas = isSeparada ? 0 : despesasLote.reduce((s, d) => s + Number(d.valor || 0), 0);
        const liquido = vv - cvVal - totalDespesas;

        const usaPrazoDiferente = mapasConfig?.prazo_dias_diferente
        const diasComprador = usaPrazoDiferente ? parseInt(dadosFinanceiros.dias_prazo_comprador) || 0 : parseInt(dadosFinanceiros.dias_prazo) || 0
        const dias = diasComprador
        const tipoCalc = configuracoesFaturamento?.tipo_calculo_parcelas || 'DIAS_CORRIDOS';

        // Data base
        let tsBase;
        if (configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' && dataLeilao) {
          tsBase = new Date(dataLeilao).getTime();
        } else {
          tsBase = Date.now();
        }

        // Soma dias via milissegundos (infalível)
        let tsVenc = tsBase;
        if (dias > 0) {
          if (tipoCalc === 'DIAS_CORRIDOS') {
            tsVenc = tsBase + (dias * 24 * 60 * 60 * 1000);
          } else {
            // DIA_FIXO_MENSAL
            const d = new Date(tsBase);
            d.setMonth(d.getMonth() + Math.floor(dias / 30));
            tsVenc = d.getTime();
          }
        }

        const dataVencimento = new Date(tsVenc).toISOString();

        parcelasParaSalvar = [{
          numero: 1,
          valor: liquido,
          data: dataVencimento,
          grupo: 1,
          peso: 1,
          descricao: `Prazo ${dias} dias`
        }];
      } else {
        parcelasParaSalvar = gerarParcelasAutomaticas();
      }

      const dadosFaturamento = {
        comprador_id: parseInt(dadosFinanceiros.comprador_id),
        fazenda_comprador_id: dadosFinanceiros.fazenda_comprador_id ? parseInt(dadosFinanceiros.fazenda_comprador_id) : null,
        valor_total: dadosFinanceiros.valor_total,
        comissao_id: parseInt(dadosFinanceiros.comissao_id),
        // Cada lado congela independente — ver LoteService._congelar_comissao_custom
        usa_comissao_padrao_venda: ignorarIndividualVenda,
        usa_comissao_padrao_compra: ignorarIndividualCompra,
        modalidade_pagamento: dadosFinanceiros.modalidade_pagamento,
        // Desconto à vista
        desconto_percentual: dadosFinanceiros.desconto_tipo === 'percentual' ? parseFloat(dadosFinanceiros.desconto_percentual || 0) : null,
        desconto_valor: dadosFinanceiros.desconto_tipo === 'valor' ? parseFloat(dadosFinanceiros.desconto_valor || 0) : null,
        // Pisteiros
        quem_trouxe_id: formData.quem_trouxe_id ? parseInt(formData.quem_trouxe_id) : null,
        quem_vendeu_id: dadosFinanceiros.quem_vendeu_id ? parseInt(dadosFinanceiros.quem_vendeu_id) : null,
        // Leiloeiro do lote
        leiloeiro_id:   dadosFinanceiros.fora_do_leilao ? null : (dadosFinanceiros.leiloeiro_id ? parseInt(dadosFinanceiros.leiloeiro_id) : null),
        fora_do_leilao: dadosFinanceiros.fora_do_leilao || false,
        dados_pagamento: {
          primeira_parcela_tipo: dadosFinanceiros.primeira_parcela_tipo,
          primeira_parcela_dias: dadosFinanceiros.primeira_parcela_dias,
          grupos_parcelas: dadosFinanceiros.modalidade_pagamento === 'PARCELADO' ? dadosFinanceiros.grupos_parcelas : [],
          parcelar_sobre_liquido: dadosFinanceiros.modalidade_pagamento === 'PARCELADO' && parcelarSobreLiquido(),
          dias_prazo: mapasConfig?.prazo_dias_diferente ? dadosFinanceiros.dias_prazo_comprador : dadosFinanceiros.dias_prazo,
          dias_prazo_comprador: mapasConfig?.prazo_dias_diferente ? dadosFinanceiros.dias_prazo_comprador : undefined,
          dias_prazo_vendedor: mapasConfig?.prazo_dias_diferente ? dadosFinanceiros.dias_prazo_vendedor : undefined,
          parcelas_calculadas: parcelasParaSalvar
        }
      };
      
      console.log('🔍 DEBUG - Dados de faturamento:', dadosFaturamento);
      console.log('🔍 DEBUG - Fazenda comprador selecionada:', fazendasComprador.find(f => f.id.toString() === dadosFinanceiros.fazenda_comprador_id));
      console.log('🔍 DEBUG - Observações do lote:', formData.observacoes);
      
      await faturamentoService.faturarLote(organizadorAtivo.id, loteId, dadosFaturamento);
      setLoteStatus('FATURADO');
      localStorage.setItem('rematei-lote-updated', Date.now().toString());
      toast.success('Lote faturado com sucesso!');
      
      // Mostrar modal de impressão se habilitado na config
      if (contratoConfig?.modal_impressao_habilitado && ((contratoConfig?.modal_impressao_opcoes || []).length > 0 || contratoConfig?.modal_impressao_novo_lote)) {
        setShowModalImpressao(true);
      }

      // TODO: Reativar quando o cálculo estiver validado
      // Buscar lotes disponíveis do mesmo leilão para oferecer faturar outro
      // const leilaoRef = loteAtualLeilaoId || parseInt(leilaoId);
      // if (leilaoRef) {
      //   try {
      //     const todos = await lotesService.listarLotesPorLeilao(organizadorAtivo.id, leilaoRef);
      //     const disponiveis = (todos || []).filter(
      //       l => l.id !== parseInt(loteId) && (l.status === 'NOVO' || l.status === 'EDITADO')
      //     );
      //     setFaturarOutroLotes(disponiveis);
      //     setFaturarOutroSearch('');
      //     setFaturarOutroSelecionado(null);
      //     setFaturarOutroValor('');
      //     setFaturarOutroModal(true);
      //   } catch { /* silencioso */ }
      // }
    } catch (error) {
      console.error('Erro ao faturar lote:', error);
      const msg = error?.response?.data?.detail || error?.message || 'Erro ao faturar lote';
      toast.error(msg);
    }
  };

  const desfazerNegociacao = async () => {
    // Verificar se existem parcelas pagas antes de desfazer
    try {
      const res = await gestaoService.listarParcelasNegociacao(organizadorAtivo.id, { lote_id: loteId })
      const parcelas = (res.data || res || []).filter(p => String(p.lote_id) === String(loteId))
      const pagas = parcelas.filter(p => p.status === 'pago')
      if (pagas.length > 0) {
        const totalPago = pagas.reduce((s, p) => s + Number(p.valor || 0), 0)
        const fmtValor = totalPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        toast((t) => (
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-gray-800">
              Este lote possui <strong>{pagas.length} parcela{pagas.length > 1 ? 's' : ''}</strong> já paga{pagas.length > 1 ? 's' : ''} ({fmtValor}).
            </p>
            <p className="text-xs text-gray-500">Ao desfazer, esses lançamentos serão excluídos permanentemente.</p>
            <div className="flex gap-2 mt-1">
              <button onClick={() => { toast.dismiss(t.id); executarDesfazer() }}
                className="flex-1 px-3 py-1.5 text-xs font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700">
                Desfazer mesmo assim
              </button>
              <button onClick={() => toast.dismiss(t.id)}
                className="flex-1 px-3 py-1.5 text-xs font-semibold border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50">
                Cancelar
              </button>
            </div>
          </div>
        ), { duration: 15000, style: { maxWidth: '380px' } })
        return
      }
    } catch {
      // Se falhar a verificação, segue sem bloquear
    }

    await executarDesfazer()
  };

  const executarDesfazer = async () => {
    setDesfazendo(true);
    try {
      await faturamentoService.desfazerNegociacao(organizadorAtivo.id, loteId);
      setLoteStatus('EDITADO');
      await carregarLote();
      setCurrentStep(5);
      toast.success('Negociação desfeita com sucesso!');
    } catch (error) {
      console.error('Erro ao desfazer negociação:', error);
      toast.error('Erro ao desfazer negociação');
    } finally {
      setDesfazendo(false);
    }
  };

  const resetarLote = async () => {
    if ((quemVendeuTravado || compradorTravado) && !window.confirm(
      'Este lote foi vendido pelo Pisteiro Rematei. Resetar vai apagar o vínculo com o comprador e a comissão registrada, sem volta. Tem certeza que quer resetar?'
    )) {
      return;
    }
    try {
      await faturamentoService.resetarLote(organizadorAtivo.id, loteId);
      setLoteStatus('NOVO');
      setValorVendaDefinido(false);
      setDadosFinanceiros({
        comprador_id: '',
        fazenda_comprador_id: '',
        modalidade_pagamento: 'A_VISTA',
        dias_prazo: '',
        parcelas: [],
        comissao_id: '',
        valor_total: 0,
        primeira_parcela_tipo: 'A_VISTA',
        primeira_parcela_dias: '',
        grupos_parcelas: parcelasIguais(3)
      });
      setCompradorSelecionado(null);
      setValorVendaData({ valor_venda_unidade: '' });
      setQuemVendeuTravado(false);
      setCompradorTravado(false);
      toast.success('Lote resetado com sucesso!');
    } catch (error) {
      console.error('Erro ao resetar lote:', error);
      toast.error('Erro ao resetar lote');
    }
  };

  // Em defesa, comprador == vendedor, logo o cenário de sócios (quando a comissão é do
  // tipo 'socios') usa o status de sócio do vendedor dos dois lados — mesma regra do backend.
  const calcularPctComissaoDefesa = (comissaoObj) => {
    if (!comissaoObj) return 0;
    if (organizadorAtivo?.usa_comissao_socios && comissaoObj.tipo_comissao === 'socios' && vendedorSelecionado?.is_socio) {
      return Number(comissaoObj.ambos_socios_defesa ?? comissaoObj.comissao_defesa ?? 0);
    }
    return Number(comissaoObj.comissao_defesa ?? 0);
  };

  // Abre o modal de defesa já com o valor de venda digitado antes (se houver)
  const abrirModalDefesa = () => {
    const c = opcoes.comissoes?.find(c => c.is_padrao);
    if (c) setComissaoDefesa(c.id.toString());
    const valorJaInformado = valorVendaData.valor_venda_unidade;
    if (valorJaInformado && !valorDefesa) setValorDefesa(String(valorJaInformado));
    setShowDefesaModal(true);
  };

  const marcarComoDefesa = async () => {
    if (!valorDefesa) {
      toast.error('Informe o valor da defesa');
      return;
    }
    
    try {
      // Definir comprador como o mesmo vendedor
      const vendedor = vendedorSelecionado;
      if (!vendedor) {
        toast.error('Vendedor não encontrado');
        return;
      }
      
      const valorTotal = parseFloat(valorDefesa.replace(',', '.')) * parseInt(formData.qtd);
      
      let dadosDefesa;
      
      if (comissaoDefesa) {
        // Usar comissão selecionada
        const comissaoSelecionada = opcoes.comissoes?.find(c => c.id.toString() === comissaoDefesa);
        if (!comissaoSelecionada) {
          toast.error('Comissão selecionada não encontrada');
          return;
        }
        setLoteComissaoDefesaPct(calcularPctComissaoDefesa(comissaoSelecionada));

        dadosDefesa = {
          comprador_id: parseInt(formData.vendedor_id),
          fazenda_comprador_id: formData.fazenda_id ? parseInt(formData.fazenda_id) : null,
          valor_total: valorTotal,
          comissao_id: parseInt(comissaoSelecionada.id),
          modalidade_pagamento: 'A_VISTA',
          dados_pagamento: {
            primeira_parcela_tipo: 'A_VISTA',
            grupos_parcelas: [],
            parcelas_calculadas: []
          }
        };
        
        setDadosFinanceiros({
          comprador_id: formData.vendedor_id,
          fazenda_comprador_id: formData.fazenda_id || '',
          modalidade_pagamento: 'A_VISTA',
          dias_prazo: '',
          parcelas: [],
          comissao_id: comissaoSelecionada.id.toString(),
          valor_total: valorTotal,
          primeira_parcela_tipo: 'A_VISTA',
          primeira_parcela_dias: '',
          grupos_parcelas: []
        });
      } else {
        // Sem comissão (defesa gratuita)
        setLoteComissaoDefesaPct(0);
        dadosDefesa = {
          comprador_id: parseInt(formData.vendedor_id),
          fazenda_comprador_id: formData.fazenda_id ? parseInt(formData.fazenda_id) : null,
          valor_total: valorTotal,
          comissao_id: null,
          modalidade_pagamento: 'A_VISTA',
          dados_pagamento: {
            primeira_parcela_tipo: 'A_VISTA',
            grupos_parcelas: [],
            parcelas_calculadas: []
          }
        };
        
        setDadosFinanceiros({
          comprador_id: formData.vendedor_id,
          fazenda_comprador_id: formData.fazenda_id || '',
          modalidade_pagamento: 'A_VISTA',
          dias_prazo: '',
          parcelas: [],
          comissao_id: '',
          valor_total: valorTotal,
          primeira_parcela_tipo: 'A_VISTA',
          primeira_parcela_dias: '',
          grupos_parcelas: []
        });
      }
      
      await faturamentoService.faturarLote(organizadorAtivo.id, loteId, dadosDefesa);
      setLoteStatus('DEFESA');
      
      setCompradorSelecionado(vendedor);
      setValorVendaDefinido(true);
      setValorVendaData({ valor_venda_unidade: valorDefesa });
      
      setShowDefesaModal(false);
      setValorDefesa('');
      setComissaoDefesa('');
      toast.success('Lote marcado como defesa com sucesso!');
    } catch (error) {
      console.error('Erro ao marcar como defesa:', error);
      toast.error('Erro ao marcar como defesa');
    }
  };

  useEffect(() => {
    if (organizadorAtivo?.id) {
      carregarMeiosPagamento();
      carregarContratoConfig();
    }
  }, [organizadorAtivo]);

  // Pré-selecionar meio de pagamento do leilão quando regra é por_parcela
  useEffect(() => {
    if (dadosLeilao?.regra_faturamento === 'por_parcela' && dadosLeilao?.meio_pagamento_padrao_id && meiosPagamento.length > 0 && !valorVendaExcecaoPorCabeca) {
      const meioPadrao = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
      if (meioPadrao && dadosFinanceiros.modalidade_pagamento === 'A_VISTA') {
        setDadosFinanceiros(prev => ({
          ...prev,
          modalidade_pagamento: meioPadrao.tipo,
          dias_prazo: meioPadrao.dias_prazo || '',
          primeira_parcela_tipo: meioPadrao.primeira_parcela_tipo || 'A_VISTA',
          primeira_parcela_dias: meioPadrao.primeira_parcela_dias || '',
          grupos_parcelas: flattenGrupos(meioPadrao.grupos_parcelas || [{ quantidade: 3, dias: 30, peso: 1 }])
        }));
      }
    }
  }, [dadosLeilao, meiosPagamento]);

  const getVendedorDisplay = () => {
    const vendedor = vendedorSelecionado;
    return vendedor ? vendedor.nome + (vendedor.is_socio ? ' 👥' : '') : '';
  };

  const getCompradorDisplay = () => {
    if (compradorSelecionado) {
      return compradorSelecionado.nome + (compradorSelecionado.is_socio ? ' 👥' : '');
    }
    return '';
  };

  const steps = isEditMode ? [
    { id: 'basico', title: 'Lote', icon: Hash },
    { id: 'animal', title: 'Animais', icon: Zap },
    { id: 'vendedor', title: 'Vendedor', icon: User },
    { id: 'extras', title: 'Extras', icon: FileText },
    { id: 'despesas', title: 'Despesas', icon: AlertTriangle },
    { id: 'financeiro', title: 'Financeiro', icon: DollarSign },
  ] : [
    { id: 'basico', title: 'Lote', icon: Hash },
    { id: 'animal', title: 'Animais', icon: Zap },
    { id: 'vendedor', title: 'Vendedor', icon: User },
    { id: 'extras', title: 'Extras', icon: FileText }
  ];

  // Resetar flag quando loteId muda (navegação entre lotes sem remount)
  useEffect(() => {
    valorVendaStateApplied.current = false;
    // A escolha de comissão (individual/sócio/padrão) é por lote — sem isso, o
    // faturamento de um lote em sequência herdava a escolha do lote anterior
    // (mesmo com vendedor/comprador diferentes) e congelava o percentual errado.
    setIgnorarIndividualVenda(forcarComissaoLeilao);
    setIgnorarIndividualCompra(forcarComissaoLeilao);
    setConfirmacaoTroca(null);
  }, [loteId]);

  // Mesma proteção, mas pro caso de trocar o vendedor/comprador sem trocar de lote
  // (ex: selecionou errado e corrigiu antes de faturar) — a escolha de comissão do
  // cliente anterior não deve continuar valendo pro novo.
  useEffect(() => { setIgnorarIndividualVenda(forcarComissaoLeilao); }, [vendedorSelecionado?.id, forcarComissaoLeilao]);
  useEffect(() => { setIgnorarIndividualCompra(forcarComissaoLeilao); }, [compradorSelecionado?.id, forcarComissaoLeilao]);
  useEffect(() => {
    if (!forcarComissaoLeilao) return;
    const idLeilao = dadosLeilao.comissao_padrao_id.toString();
    setDadosFinanceiros(prev => (prev.comissao_id === idLeilao ? prev : { ...prev, comissao_id: idLeilao }));
  }, [forcarComissaoLeilao, dadosLeilao?.comissao_padrao_id, dadosFinanceiros.comissao_id]);

  useEffect(() => {
    if (organizadorAtivo?.id) {
      carregarOpcoes();
      carregarConfiguracoesFaturamento();
      carregarMapasConfig();
      if (isEditMode && loteId) {
        carregarLote();
      }
      if (leilaoId) {
        carregarDataLeilao();
      }
    }
  }, [organizadorAtivo, loteId, leilaoId]);

  // Leilão com filtro automático: "Ordem do Lote" vira só exibição da posição na ordem de entrada
  const [ordemAuto, setOrdemAuto] = useState({ ativo: false, posicao: null })
  useEffect(() => {
    const leilaoRef = loteAtualLeilaoId || (leilaoId ? parseInt(leilaoId) : null)
    if (!organizadorAtivo?.id || !leilaoRef) return
    let cancelado = false
    ordemEntradaService.obterConfiguracao(leilaoRef)
      .then(async cfg => {
        if (cancelado) return
        if (!cfg?.filtro_bateria_id) return setOrdemAuto({ ativo: false, posicao: null })
        let posicao = null
        if (loteId) {
          const lista = await ordemEntradaService.listarOrdem(leilaoRef)
          posicao = lista.find(o => String(o.lote_id) === String(loteId))?.posicao ?? null
        }
        if (!cancelado) setOrdemAuto({ ativo: true, posicao })
      })
      .catch(() => {})
    return () => { cancelado = true }
  }, [organizadorAtivo, loteAtualLeilaoId, leilaoId, loteId])

  // Carrega leiloeiros do leilão para o dropdown no financeiro
  useEffect(() => {
    const leilaoRef = loteAtualLeilaoId || (leilaoId ? parseInt(leilaoId) : null)
    if (!organizadorAtivo?.id || !leilaoRef) return
    leiloeiroService.listarDoLeilao(organizadorAtivo.id, leilaoRef)
      .then(lista => {
        setLeileirosDoLeilaoList(lista)
        // Auto-fill leiloeiro com o primeiro da lista se ainda não definido
        if (lista.length > 0 && !dadosFinanceiros.leiloeiro_id) {
          setDadosFinanceiros(prev => ({ ...prev, leiloeiro_id: lista[0].leiloeiro_id }))
        }
      })
      .catch(() => {})
  }, [organizadorAtivo, loteAtualLeilaoId, leilaoId])

  // Lê location.state (LotesLista) ou query params (MapaCurral) para abrir direto no Financeiro
  useEffect(() => {
    if (loading || !isEditMode) return;

    // Via location.state (LotesLista navigate)
    const stepState              = location.state?.step;
    const valorState             = location.state?.valorVendaUnidade;
    const valorTotalState        = location.state?.valorTotalPrecalculado ?? null;
    const excecaoState           = location.state?.excecaoPorCabeca || false;

    // Via query params (Mapa do Curral window.open)
    const stepParam              = searchParams.get('step') ? parseInt(searchParams.get('step')) : null;
    const valorParam             = searchParams.get('valor_venda') ? parseFloat(searchParams.get('valor_venda')) : null;
    const valorTotalParam        = searchParams.get('valor_total_precalculado') ? parseFloat(searchParams.get('valor_total_precalculado')) : null;
    const excecaoParam           = searchParams.get('excecao_por_cabeca') === '1';

    const step                   = stepState  ?? stepParam;
    const valor                  = valorState ?? valorParam;
    const valorTotalPrecalculado = valorTotalState ?? valorTotalParam;
    const excecaoPorCabeca       = excecaoState || excecaoParam;

    if (step === 4) {
      if (valorVendaStateApplied.current) return;
      valorVendaStateApplied.current = true;

      // Se é exceção por cabeça, setar flag e resetar modalidade para À Vista
      if (excecaoPorCabeca) {
        setValorVendaExcecaoPorCabeca(true);
        setDadosFinanceiros(prev => ({
          ...prev,
          modalidade_pagamento: 'A_VISTA',
          dias_prazo: '',
          primeira_parcela_tipo: 'A_VISTA',
          primeira_parcela_dias: '',
          grupos_parcelas: parcelasIguais(3)
        }));
      }

      if (valor) {
        let valorTotal;
        const qtd = parseInt(formData.qtd) || 1;
        if (valorTotalPrecalculado !== null) {
          // Valor já calculado corretamente (inclui × qtd_parcelas se aplicável)
          valorTotal = valorTotalPrecalculado;
        } else if (dadosLeilao?.regra_faturamento === 'por_parcela' && !excecaoPorCabeca && dadosLeilao?.meio_pagamento_padrao_id) {
          const meioPadrao = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
          const qtdParcelas = meioPadrao?.grupos_parcelas?.reduce((acc, g) => acc + g.quantidade * (g.peso || 1), 0) || 1;
          valorTotal = valor * qtdParcelas * qtd;
        } else {
          valorTotal = valor * qtd;
        }
        setValorVendaData(prev => ({ ...prev, valor_venda_unidade: String(valor) }));
        setDadosFinanceiros(prev => ({ ...prev, valor_total: valorTotal }));
        setValorVendaDefinido(true);
      }
      setCurrentStep(5);
      setTimeout(() => compradorInputRef.current?.focus(), 300);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [loading, dadosLeilao, meiosPagamento]);

  const carregarLote = async () => {
    try {
      setLoading(true);
      const lote = await lotesService.obterLote(organizadorAtivo.id, loteId);
      
      setFormData({
        numero_lote: lote.numero_lote || '',
        qtd: lote.qtd?.toString() || '',
        curral: lote.curral || '',
        peso: lote.peso?.toString() || '',
        valor_minimo_unidade: lote.valor_minimo_unidade?.toString() || '',
        observacoes: lote.observacoes || '',
        link_video: lote.link_video || '',
        video_url: lote.video_url || '',
        video_poster_url: lote.video_poster_url || '',
        vendedor_id: lote.vendedor_id?.toString() || '',
        fazenda_id: lote.fazenda_id?.toString() || '',
        fazenda_ficticia: lote.fazenda_ficticia || '',
        usar_fazenda_ficticia: !!lote.fazenda_ficticia,
        tipo_animal_id: lote.tipo_animal_id?.toString() || '',
        idade_id: lote.idade_id?.toString() || '',
        sexo: lote.sexo || '',
        raca_id: lote.raca_id?.toString() || '',
        qtd_crias_femeas: lote.qtd_crias_femeas || 0,
        qtd_crias_machos: lote.qtd_crias_machos || 0,
        quem_trouxe_id: lote.quem_trouxe_id?.toString() || null,
        ordem: lote.ordem?.toString() || ''
      });
      
      setLoteStatus(lote.status || 'NOVO');
      setRefugoInfo({ foi_refugado: !!lote.foi_refugado, qtd_total_refugada: lote.qtd_total_refugada || 0 });
      setGtaNotaIsento(!!lote.gta_nota_isento);
      setGtaIsento(!!lote.gta_isento || !!lote.gta_nota_isento);
      setNotaIsento(!!lote.nota_isento || !!lote.gta_nota_isento);
      setDefesaIsenta(lote.comissao_defesa_original != null);
      setLoteComissaoDefesaPct(lote.comissao_defesa != null ? Number(lote.comissao_defesa) : null);

      // Ativar flag de crias se o lote já tem crias cadastradas
      if ((lote.qtd_crias_femeas || 0) > 0 || (lote.qtd_crias_machos || 0) > 0) {
        setShowCrias(true);
      }

      // Carregar comissão custom se existir
      setComissaoCustom({
        compra: lote.comissao_compra_custom != null ? Number(lote.comissao_compra_custom) : null,
        venda: lote.comissao_venda_custom != null ? Number(lote.comissao_venda_custom) : null,
      });
      setComissaoAlteradaManualmenteFlag(!!lote.comissao_alterada_manualmente);

      // Sempre setar valor unitário se existir (independente do status)
      // MAS não sobrescrever se há valor vindo via state/params (atalho de venda)
      const hasIncomingValor = location.state?.valorVendaUnidade || searchParams.get('valor_venda');
      if (lote.valor_venda_unidade && !hasIncomingValor) {
        setValorVendaData({ valor_venda_unidade: String(lote.valor_venda_unidade) });
      }

      // Carregar dados financeiros se lote estiver faturado
      if (lote.status === 'FATURADO' && lote.valor_venda_total) {
        console.log('🔍 DEBUG - Lote faturado carregado:', lote);
        setValorVendaDefinido(true);
        setDadosFinanceiros({
          comprador_id: lote.comprador_id?.toString() || '',
          fazenda_comprador_id: lote.fazenda_comprador_id?.toString() || '',
          modalidade_pagamento: lote.modalidade_pagamento || 'A_VISTA',
          dias_prazo: lote.dados_pagamento?.dias_prazo || '',
          dias_prazo_comprador: lote.dados_pagamento?.dias_prazo_comprador || '',
          dias_prazo_vendedor: lote.dados_pagamento?.dias_prazo_vendedor || '',
          // Array real salvo no faturamento — usado no preview do cronograma em vez de
          // regerar via grupos_parcelas, que em lotes migrados de outro sistema pode ser
          // só um placeholder genérico (não reflete os pesos reais originais)
          parcelas: lote.dados_pagamento?.parcelas_calculadas || [],
          comissao_id: lote.comissao_id?.toString() || '',
          valor_total: lote.valor_venda_total || 0,
          primeira_parcela_tipo: lote.dados_pagamento?.primeira_parcela_tipo || 'A_VISTA',
          primeira_parcela_dias: lote.dados_pagamento?.primeira_parcela_dias || '',
          grupos_parcelas: flattenGrupos((lote.dados_pagamento?.grupos_parcelas || [{ quantidade: 3, peso: 1 }])
            .map(g => ({ ...g, dias: g.dias ?? lote.dados_pagamento?.intervalo_dias ?? 30 }))),
          parcelar_sobre_liquido: !!lote.dados_pagamento?.parcelar_sobre_liquido,
          desconto_tipo: lote.desconto_percentual ? 'percentual' : lote.desconto_valor ? 'valor' : '',
          desconto_percentual: lote.desconto_percentual ? String(lote.desconto_percentual) : '',
          desconto_valor: lote.desconto_valor ? String(lote.desconto_valor) : '',
          quem_vendeu_id: lote.quem_vendeu_id?.toString() || null,
          quem_vendeu_percentual: lote.quem_vendeu_percentual || null,
          leiloeiro_id: lote.leiloeiro_id || null,
          fora_do_leilao: lote.fora_do_leilao || false,
        });

        // Lote já tem comissão decidida (faturamento anterior) — impede que o
        // auto-select de comissão de sócios sobrescreva o cenário já salvo ao reabrir o lote.
        if (lote.comissao_id) {
          setComissaoAlteradaManualmente(true);
        }

        if (lote.comprador_id) {
          clientesService.getById(organizadorAtivo.id, lote.comprador_id)
            .then(c => setCompradorSelecionado(c)).catch(() => {});
          carregarFazendasComprador(lote.comprador_id, lote.fazenda_comprador_id);
        }
      }

      // Carregar vendedor e comprador por ID (sem depender da lista completa)
      if (lote.vendedor_id) {
        clientesService.getById(organizadorAtivo.id, lote.vendedor_id)
          .then(c => setVendedorSelecionado(c)).catch(() => {});
      }

      // Carregar dados financeiros se lote estiver em DEFESA
      if (lote.status === 'DEFESA' && lote.valor_venda_total) {
        setValorVendaDefinido(true);
        setDadosFinanceiros({
          comprador_id: lote.comprador_id?.toString() || '',
          fazenda_comprador_id: lote.fazenda_comprador_id?.toString() || '',
          modalidade_pagamento: lote.modalidade_pagamento || 'A_VISTA',
          dias_prazo: '',
          parcelas: [],
          comissao_id: lote.comissao_id?.toString() || '',
          valor_total: lote.valor_venda_total || 0,
          primeira_parcela_tipo: 'A_VISTA',
          primeira_parcela_dias: '',
          grupos_parcelas: []
        });
        setValorVendaData({ valor_venda_unidade: String(lote.valor_venda_unidade || (lote.valor_venda_total / (lote.qtd || 1))) });

        // Lote já tem comissão decidida (faturamento anterior) — impede que o
        // auto-select de comissão de sócios sobrescreva o cenário já salvo ao reabrir o lote.
        if (lote.comissao_id) {
          setComissaoAlteradaManualmente(true);
        }

        if (lote.comprador_id) {
          clientesService.getById(organizadorAtivo.id, lote.comprador_id)
            .then(c => setCompradorSelecionado(c)).catch(() => {});
        }
      }
      
      // Lote marcado pelo módulo Pisteiro remoto (Painel V2) — flag própria e
      // exclusiva desse fluxo, não usada por vendas manuais normais (essas
      // já podem ter valor_venda_unidade setado em EDITADO sem ser isso).
      // Mostra o valor e "Quem Vendeu" já preenchidos em vez do wizard
      // "Defina o Valor de Venda" do zero.
      if (lote.vendido_via_pisteiro_remoto && lote.status !== 'FATURADO' && lote.status !== 'DEFESA' && lote.valor_venda_unidade) {
        setValorVendaDefinido(true);
        setDadosFinanceiros((prev) => ({
          ...prev,
          valor_total: lote.valor_venda_total || prev.valor_total,
          quem_vendeu_id: lote.quem_vendeu_id?.toString() || null,
          quem_vendeu_percentual: lote.quem_vendeu_percentual || null,
        }));
        if (lote.quem_vendeu_id) setQuemVendeuTravado(true);

        if (lote.comprador_id) {
          setDadosFinanceiros((prev) => ({
            ...prev,
            comprador_id: lote.comprador_id.toString(),
            fazenda_comprador_id: lote.fazenda_comprador_id?.toString() || '',
          }));
          clientesService.getById(organizadorAtivo.id, lote.comprador_id)
            .then((c) => setCompradorSelecionado(c)).catch(() => {});
          if (lote.fazenda_comprador_id) carregarFazendasComprador(lote.comprador_id, lote.fazenda_comprador_id);
          setCompradorTravado(true);
        }
      }

      // Se faturado (ou já marcado pelo pisteiro remoto com valor/quem-vendeu
      // definidos), abrir direto no step financeiro
      if (lote.status === 'FATURADO' || lote.status === 'DEFESA' || (lote.vendido_via_pisteiro_remoto && lote.valor_venda_unidade && lote.quem_vendeu_id)) {
        setCurrentStep(5);
      }

      // Carregar data do leilão usando o leilao_id do lote
      if (lote.leilao_id) {
        setLoteAtualLeilaoId(lote.leilao_id);
        await carregarDataLeilaoById(lote.leilao_id);
      }
      
      if (lote.vendedor_id) {
        await carregarFazendas(lote.vendedor_id);
      }

      // Carregar despesas do lote para uso nos cálculos financeiros
      if (loteId && organizadorAtivo?.id) {
        try {
          const desp = await despesasService.listar(organizadorAtivo.id, loteId);
          setDespesasLote(desp || []);
        } catch (e) {
          setDespesasLote([]);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar lote:', error);
      toast.error('Erro ao carregar dados do lote');
      navigate('/lotes');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Auto-preencher campos baseado no tipo selecionado
    if (formData.tipo_animal_id) {
      const tipoSelecionado = opcoes.tiposAnimais.find(t => t.id.toString() === formData.tipo_animal_id);
      if (tipoSelecionado) {
        setFormData(prev => ({
          ...prev,
          sexo: tipoSelecionado.sexo_padrao || prev.sexo,
          // Só preenche idade se ainda estiver vazia — não sobrescreve seleção do usuário
          idade_id: prev.idade_id || tipoSelecionado.idade_padrao_id?.toString() || ''
        }));

        // Mostrar campos de crias se for "Vaca com cria"
        setShowCrias(tipoSelecionado.nome.toLowerCase().includes('cria'));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.tipo_animal_id]);

  const carregarConfiguracoesFaturamento = async () => {
    try {
      const config = await organizadoresService.getConfiguracaoFaturamento(organizadorAtivo.id);
      setConfiguracoesFaturamento(config);
    } catch (error) {
      console.error('Erro ao carregar configurações de faturamento:', error);
    }
  };

  const carregarMapasConfig = async () => {
    try {
      const cfg = await mapasService.getConfig(organizadorAtivo.id);
      setMapasConfig(cfg);
    } catch (error) {
      console.error('Erro ao carregar configurações de mapas:', error);
    }
  };

  const carregarDataLeilao = async () => {
    try {
      const leilao = await leiloesService.obterLeilao(organizadorAtivo.id, leilaoId);
      setDadosLeilao(leilao);
      if (leilao.data_leilao) {
        setDataLeilao(new Date(leilao.data_leilao));
      }
      // Pré-selecionar meio de pagamento quando regra é por_parcela
      if (leilao.regra_faturamento === 'por_parcela' && leilao.meio_pagamento_padrao_id) {
        const meioPadrao = meiosPagamento.find(m => m.id === leilao.meio_pagamento_padrao_id);
        if (meioPadrao) {
          setDadosFinanceiros(prev => ({
            ...prev,
            modalidade_pagamento: meioPadrao.tipo,
            dias_prazo: meioPadrao.dias_prazo || '',
            primeira_parcela_tipo: meioPadrao.primeira_parcela_tipo || 'A_VISTA',
            primeira_parcela_dias: meioPadrao.primeira_parcela_dias || '',
            grupos_parcelas: flattenGrupos(meioPadrao.grupos_parcelas || [{ quantidade: 3, dias: 30, peso: 1 }])
          }));
        }
      }
    } catch (error) {
      console.error('Erro ao carregar data do leilão:', error);
      setDataLeilao(new Date());
    }
  };

  const carregarDataLeilaoById = async (leilaoIdParam) => {
    try {
      const leilao = await leiloesService.obterLeilao(organizadorAtivo.id, leilaoIdParam);
      setDadosLeilao(leilao);
      if (leilao.data_leilao) {
        setDataLeilao(new Date(leilao.data_leilao));
      }
      // Pré-preencher comissão padrão do leilão se não estiver definida
      if (leilao.comissao_padrao_id) {
        setDadosFinanceiros(prev => ({
          ...prev,
          comissao_id: prev.comissao_id || leilao.comissao_padrao_id.toString()
        }));
      }
      // Pré-selecionar meio de pagamento quando regra é por_parcela
      if (leilao.regra_faturamento === 'por_parcela' && leilao.meio_pagamento_padrao_id) {
        const meioPadrao = meiosPagamento.find(m => m.id === leilao.meio_pagamento_padrao_id);
        if (meioPadrao) {
          setDadosFinanceiros(prev => ({
            ...prev,
            modalidade_pagamento: meioPadrao.tipo,
            dias_prazo: meioPadrao.dias_prazo || '',
            primeira_parcela_tipo: meioPadrao.primeira_parcela_tipo || 'A_VISTA',
            primeira_parcela_dias: meioPadrao.primeira_parcela_dias || '',
            grupos_parcelas: flattenGrupos(meioPadrao.grupos_parcelas || [{ quantidade: 3, dias: 30, peso: 1 }])
          }));
        }
      }
    } catch (error) {
      console.error('Erro ao carregar data do leilão por ID:', error);
      setDataLeilao(new Date());
    }
  };

  const carregarOpcoes = async () => {
    try {
      setLoadingOpcoes(true);
      // Crítico: tipos, idades, raças e comissões — sem clientes (carregado lazily)
      const [tiposData, idadesData, racasData, comissoesData] = await Promise.all([
        lotesService.listarTiposAnimais(organizadorAtivo.id, { apenasAtivos: !isEditMode }),
        lotesService.listarIdades(organizadorAtivo.id, { apenasAtivos: !isEditMode }),
        lotesService.listarRacas(organizadorAtivo.id, { apenasAtivos: !isEditMode }),
        comissoesService.listar(organizadorAtivo.id, { ativo: 'true' }),
      ]);

      setOpcoes(prev => ({
        ...prev,
        tiposAnimais: tiposData || [],
        idades: idadesData || [],
        racas: racasData || [],
        comissoes: Array.isArray(comissoesData?.data) ? comissoesData.data : Array.isArray(comissoesData) ? comissoesData : [],
      }));
    } catch (error) {
      console.error('Erro ao carregar opções:', error);
      toast.error('Erro ao carregar dados do formulário');
    } finally {
      setLoadingOpcoes(false);
    }
  };

  // Busca clientes com debounce — substitui o carregamento de 1000 registros
  const buscarClientes = (termo) => {
    clearTimeout(vendedorSearchRef.current);
    if (!termo || termo.length < 2) {
      setOpcoes(prev => ({ ...prev, clientes: [] }));
      return;
    }
    setLoadingClientes(true);
    vendedorSearchRef.current = setTimeout(async () => {
      try {
        const data = await clientesService.getByOrganizador(organizadorAtivo.id, 1, 20, termo);
        setOpcoes(prev => ({
          ...prev,
          clientes: Array.isArray(data) ? data : (data?.data || []),
        }));
      } catch (e) {
        console.error('Erro ao buscar clientes:', e);
      } finally {
        setLoadingClientes(false);
      }
    }, 300);
  };

  const buscarClientesComprador = (termo) => {
    clearTimeout(compradorSearchRef.current);
    if (!termo || termo.length < 2) {
      setClientesComprador([]);
      return;
    }
    setLoadingComprador(true);
    compradorSearchRef.current = setTimeout(async () => {
      try {
        const data = await clientesService.getByOrganizador(organizadorAtivo.id, 1, 20, termo);
        setClientesComprador(Array.isArray(data) ? data : (data?.data || []));
      } catch (e) {
        console.error('Erro ao buscar compradores:', e);
      } finally {
        setLoadingComprador(false);
      }
    }, 300);
  };

  const carregarFazendas = async (clienteId) => {
    try {
      const cliente = await clientesService.getById(organizadorAtivo.id, clienteId);
      const fazendas = cliente.fazendas || [];
      
      setOpcoes(prev => ({
        ...prev,
        fazendas: fazendas
      }));
      
      // Auto-selecionar fazenda apenas no modo criação, manter seleção no modo edição
      if (!isEditMode) {
        if (fazendas.length > 0) {
          const fazendaPadrao = fazendas[fazendas.length - 1]; // Última cadastrada
          setFormData(prev => ({ ...prev, fazenda_id: fazendaPadrao.id.toString() }));
        } else {
          setFormData(prev => ({ ...prev, fazenda_id: '' }));
        }
      }
      // No modo edição, manter a fazenda já selecionada (não alterar formData.fazenda_id)
    } catch (error) {
      console.error('Erro ao carregar fazendas:', error);
      setOpcoes(prev => ({ ...prev, fazendas: [] }));
      // Não limpar fazenda_id no modo edição para manter valor original
      if (!isEditMode) {
        setFormData(prev => ({ ...prev, fazenda_id: '' }));
      }
    }
  };

  const carregarFazendasComprador = async (clienteId, manterFazendaId = null) => {
    try {
      const cliente = await clientesService.getById(organizadorAtivo.id, clienteId);
      const fazendas = cliente.fazendas || [];
      setFazendasComprador(fazendas);

      // Se veio um ID pra manter (ex: reabrindo lote já faturado), preserva a fazenda
      // já salva em vez de sobrescrever com a "padrão" (última cadastrada) do cliente.
      if (manterFazendaId) {
        setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: manterFazendaId.toString() }));
      } else if (fazendas.length > 0) {
        const fazendaPadrao = fazendas[fazendas.length - 1];
        setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: fazendaPadrao.id.toString() }));
      } else {
        setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: '' }));
      }
    } catch (error) {
      console.error('Erro ao carregar fazendas do comprador:', error);
      setFazendasComprador([]);
      if (!manterFazendaId) {
        setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: '' }));
      }
    }
  };

  const calcularComissaoAutomatica = (vendedorId, compradorId, comissaoId) => {
    if (!vendedorId || !compradorId || !comissaoId) return null;

    const vendedor = vendedorSelecionado?.id?.toString() === vendedorId ? vendedorSelecionado : null;
    const comprador = compradorSelecionado?.id?.toString() === compradorId ? compradorSelecionado : null;
    const comissao = comissoesQtd?.find(c => c.id.toString() === comissaoId);

    if (!vendedor || !comprador || !comissao) return comissao;

    let comissaoCalculada = { ...comissao };

    // 1. Comissão individual por cliente tem prioridade máxima — cada lado (venda/compra)
    // tem sua própria opção de ignorar, independente do outro lado.
    const ccIndividual = comprador.comissao_compra_pct != null ? Number(comprador.comissao_compra_pct) : null;
    const cvIndividual = vendedor.comissao_venda_pct   != null ? Number(vendedor.comissao_venda_pct)   : null;

    let cc = ignorarIndividualCompra ? null : ccIndividual;
    let cv = ignorarIndividualVenda  ? null : cvIndividual;

    // 2. Cenário sócio pro lado que não tem % individual em uso (somente se habilitado
    // e comissão for do tipo 'socios'). Calculado sempre (não só quando falta individual)
    // pra podermos mostrar "Sócio (X%)" como alternativa real no seletor, em vez de
    // rotular incorretamente de "Padrão".
    const usaSocios = organizadorAtivo?.usa_comissao_socios;
    let ccSocio = null, cvSocio = null, cdSocio = null, cenarioSocio = null;
    if (usaSocios && comissao.tipo_comissao === 'socios') {
      const vendedorSocio = vendedor.is_socio;
      const compradorSocio = comprador.is_socio;

      if (vendedorSocio && compradorSocio) {
        ccSocio = comissao.ambos_socios_comprador;
        cvSocio = comissao.ambos_socios_vendedor;
        cdSocio = comissao.ambos_socios_defesa;
        cenarioSocio = 'Ambos Sócios';
      } else if (!vendedorSocio && compradorSocio) {
        ccSocio = comissao.comprador_socio_comprador;
        cvSocio = comissao.comprador_socio_vendedor;
        cdSocio = comissao.comprador_socio_defesa;
        cenarioSocio = 'Só Comprador Sócio';
      } else if (vendedorSocio && !compradorSocio) {
        ccSocio = comissao.vendedor_socio_comprador;
        cvSocio = comissao.vendedor_socio_vendedor;
        cdSocio = comissao.vendedor_socio_defesa;
        cenarioSocio = 'Só Vendedor Sócio';
      } else {
        cenarioSocio = 'Nenhum Sócio';
      }
    }
    if (cc == null && ccSocio != null) cc = ccSocio;
    if (cv == null && cvSocio != null) cv = cvSocio;

    // Indicadores de origem para o preview
    if (ccIndividual != null) comissaoCalculada.cenario_compra_individual = true;
    if (cvIndividual != null) comissaoCalculada.cenario_venda_individual = true;
    // Alternativa real de cada lado (o que seria usado se o individual fosse ignorado) —
    // é o cenário de sócio quando existe, senão o padrão puro da tabela.
    comissaoCalculada.alternativa_compra_pct = ccSocio ?? comissao.comissao_compra;
    comissaoCalculada.alternativa_venda_pct  = cvSocio ?? comissao.comissao_venda;
    // Rótulo curto pro botão (cabe sem cortar) + detalhe completo pra confirmação/tooltip.
    // "Sócio" só no rótulo de quem É sócio. Dentro de uma tabela do tipo sócios, quem
    // não é sócio é só "Não Sócio" — nada de explicar o motivo no rótulo. "Padrão" fica
    // reservado pra quando a tabela nem é do tipo sócios (conceito não se aplica).
    comissaoCalculada.alternativa_compra_label =
      cenarioSocio === 'Ambos Sócios' ? 'Ambos sócios' :
      cenarioSocio === 'Só Comprador Sócio' ? 'Sócio' :
      cenarioSocio ? 'Não Sócio' : 'Padrão';
    comissaoCalculada.alternativa_venda_label =
      cenarioSocio === 'Ambos Sócios' ? 'Ambos sócios' :
      cenarioSocio === 'Só Vendedor Sócio' ? 'Sócio' :
      cenarioSocio ? 'Não Sócio' : 'Padrão';
    comissaoCalculada.alternativa_compra_detalhe = cenarioSocio === 'Só Vendedor Sócio'
      ? 'Vendedor é sócio (comprador não é)'
      : ccSocio != null ? `Sócio (${cenarioSocio})` : 'Padrão da tabela';
    comissaoCalculada.alternativa_venda_detalhe = cenarioSocio === 'Só Comprador Sócio'
      ? 'Comprador é sócio (vendedor não é)'
      : cvSocio != null ? `Sócio (${cenarioSocio})` : 'Padrão da tabela';

    // 3. Fallback para valores padrão da comissão
    comissaoCalculada.comissao_compra = cc ?? comissao.comissao_compra;
    comissaoCalculada.comissao_venda  = cv ?? comissao.comissao_venda;
    // Defesa: comprador == vendedor, então o cenário de sócio (quando existe) é o mesmo
    // dos dois lados — não há "cc"/"cv" individual pro lado de defesa, só o da tabela.
    comissaoCalculada.comissao_defesa = cdSocio ?? comissao.comissao_defesa;
    comissaoCalculada.cenario = cenarioSocio;

    return comissaoCalculada;
  };

  // Um percentual congelado (comissao_compra_custom/comissao_venda_custom) só é
  // realmente "alterado" se divergir do que a hierarquia calcularia hoje (individual >
  // sócio > padrão) para o cenário selecionado. Como o faturamento sempre congela o
  // percentual efetivamente usado, custom != null sozinho não significa edição manual.
  const comissaoDivergente = (customVal, calculadaVal) => {
    if (customVal == null) return false;
    if (calculadaVal == null) return true;
    return Math.abs(Number(customVal) - Number(calculadaVal)) > 0.005;
  };

  // Quando o congelado diverge do cálculo atual, a causa pode ser: (a) o cadastro do
  // cliente foi alterado depois do faturamento; ou (b) alguém editou manualmente o lote
  // (ex: "Alterar Com." nos mapas/faturas). O backend grava isso explicitamente em
  // lote.comissao_alterada_manualmente (comissaoAlteradaManualmenteFlag) — usamos essa
  // flag como fonte de verdade. Para lotes editados antes dessa flag existir, cai numa
  // heurística: se o cliente não tem percentual individual cadastrado, a divergência só
  // pode ter vindo de uma edição manual, já que não há cadastro que a explique.
  const origemDivergencia = (customVal, calculadaVal, individualVal) => {
    if (!comissaoDivergente(customVal, calculadaVal)) return null;
    if (comissaoAlteradaManualmenteFlag) return 'manual';
    return individualVal != null ? 'cadastro' : 'manual';
  };

  // Limiar de diferença relativa acima do qual trocar pra fora do individual pede
  // confirmação — evita clique acidental que passa despercebido, sem travar quem
  // realmente quer trocar de propósito (diferenças pequenas trocam direto).
  const LIMIAR_CONFIRMACAO_TROCA = 0.20;

  // Troca de comissão num lado — nos dois sentidos (individual → alternativa E
  // alternativa → individual). pctAtual é o que tá valendo agora, pctDestino o que vai
  // passar a valer se confirmar; destino é o valor que ignorando assume na troca.
  const escolherComissaoLado = (lado, pctAtual, pctDestino, labelDestino, destino, setIgnorando) => {
    const diffRelativa = pctAtual > 0 ? Math.abs(pctAtual - pctDestino) / pctAtual : (pctDestino > 0 ? 1 : 0);
    if (diffRelativa > LIMIAR_CONFIRMACAO_TROCA) {
      setConfirmacaoTroca({ lado, pctAtual, pctNovo: pctDestino, label: labelDestino, destino, setIgnorando });
    } else {
      setIgnorando(destino);
    }
  };

  const CORES_CARTAO_COMISSAO = {
    yellow: { border: 'border-yellow-400', bg: 'bg-yellow-50', text: 'text-yellow-800' },
    amber:  { border: 'border-amber-500',  bg: 'bg-amber-50',  text: 'text-amber-700' },
    blue:   { border: 'border-blue-300',   bg: 'bg-blue-50',   text: 'text-blue-700' },
  };

  // Um cartão de opção de comissão (Individual, Sócio/Padrão, congelada ou informativa).
  // Cinza de verdade quando não selecionado — nada de texto colorido "quase selecionado",
  // que confunde o que tá realmente valendo pro lote.
  const renderCartaoComissao = (card) => {
    const cor = CORES_CARTAO_COMISSAO[card.cor];
    const selecionado = card.selecionado;
    return (
      <button
        key={card.key}
        type="button"
        disabled={!card.onClick}
        onClick={card.onClick || undefined}
        className={`min-h-[72px] p-2 rounded border flex flex-col items-center justify-center text-center transition-colors ${
          selecionado ? `${cor.border} ${cor.bg}` : 'border-gray-200 bg-white hover:bg-gray-50'
        } ${card.onClick ? '' : 'cursor-default'}`}
      >
        <div className={`text-[10px] font-semibold ${selecionado ? cor.text : 'text-gray-400'}`}>{card.grupo}</div>
        <div className={`text-[10px] ${selecionado ? cor.text : 'text-gray-400'}`}>{card.tipo}</div>
        <div className={`text-base font-bold ${selecionado ? cor.text : 'text-gray-500'}`}>{card.pct.toFixed(2)}%</div>
      </button>
    );
  };

  // Cartões de opção de comissão de um lado (compra ou venda). Cada lado decide de
  // forma independente entre o percentual individual do cliente e a alternativa real
  // (sócio, se aplicável, senão o padrão da tabela) — ver cenários A-E do desenho de UX.
  const getCartoesLado = (lado, isDisabled) => {
    if (!comissaoCalculada) return [];
    const isCompra = lado === 'compra';
    const grupo = isCompra ? 'Comprador' : 'Vendedor';
    const cliente = isCompra ? compradorSelecionado : vendedorSelecionado;
    const individualPctRaw = cliente ? (isCompra ? cliente.comissao_compra_pct : cliente.comissao_venda_pct) : null;
    const individualExiste = individualPctRaw != null;
    const individualPct = individualExiste ? Number(individualPctRaw) : null;
    const alternativaPct = Number(isCompra ? comissaoCalculada.alternativa_compra_pct : comissaoCalculada.alternativa_venda_pct);
    const alternativaLabel = isCompra ? comissaoCalculada.alternativa_compra_label : comissaoCalculada.alternativa_venda_label;
    const alternativaDetalhe = isCompra ? comissaoCalculada.alternativa_compra_detalhe : comissaoCalculada.alternativa_venda_detalhe;
    const ignorando = isCompra ? ignorarIndividualCompra : ignorarIndividualVenda;
    const setIgnorando = isCompra ? setIgnorarIndividualCompra : setIgnorarIndividualVenda;
    const custom = isCompra ? comissaoCustom.compra : comissaoCustom.venda;
    const calculadaPct = isCompra ? comissaoCalculada.comissao_compra : comissaoCalculada.comissao_venda;

    // Cenário com percentual pré-congelado manualmente (via "Alterar Com." antes do
    // faturamento) — esse valor sempre vence, a escolha individual/padrão nem se aplica.
    if (custom != null) {
      const origem = origemDivergencia(custom, calculadaPct, individualPctRaw);
      // Se o valor congelado bate com o individual cadastrado, mostra "Individual" (foi
      // isso que foi usado no faturamento) em vez do genérico "Congelada" — só diverge
      // quando o congelado não corresponde a nada que explique o percentual hoje.
      const bateComIndividual = individualExiste && Math.abs(custom - individualPct) < 0.005;
      const tipo = origem === 'manual' ? '✏️ Manual' : bateComIndividual ? '🔒 Individual' : '🔒 Congelada';
      return [{
        key: `${lado}-custom`, grupo, tipo,
        pct: custom, selecionado: true, cor: bateComIndividual ? 'yellow' : 'amber', onClick: null,
      }];
    }

    // Sem comissão individual cadastrada — nada pra escolher, só informa (cenários B/D).
    if (!individualExiste) {
      return [{
        key: `${lado}-unico`, grupo, tipo: alternativaLabel,
        pct: Number(calculadaPct), selecionado: true, cor: 'blue', onClick: null,
      }];
    }

    // Individual cadastrado — duas opções reais, uma delas sempre selecionada
    // (cenários A/C). "Sócio" em vez de "Padrão" quando for o caso, pra não rotular
    // errado o que o sistema vai efetivamente aplicar — detalhe completo do cenário
    // (ex: "Sócio (Só Vendedor Sócio)") fica na confirmação de troca, não no cartão.
    return [
      {
        key: `${lado}-individual`, grupo, tipo: 'Individual',
        pct: individualPct, selecionado: !ignorando, cor: 'yellow',
        onClick: (isDisabled || forcarComissaoLeilao || !ignorando) ? null : () => escolherComissaoLado(lado, alternativaPct, individualPct, 'Individual', false, setIgnorando),
      },
      {
        key: `${lado}-alternativa`, grupo, tipo: alternativaLabel,
        pct: alternativaPct, selecionado: ignorando, cor: 'amber',
        onClick: (isDisabled || forcarComissaoLeilao || ignorando) ? null : () => escolherComissaoLado(lado, individualPct, alternativaPct, alternativaDetalhe, true, setIgnorando),
      },
    ];
  };

  const valorLadoComissao = (lado) => {
    if (!comissaoCalculada) return 0;
    const isCompra = lado === 'compra';
    const custom = isCompra ? comissaoCustom.compra : comissaoCustom.venda;
    const calculadaPct = isCompra ? comissaoCalculada.comissao_compra : comissaoCalculada.comissao_venda;
    const pctExibido = custom != null ? custom : calculadaPct;
    return (dadosFinanceiros.valor_total * pctExibido) / 100;
  };

  useEffect(() => {
    // Auto-selecionar comissão de sócios quando vendedor ou comprador são sócios
    if (dadosFinanceiros.comprador_id && formData.vendedor_id && opcoes.comissoes) {
      const vendedor = vendedorSelecionado;
      const comprador = compradorSelecionado?.id?.toString() === dadosFinanceiros.comprador_id ? compradorSelecionado : null;
      
      if (vendedor && comprador && (vendedor.is_socio || comprador.is_socio) && !comissaoAlteradaManualmente && organizadorAtivo?.usa_comissao_socios && !forcarComissaoLeilao) {
        // Buscar comissão do tipo 'socios'
        const comissaoSocios = opcoes.comissoes.find(c => c.tipo_comissao === 'socios');
        if (comissaoSocios && dadosFinanceiros.comissao_id !== comissaoSocios.id.toString()) {
          console.log('Auto-selecionando comissão de sócios:', comissaoSocios.nome);
          setDadosFinanceiros(prev => ({ ...prev, comissao_id: comissaoSocios.id.toString() }));
          setComissaoSelecionada(comissaoSocios);
        }
      }
    }
    
    // Calcular comissão
    if (dadosFinanceiros.comprador_id && formData.vendedor_id && dadosFinanceiros.comissao_id && opcoes.comissoes) {
      const comissaoCalc = calcularComissaoAutomatica(
        formData.vendedor_id,
        dadosFinanceiros.comprador_id,
        dadosFinanceiros.comissao_id
      );
      setComissaoCalculada(comissaoCalc);
    } else {
      setComissaoCalculada(null);
    }
  }, [dadosFinanceiros.comprador_id, formData.vendedor_id, dadosFinanceiros.comissao_id, vendedorSelecionado, compradorSelecionado, opcoes.comissoes, comissoesQtd, ignorarIndividualVenda, ignorarIndividualCompra]);

  const verificarNumeroLote = async (numeroLote) => {
    if (!numeroLote.trim() || !leilaoId) return;
    
    try {
      const lotes = await lotesService.listarLotesPorLeilao(organizadorAtivo.id, leilaoId);
      const existe = lotes.some(lote => lote.numero_lote === numeroLote.trim());
      
      if (existe) {
        setNumeroLoteError('Já existe um lote com este número neste leilão');
        toast.error('Já existe um lote com este número neste leilão');
      } else {
        setNumeroLoteError('');
      }
    } catch (error) {
      console.error('Erro ao verificar número do lote:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let maskedValue = value;

    // Aplicar máscaras
    if (name === 'valor_minimo_unidade') {
      maskedValue = value.replace(/\D/g, '').replace(/(\d{2})$/, ',$1');
    } else if (name === 'peso') {
      // Aceita números, vírgula e ponto como separadores decimais
      maskedValue = value.replace(/[^\d,.]/g, '');
      // Se tem vírgula, substitui por ponto para padronizar
      if (maskedValue.includes(',')) {
        maskedValue = maskedValue.replace(',', '.');
      }
    }

    setFormData(prev => ({ ...prev, [name]: maskedValue }));
    
    // Marcar como alterado no modo edição
    if (isEditMode) {
      setDadosAlterados(true);
    }

    // Verificar número do lote quando sair do campo
    if (name === 'numero_lote') {
      setNumeroLoteError('');
    }

    // Carregar fazendas quando vendedor for selecionado
    if (name === 'vendedor_id' && value) {
      carregarFazendas(value);
    }
  };

  // Recalcular peso médio quando quantidade muda no modo peso total
  useEffect(() => {
    if (pesoTotalMode && pesoTotalValue) {
      const qtd = parseInt(formData.qtd) || 0;
      const total = parseFloat(pesoTotalValue) || 0;
      if (qtd > 0 && total > 0) {
        const medio = (total / qtd).toFixed(2);
        setFormData(prev => ({ ...prev, peso: medio }));
      }
    }
  }, [formData.qtd, pesoTotalMode, pesoTotalValue]);

  // Auto-focus first field when step changes
  useEffect(() => {
    const firstFields = { 0: 'numero_lote', 1: 'tipo_animal_id', 2: 'vendedor_search', 3: 'observacoes' };
    const field = firstFields[currentStep];
    if (field) {
      setTimeout(() => inputRefs.current[field]?.focus(), 80);
    }
  }, [currentStep]);

  // Auto-criar item quando texto digitado não existe na lista
  const autoCreateItem = async (stateKey, idField, searchText) => {
    if (!searchText || !searchText.trim()) return;
    const nome = searchText.trim();
    
    try {
      let novoItem;
      if (stateKey === 'tipo') {
        // Verificar se já existe (case insensitive)
        const existe = opcoes.tiposAnimais.find(t => t.nome.toLowerCase() === nome.toLowerCase());
        if (existe) {
          handleInputChange({ target: { name: idField, value: existe.id.toString() } });
          return;
        }
        novoItem = await lotesService.criarTipoAnimal(organizadorAtivo.id, { nome });
        setOpcoes(prev => ({ ...prev, tiposAnimais: [...prev.tiposAnimais, novoItem] }));
      } else if (stateKey === 'raca') {
        const existe = opcoes.racas.find(r => r.nome.toLowerCase() === nome.toLowerCase());
        if (existe) {
          handleInputChange({ target: { name: idField, value: existe.id.toString() } });
          return;
        }
        novoItem = await lotesService.criarRaca(organizadorAtivo.id, { nome });
        setOpcoes(prev => ({ ...prev, racas: [...prev.racas, novoItem] }));
      } else if (stateKey === 'idade') {
        const existe = opcoes.idades.find(i => i.nome.toLowerCase() === nome.toLowerCase());
        if (existe) {
          handleInputChange({ target: { name: idField, value: existe.id.toString() } });
          return;
        }
        novoItem = await lotesService.criarIdade(organizadorAtivo.id, { nome });
        setOpcoes(prev => ({ ...prev, idades: [...prev.idades, novoItem] }));
      }
      if (novoItem) {
        handleInputChange({ target: { name: idField, value: novoItem.id.toString() } });
      }
    } catch (error) {
      console.error(`Erro ao criar ${stateKey}:`, error);
    }
  };

  // Enter in a search dropdown selects the first visible item, then moves focus
  const handleSearchKeyDown = (e, stateKey, opcoesList, filterField, idField, nextField) => {
    if (e.key !== 'Enter' && e.key !== 'Tab') return;
    e.preventDefault();
    const state = searchStates[stateKey];
    const searchText = state.search || '';
    const filtered = opcoesList.filter(o =>
      contem(o.nome, searchText.toLowerCase())
    );
    if (filtered.length > 0) {
      // Se tem match exato, seleciona
      const exactMatch = filtered.find(o => o.nome.toLowerCase() === searchText.toLowerCase());
      const selected = exactMatch || filtered[0];
      handleInputChange({ target: { name: idField, value: selected.id.toString() } });
      // Se for vendedor, também atualiza o vendedorSelecionado
      if (stateKey === 'vendedor') {
        setVendedorSelecionado(selected);
      }
      setSearchStates(prev => ({ ...prev, [stateKey]: { show: false, search: '' } }));
    } else if (searchText.trim() && stateKey !== 'vendedor' && stateKey !== 'tipo') {
      // Texto digitado não existe — criar automaticamente (exceto vendedor e tipo)
      autoCreateItem(stateKey, idField, searchText);
      setSearchStates(prev => ({ ...prev, [stateKey]: { show: false, search: '' } }));
    }
    if (nextField && inputRefs.current[nextField]) {
      setTimeout(() => inputRefs.current[nextField]?.focus(), 50);
    }
  };

  const handleKeyDown = (e, nextField) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault();
      if (nextField && inputRefs.current[nextField]) {
        inputRefs.current[nextField].focus();
      } else if (e.key === 'Enter') {
        nextStep();
      }
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCompletedSteps(prev => new Set([...prev, currentStep]));
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const goToStep = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  const isStepValid = (stepIndex) => {
    switch (stepIndex) {
      case 0: return formData.numero_lote && formData.qtd;
      case 1: return formData.tipo_animal_id && formData.idade_id && formData.sexo;
      case 2: return formData.vendedor_id;
      case 3: return true;
      default: return false;
    }
  };

  // Gera próximo número para lote duplicado: "001" → "001A", "001A" → "001B", "001Z" → "001AA"
  const gerarNumeroLoteDuplicado = (numero) => {
    if (!numero) return numero;
    const trimmed = numero.trim();
    const match = trimmed.match(/^([\s\S]*?)([A-Za-z]*)$/);
    const base = match[1];
    const suffix = match[2].toUpperCase();
    if (!suffix) return base + 'A';
    const lastChar = suffix[suffix.length - 1];
    if (lastChar === 'Z') return base + suffix + 'A';
    return base + suffix.slice(0, -1) + String.fromCharCode(lastChar.charCodeAt(0) + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar leilaoId apenas no modo criação
    if (!isEditMode && !leilaoId) {
      toast.error('ID do leilão não encontrado');
      return;
    }

    // Validar campos obrigatórios
    const errors = [];
    if (!formData.numero_lote.trim()) errors.push('Número do lote');
    if (!formData.qtd) errors.push('Quantidade');
    if (!formData.tipo_animal_id) errors.push('Tipo de animal');
    if (!formData.idade_id) errors.push('Idade');
    if (!formData.sexo) errors.push('Sexo');
    if (!formData.vendedor_id) errors.push('Vendedor');
    
    if (errors.length > 0) {
      toast.error(`Campos obrigatórios: ${errors.join(', ')}`);
      return;
    }

    setSaving(true);
    try {
      const loteData = {
        numero_lote: formData.numero_lote.trim(),
        qtd: parseInt(formData.qtd),
        curral: formData.curral || null,
        peso: formData.peso ? parseFloat(formData.peso.replace(',', '.')) : null,
        valor_minimo_unidade: formData.valor_minimo_unidade ? parseFloat(formData.valor_minimo_unidade.replace(',', '.')) : null,
        observacoes: formData.observacoes || null,
        link_video: formData.link_video || null,
        video_pending_key: formData.video_pending_key || null,
        poster_pending_key: formData.poster_pending_key || null,
        leilao_id: loteAtualLeilaoId || parseInt(leilaoId),
        vendedor_id: parseInt(formData.vendedor_id),
        fazenda_id: formData.fazenda_id ? parseInt(formData.fazenda_id) : null,
        fazenda_ficticia: formData.usar_fazenda_ficticia ? (formData.fazenda_ficticia || null) : null,
        tipo_animal_id: parseInt(formData.tipo_animal_id),
        idade_id: parseInt(formData.idade_id),
        sexo: formData.sexo,
        raca_id: formData.raca_id ? parseInt(formData.raca_id) : null,
        qtd_crias_femeas: showCrias ? parseInt(formData.qtd_crias_femeas) || 0 : 0,
        qtd_crias_machos: showCrias ? parseInt(formData.qtd_crias_machos) || 0 : 0,
        quem_trouxe_id: formData.quem_trouxe_id ? parseInt(formData.quem_trouxe_id) : null,
        // Com filtro automático a posição é gerida pela ordem de entrada: não enviar para não reposicionar o lote
        ...(ordemAuto.ativo ? {} : { ordem: formData.ordem ? parseInt(formData.ordem) : null })
      };

      console.log('Dados do lote:', loteData);
      
      if (isEditMode) {
        // Atualizar lote existente
        await lotesService.atualizarLote(organizadorAtivo.id, loteId, loteData);
        toast.success(`Lote ${formData.numero_lote} atualizado com sucesso!`);
        setDadosAlterados(false);
        localStorage.setItem('rematei-lote-updated', Date.now().toString());

        if (duplicar) {
          const novoNumero = gerarNumeroLoteDuplicado(formData.numero_lote);
          const duplicaData = { ...loteData, numero_lote: novoNumero };
          const novoLote = await lotesService.criarLote(organizadorAtivo.id, duplicaData);
          toast.success(`Cópia criada como Lote ${novoNumero} — abrindo para edição`);
          setDuplicar(false);
          navigate(`/lotes/editar/${novoLote.id}`);
        }
      } else {
        // Criar novo lote
        loteData.leilao_id = parseInt(leilaoId);
        await lotesService.criarLote(organizadorAtivo.id, loteData);
        toast.success(`Lote ${formData.numero_lote} cadastrado com sucesso!`);
        localStorage.setItem('rematei-lote-updated', Date.now().toString());

        if (duplicar) {
          // Mantém todos os dados, só atualiza o número para o próximo
          // Limpa peso pois cada lote tem peso diferente
          const novoNumero = gerarNumeroLoteDuplicado(formData.numero_lote);
          setFormData(prev => ({
            ...prev, numero_lote: novoNumero, peso: '',
            // Vídeo é específico de cada lote físico — não duplica pro próximo
            video_url: '', video_poster_url: '', video_pending_key: '', poster_pending_key: '',
          }));
          setPesoTotalValue('');
          setCurrentStep(0);
          setCompletedSteps(new Set());
          setNumeroLoteError(''); setQtdError('');
          toast.success(`Formulário pré-preenchido como Lote ${novoNumero} — revise e salve`);
          setTimeout(() => {
            if (inputRefs.current['numero_lote']) inputRefs.current['numero_lote'].focus();
          }, 100);
        } else {
          // Limpar formulário para próximo cadastro
          setFormData({
            numero_lote: '',
            qtd: '',
            curral: '',
            peso: '',
            valor_minimo_unidade: '',
            observacoes: '',
            link_video: '',
            video_url: '',
            video_poster_url: '',
            video_pending_key: '',
            poster_pending_key: '',
            vendedor_id: '',
            fazenda_id: '',
            tipo_animal_id: '',
            idade_id: '',
            sexo: '',
            raca_id: '',
            qtd_crias_femeas: 0,
            qtd_crias_machos: 0,
            ordem: ''
          });
          setPesoTotalValue('');
          setCurrentStep(0);
          setCompletedSteps(new Set());
          setNumeroLoteError('');
          setTimeout(() => {
            if (inputRefs.current['numero_lote']) inputRefs.current['numero_lote'].focus();
          }, 100);
        }
      }
    } catch (error) {
      console.error('Erro ao criar lote:', error);
      const detail = error.response?.data?.detail;
      const errorMessage = Array.isArray(detail)
        ? detail.map(e => e.msg).join(', ')
        : (typeof detail === 'string' ? detail : 'Erro ao criar lote');
      toast.error(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    // Só bloqueia no modo edição enquanto o lote está carregando
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const renderStepContent = () => {
    const isDisabled = !podeEditar();
    
    switch (currentStep) {
      case 0:
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <Hash size={16} className="text-blue-500" />
                  Número do Lote *
                </label>
                <input
                  ref={el => inputRefs.current['numero_lote'] = el}
                  type="text"
                  name="numero_lote"
                  value={formData.numero_lote}
                  onChange={handleInputChange}
                  onBlur={(e) => verificarNumeroLote(e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, 'qtd')}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${
                    numeroLoteError ? 'border-red-500' : 'border-gray-300'
                  } ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Ex: 001, A-001"
                  autoFocus
                  required
                  disabled={isDisabled}
                />
                {numeroLoteError && (
                  <p className="text-red-500 text-sm mt-1 flex items-center gap-1">
                    <AlertTriangle size={14} />
                    {numeroLoteError}
                  </p>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <Users size={16} className="text-green-500" />
                  Quantidade *
                </label>
                <input
                  ref={el => inputRefs.current['qtd'] = el}
                  type="number"
                  name="qtd"
                  value={formData.qtd}
                  onChange={(e) => {
                    handleInputChange(e)
                    if (e.target.value) setQtdError('')
                  }}
                  onBlur={(e) => {
                    const v = parseInt(e.target.value)
                    if (!e.target.value || isNaN(v) || v <= 0) {
                      setQtdError('Informe a quantidade de animais')
                    } else {
                      setQtdError('')
                    }
                  }}
                  onKeyDown={(e) => handleKeyDown(e, 'curral')}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${qtdError ? 'border-red-500 bg-red-50' : 'border-gray-300'} ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Ex: 10, 25"
                  min="1"
                  required
                  disabled={isDisabled}
                />
                {qtdError && (
                  <p className="text-red-500 text-sm mt-1 flex items-center gap-1">
                    <AlertTriangle size={14} />
                    {qtdError}
                  </p>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <MapPin size={16} className="text-purple-500" />
                  {labelCurral}
                </label>
                <input
                  ref={el => inputRefs.current['curral'] = el}
                  type="text"
                  name="curral"
                  value={formData.curral}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handleKeyDown(e, 'peso')}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder={`Ex: A1, ${labelCurral} 5`}
                  disabled={isDisabled}
                />
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <Scale size={16} className="text-orange-500" />
                  {pesoTotalMode ? 'Peso (kg) Total do Lote' : 'Peso (kg)'}
                  <button
                    type="button"
                    onClick={() => {
                      setPesoTotalMode(!pesoTotalMode);
                      if (!pesoTotalMode) {
                        // Entrando no modo total: limpa o valor total
                        setPesoTotalValue('');
                      } else {
                        // Saindo do modo total: limpa o peso total
                        setPesoTotalValue('');
                      }
                    }}
                    className={`ml-auto text-[11px] font-semibold px-2 py-0.5 rounded-md border transition-colors ${
                      pesoTotalMode
                        ? 'bg-orange-100 border-orange-300 text-orange-700'
                        : 'bg-gray-100 border-gray-300 text-gray-600 hover:border-orange-300 hover:text-orange-600'
                    }`}
                  >
                    {pesoTotalMode ? 'Peso Total ✓' : 'Peso Total'}
                  </button>
                </label>
                {pesoTotalMode ? (
                  <>
                    <input
                      ref={el => inputRefs.current['peso'] = el}
                      type="text"
                      value={pesoTotalValue}
                      onChange={(e) => {
                        let val = e.target.value.replace(/[^\d,.]/g, '');
                        if (val.includes(',')) val = val.replace(',', '.');
                        setPesoTotalValue(val);
                        // Calcula peso médio automaticamente
                        const qtd = parseInt(formData.qtd) || 0;
                        if (qtd > 0 && parseFloat(val) > 0) {
                          const medio = (parseFloat(val) / qtd).toFixed(2);
                          setFormData(prev => ({ ...prev, peso: medio }));
                        } else {
                          setFormData(prev => ({ ...prev, peso: '' }));
                        }
                        if (isEditMode) setDadosAlterados(true);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, 'ordem')}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      placeholder="Ex: 4500 (peso total do lote)"
                      disabled={isDisabled}
                    />
                    {formData.peso && (
                      <p className="text-xs text-orange-600 mt-1 font-medium">
                        Peso médio: {parseFloat(formData.peso).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} kg/cab
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      ref={el => inputRefs.current['peso'] = el}
                      type="text"
                      name="peso"
                      value={formData.peso}
                      onChange={handleInputChange}
                      onKeyDown={(e) => handleKeyDown(e, 'ordem')}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      placeholder="Ex: 450,5"
                      disabled={isDisabled}
                    />
                    {formData.peso && formData.qtd && parseInt(formData.qtd) > 0 && (
                      <p className="text-xs text-gray-500 mt-1">
                        Peso total do lote: {(parseFloat(formData.peso) * parseInt(formData.qtd)).toLocaleString('pt-BR', { minimumFractionDigits: 1 })} kg
                      </p>
                    )}
                  </>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <ArrowRight size={16} className="text-indigo-500" />
                  Ordem do Lote
                </label>
                {ordemAuto.ativo ? (
                  <>
                    <input
                      type="text"
                      readOnly
                      ref={el => inputRefs.current['ordem'] = el}
                      onKeyDown={(e) => handleKeyDown(e, 'valor_minimo_unidade')}
                      value={isEditMode ? (ordemAuto.posicao != null ? `${ordemAuto.posicao}º` : 'Fora da ordem') : 'Automática'}
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-100 text-gray-600 cursor-not-allowed text-lg"
                    />
                    <p className="text-xs text-gray-500 mt-1">Definida pelo filtro automático — ajuste na Ordem de Entrada</p>
                  </>
                ) : (
                  <>
                    <input
                      ref={el => inputRefs.current['ordem'] = el}
                      type="number"
                      name="ordem"
                      value={formData.ordem}
                      onChange={handleInputChange}
                      onKeyDown={(e) => handleKeyDown(e, 'valor_minimo_unidade')}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      placeholder="Auto"
                      min="1"
                      disabled={isDisabled}
                    />
                    <p className="text-xs text-gray-500 mt-1">Posição na ordem de entrada</p>
                  </>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <DollarSign size={16} className="text-green-600" />
                  Valor Mínimo (R$/unidade)
                </label>
                <input
                  ref={el => inputRefs.current['valor_minimo_unidade'] = el}
                  type="text"
                  name="valor_minimo_unidade"
                  value={formData.valor_minimo_unidade}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handleKeyDown(e, null)}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Ex: 1500,00"
                  disabled={isDisabled}
                />
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
              <div className="relative">
                <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <Zap size={16} className="text-orange-500" />
                    Tipo de Animal *
                  </div>
                  <button
                    type="button"
                    onClick={() => setQuickCreateModals(prev => ({ ...prev, tipo: true }))}
                    className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Criar novo tipo"
                    disabled={isDisabled}
                  >
                    <Plus size={16} />
                  </button>
                </label>
                <input
                  ref={el => inputRefs.current['tipo_animal_id'] = el}
                  name="tipo_animal_search"
                  autoComplete="off"
                  placeholder={loadingOpcoes ? 'Carregando...' : 'Pesquisar tipo de animal...'}
                  value={searchStates.tipo.search !== '' ? searchStates.tipo.search : opcoes.tiposAnimais.find(t => t.id.toString() === formData.tipo_animal_id)?.nome || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchStates(prev => ({ ...prev, tipo: { show: true, search: value } }));
                    // Apenas filtra — não permite valor manual
                    if (!value.trim()) {
                      handleInputChange({ target: { name: 'tipo_animal_id', value: '' } });
                    }
                  }}
                  onFocus={(e) => {
                    // Ao focar, seleciona o texto para facilitar nova busca
                    e.target.select();
                    setSearchStates(prev => ({ ...prev, tipo: { show: true, search: '' } }));
                  }}
                  onBlur={() => setTimeout(() => {
                    // Ao sair do campo, restaura o nome do tipo selecionado ou limpa
                    setFieldTouched(prev => ({ ...prev, tipo_animal_id: true }));
                    setSearchStates(prev => ({ ...prev, tipo: { show: false, search: '' } }));
                  }, 200)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === 'Tab') {
                      e.preventDefault();
                      const searchText = searchStates.tipo.search || '';
                      const filtered = opcoes.tiposAnimais.filter(t =>
                        contem(t.nome, searchText.toLowerCase())
                      );
                      if (filtered.length > 0) {
                        const exactMatch = filtered.find(t => t.nome.toLowerCase() === searchText.toLowerCase());
                        const selected = exactMatch || filtered[0];
                        handleInputChange({ target: { name: 'tipo_animal_id', value: selected.id.toString() } });
                        setFieldTouched(prev => ({ ...prev, tipo_animal_id: false }));
                        // Auto-preencher sexo e idade padrão
                        if (selected.sexo_padrao) {
                          handleInputChange({ target: { name: 'sexo', value: selected.sexo_padrao } });
                        }
                        if (selected.idade_padrao_id) {
                          handleInputChange({ target: { name: 'idade_id', value: selected.idade_padrao_id.toString() } });
                        }
                        setSearchStates(prev => ({ ...prev, tipo: { show: false, search: '' } }));
                      }
                      if (inputRefs.current['raca_search']) {
                        setTimeout(() => inputRefs.current['raca_search']?.focus(), 50);
                      }
                    }
                  }}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:border-transparent text-lg ${
                    isDisabled ? 'bg-gray-100 cursor-not-allowed border-gray-300' :
                    fieldTouched.tipo_animal_id && !formData.tipo_animal_id ? 'border-red-500 focus:ring-red-500 bg-red-50' :
                    'border-gray-300 focus:ring-blue-500'
                  }`}
                  required
                  disabled={isDisabled}
                />
                {fieldTouched.tipo_animal_id && !formData.tipo_animal_id && (
                  <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                    <AlertTriangle size={14} />
                    Selecione um tipo de animal da lista
                  </p>
                )}
                {searchStates.tipo.show && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {(() => {
                      const filtered = opcoes.tiposAnimais.filter(tipo =>
                        contem(tipo.nome, (searchStates.tipo.search || '').toLowerCase())
                      );
                      if (filtered.length === 0) {
                        return (
                          <div className="px-4 py-3 text-sm text-gray-400">
                            Nenhum tipo encontrado
                          </div>
                        );
                      }
                      return filtered.map(tipo => (
                        <div
                          key={tipo.id}
                          onClick={() => {
                            handleInputChange({ target: { name: 'tipo_animal_id', value: tipo.id.toString() } });
                            setFieldTouched(prev => ({ ...prev, tipo_animal_id: false }));
                            // Auto-preencher sexo e idade padrão
                            if (tipo.sexo_padrao) {
                              handleInputChange({ target: { name: 'sexo', value: tipo.sexo_padrao } });
                            }
                            if (tipo.idade_padrao_id) {
                              handleInputChange({ target: { name: 'idade_id', value: tipo.idade_padrao_id.toString() } });
                            }
                            setSearchStates(prev => ({ ...prev, tipo: { show: false, search: '' } }));
                            if (inputRefs.current['raca_search']) {
                              setTimeout(() => inputRefs.current['raca_search']?.focus(), 50);
                            }
                          }}
                          className={`px-4 py-2 hover:bg-blue-50 cursor-pointer text-lg ${
                            formData.tipo_animal_id === tipo.id.toString() ? 'bg-blue-50 font-medium text-blue-700' : ''
                          }`}
                        >
                          {tipo.nome}
                        </div>
                      ));
                    })()}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <Heart size={16} className="text-amber-500" />
                    Raça
                  </div>
                  <button
                    type="button"
                    onClick={() => setQuickCreateModals(prev => ({ ...prev, raca: true }))}
                    className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors"
                    title="Criar nova raça"
                  >
                    <Plus size={16} />
                  </button>
                </label>
                <input
                  ref={el => inputRefs.current['raca_search'] = el}
                  name="raca_search"
                  placeholder={loadingOpcoes ? 'Carregando...' : 'Digite para buscar raça...'}
                  value={searchStates.raca.search || opcoes.racas.find(r => r.id.toString() === formData.raca_id)?.nome || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchStates(prev => ({ ...prev, raca: { show: value.length > 0, search: value } }));
                    if (!value.trim()) {
                      handleInputChange({ target: { name: 'raca_id', value: '' } });
                    } else {
                      const raca = opcoes.racas.find(r => r.nome.toLowerCase() === value.toLowerCase());
                      if (raca) {
                        handleInputChange({ target: { name: 'raca_id', value: raca.id.toString() } });
                      }
                    }
                  }}
                  onFocus={() => setSearchStates(prev => ({ ...prev, raca: { ...prev.raca, show: true } }))}
                  onBlur={() => setTimeout(() => {
                    const searchText = searchStates.raca.search;
                    if (searchText && searchText.trim() && !formData.raca_id) {
                      autoCreateItem('raca', 'raca_id', searchText);
                    }
                    setSearchStates(prev => ({ ...prev, raca: { ...prev.raca, show: false } }));
                  }, 250)}
                  onKeyDown={(e) => handleSearchKeyDown(e, 'raca', opcoes.racas, 'raca', 'raca_id', 'sexo')}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  disabled={isDisabled}
                />
                {searchStates.raca.show && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {opcoes.racas
                      .filter(raca => contem(raca.nome, searchStates.raca.search.toLowerCase()))
                      .map(raca => (
                        <div
                          key={raca.id}
                          onClick={() => {
                            handleInputChange({ target: { name: 'raca_id', value: raca.id.toString() } });
                            setSearchStates(prev => ({ ...prev, raca: { show: false, search: '' } }));
                          }}
                          className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-lg"
                        >
                          {raca.nome}
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <Users size={16} className="text-pink-500" />
                  Sexo *
                </label>
                <select
                  ref={el => inputRefs.current['sexo'] = el}
                  name="sexo"
                  value={formData.sexo}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handleKeyDown(e, 'idade_id')}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  required
                  disabled={isDisabled}
                >
                  <option value="">Selecione o sexo...</option>
                  <option value="Macho">Macho</option>
                  <option value="Fêmea">Fêmea</option>
                  <option value="Misto">Misto</option>
                  <option value="Prendas">Prendas</option>
                </select>
              </div>

              <div className="relative">
                <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <Calendar size={16} className="text-blue-500" />
                    Idade *
                  </div>
                  <button
                    type="button"
                    onClick={() => setQuickCreateModals(prev => ({ ...prev, idade: true }))}
                    className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors"
                    title="Criar nova idade"
                  >
                    <Plus size={16} />
                  </button>
                </label>
                <input
                  ref={el => inputRefs.current['idade_search'] = el}
                  name="idade_search"
                  placeholder={loadingOpcoes ? 'Carregando...' : 'Digite para buscar idade...'}
                  value={searchStates.idade.search || opcoes.idades.find(i => i.id.toString() === formData.idade_id)?.nome || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchStates(prev => ({ ...prev, idade: { show: value.length > 0, search: value } }));
                    if (!value.trim()) {
                      handleInputChange({ target: { name: 'idade_id', value: '' } });
                    } else {
                      const idade = opcoes.idades.find(i => i.nome.toLowerCase() === value.toLowerCase());
                      if (idade) {
                        handleInputChange({ target: { name: 'idade_id', value: idade.id.toString() } });
                      }
                    }
                  }}
                  onFocus={() => setSearchStates(prev => ({ ...prev, idade: { ...prev.idade, show: true } }))}
                  onBlur={() => setTimeout(() => {
                    const searchText = searchStates.idade.search;
                    if (searchText && searchText.trim() && !formData.idade_id) {
                      autoCreateItem('idade', 'idade_id', searchText);
                    }
                    setSearchStates(prev => ({ ...prev, idade: { ...prev.idade, show: false } }));
                  }, 250)}
                  onKeyDown={(e) => handleSearchKeyDown(e, 'idade', opcoes.idades, 'idade', 'idade_id', showCrias ? 'qtd_crias_femeas' : null)}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  required
                  disabled={isDisabled}
                />
                {searchStates.idade.show && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {opcoes.idades
                      .filter(idade => contem(idade.nome, searchStates.idade.search.toLowerCase()))
                      .map(idade => (
                        <div
                          key={idade.id}
                          onClick={() => {
                            handleInputChange({ target: { name: 'idade_id', value: idade.id.toString() } });
                            setSearchStates(prev => ({ ...prev, idade: { show: false, search: '' } }));
                          }}
                          className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-lg"
                        >
                          {idade.nome}
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>

              {/* Toggle de Crias */}
              <div className="col-span-1 lg:col-span-2 flex items-center gap-3 pt-2">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={showCrias}
                    onChange={(e) => setShowCrias(e.target.checked)}
                    className="w-5 h-5 rounded border-gray-300 text-green-600 focus:ring-green-500 cursor-pointer"
                    disabled={isDisabled}
                  />
                  <span className="text-base">🐄</span>
                  <span className="text-sm font-medium text-gray-700">Com Cria</span>
                </label>
              </div>

              {showCrias && (
                <>
                  <div>
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                      <span className="text-base">🐮</span>
                      Qtd Bezerras
                    </label>
                    <input
                      ref={el => inputRefs.current['qtd_crias_femeas'] = el}
                      type="number"
                      name="qtd_crias_femeas"
                      value={formData.qtd_crias_femeas}
                      onChange={handleInputChange}
                      onKeyDown={(e) => handleKeyDown(e, 'qtd_crias_machos')}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      min="0"
                      placeholder="0"
                      disabled={isDisabled}
                    />
                  </div>

                  <div>
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                      <span className="text-base">🐂</span>
                      Qtd Bezerros
                    </label>
                    <input
                      ref={el => inputRefs.current['qtd_crias_machos'] = el}
                      type="number"
                      name="qtd_crias_machos"
                      value={formData.qtd_crias_machos}
                      onChange={handleInputChange}
                      onKeyDown={(e) => handleKeyDown(e, null)}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      min="0"
                      placeholder="0"
                      disabled={isDisabled}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        );

      case 2:
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
              <div className="relative">
                <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <User size={16} className="text-indigo-500" />
                    Vendedor *
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowNovoClienteModal(true);
                    }}
                    className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors"
                    title="Criar novo vendedor"
                  >
                    <Plus size={16} />
                  </button>
                </label>
                <input
                  ref={el => inputRefs.current['vendedor_search'] = el}
                  name="vendedor_search"
                  value={searchStates.vendedor.search || vendedorSelecionado?.nome || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchStates(prev => ({ ...prev, vendedor: { show: true, search: value } }));
                    if (!value) {
                      handleInputChange({ target: { name: 'vendedor_id', value: '' } });
                      setVendedorSelecionado(null);
                    }
                    buscarClientes(value);
                  }}
                  onFocus={(e) => {
                    setSearchStates(prev => ({ ...prev, vendedor: { ...prev.vendedor, show: true } }));
                    if (!searchStates.vendedor.search) buscarClientes(e.target.value || '');
                  }}
                  onBlur={() => setTimeout(() => setSearchStates(prev => ({ ...prev, vendedor: { ...prev.vendedor, show: false } })), 200)}
                  onKeyDown={(e) => handleSearchKeyDown(e, 'vendedor', opcoes.clientes, 'vendedor', 'vendedor_id', 'fazenda_id')}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Digite o nome do vendedor..."
                  required
                  disabled={isDisabled}
                />
                {searchStates.vendedor.show && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {loadingClientes ? (
                      <div className="px-4 py-3 text-sm text-gray-400">Buscando...</div>
                    ) : opcoes.clientes.length === 0 && searchStates.vendedor.search.length >= 2 ? (
                      <div className="px-4 py-3 text-sm text-gray-400">Nenhum cliente encontrado</div>
                    ) : opcoes.clientes.length === 0 ? (
                      <div className="px-4 py-3 text-sm text-gray-400">Digite para buscar...</div>
                    ) : (
                      opcoes.clientes.map(cliente => (
                        <div
                          key={cliente.id}
                          onClick={() => {
                            handleInputChange({ target: { name: 'vendedor_id', value: cliente.id.toString() } });
                            setVendedorSelecionado(cliente);
                            setSearchStates(prev => ({ ...prev, vendedor: { show: false, search: '' } }));
                          }}
                          className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-lg"
                        >
                          <div className="font-medium flex items-center gap-2">
                            {cliente.apelido && (
                              <span className="text-gray-500 font-normal">{cliente.apelido} ·</span>
                            )}
                            {cliente.nome}
                            <span className="text-xs font-normal text-gray-400">#{cliente.id}</span>
                            {cliente.is_socio && (
                              <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-semibold">
                                👥 SÓCIO
                              </span>
                            )}
                          </div>
                          {cliente.cpf_cnpj && (
                            <div className="text-sm text-gray-500">{cliente.cpf_cnpj}</div>
                          )}
                          {cliente.is_socio && (
                            <div className="text-xs text-blue-600">Comissão diferenciada</div>
                          )}
                          {(() => {
                            const termo = searchStates.vendedor.search.toLowerCase();
                            const fazendasMatch = (cliente.fazendas || []).filter(f =>
                              f.nome && contem(f.nome, termo)
                            );
                            if (fazendasMatch.length === 0) return null;
                            return (
                              <div className="mt-1 flex flex-wrap gap-1">
                                {fazendasMatch.map(f => (
                                  <span key={f.id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full">
                                    🏠 {f.nome}{f.cidade ? ` · ${f.cidade}` : ''}
                                  </span>
                                ))}
                              </div>
                            );
                          })()}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <MapPin size={16} className="text-green-500" />
                  Fazenda
                </label>
                {!formData.usar_fazenda_ficticia ? (
                  <>
                    <select
                      ref={el => inputRefs.current['fazenda_id'] = el}
                      name="fazenda_id"
                      value={formData.fazenda_id}
                      onChange={handleInputChange}
                      onKeyDown={(e) => handleKeyDown(e, null)}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      disabled={!formData.vendedor_id || isDisabled}
                    >
                      <option value="">Selecione a fazenda...</option>
                      {opcoes.fazendas.map(fazenda => (
                        <option key={fazenda.id} value={fazenda.id}>
                          {fazenda.nome}
                          {fazenda.id.toString() === opcoes.fazendas[opcoes.fazendas.length - 1]?.id.toString() && ' (Padrão)'}
                        </option>
                      ))}
                    </select>
                    {opcoes.fazendas.length === 0 && formData.vendedor_id && (
                      <p className="text-sm text-gray-500 mt-1">Nenhuma fazenda cadastrada para este vendedor</p>
                    )}
                    <NovaFazendaInline
                      organizadorId={organizadorAtivo?.id}
                      clienteId={formData.vendedor_id}
                      disabled={isDisabled}
                      onErro={(msg) => toast.error(msg)}
                      onCriada={(fazenda) => {
                        setOpcoes(prev => ({ ...prev, fazendas: [...(prev.fazendas || []), fazenda] }))
                        setFormData(prev => ({ ...prev, fazenda_id: fazenda.id.toString() }))
                        toast.success(`Fazenda "${fazenda.nome}" cadastrada!`)
                      }}
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    value={formData.fazenda_ficticia || ''}
                    onChange={(e) => setFormData(prev => ({ ...prev, fazenda_ficticia: e.target.value }))}
                    className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                    placeholder="Digite o nome da fazenda..."
                    disabled={isDisabled}
                  />
                )}
                <label className="flex items-center gap-2 mt-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={!!formData.usar_fazenda_ficticia}
                    onChange={(e) => {
                      const usar = e.target.checked
                      setFormData(prev => ({
                        ...prev,
                        usar_fazenda_ficticia: usar,
                        fazenda_id: usar ? '' : prev.fazenda_id,
                        fazenda_ficticia: usar ? prev.fazenda_ficticia : ''
                      }))
                    }}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    disabled={isDisabled}
                  />
                  <span className="text-sm text-gray-600">Digitar fazenda manualmente</span>
                </label>
              </div>
            </div>
            
            {/* Confirmação do vendedor selecionado */}
            {formData.vendedor_id && (
              <div className={`mt-4 p-3 border rounded-lg ${
                vendedorSelecionado?.is_socio
                  ? 'bg-blue-50 border-blue-200' 
                  : 'bg-green-50 border-green-200'
              }`}>
                <div className="flex items-center gap-2">
                  <Check size={16} className={vendedorSelecionado?.is_socio ? 'text-blue-600' : 'text-green-600'} />
                  <span className={`text-sm font-medium ${
                    vendedorSelecionado?.is_socio ? 'text-blue-800' : 'text-green-800'
                  }`}>
                    Vendedor: {vendedorSelecionado?.nome}
                    <span className="ml-1 text-xs font-normal opacity-60">#{formData.vendedor_id}</span>
                    {vendedorSelecionado?.is_socio && (
                      <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-semibold">
                        🏥 SÓCIO
                      </span>
                    )}
                  </span>
                </div>
                {vendedorSelecionado?.is_socio && (
                  <div className="text-xs text-blue-600 font-medium mt-1">
                    ✓ Comissão de sócio será aplicada
                  </div>
                )}
              </div>
            )}

            {/* Quem Captou (Módulo Pisteiros) */}
            <PisteiroSelect
              organizadorId={organizadorAtivo?.id}
              value={formData.quem_trouxe_id}
              onChange={(val) => { setFormData(prev => ({ ...prev, quem_trouxe_id: val })); if (isEditMode) setDadosAlterados(true) }}
              disabled={isDisabled}
              label="Quem Captou"
            />
          </div>
        );

      case 3:
        return (
          <div className="space-y-6">
            <div className="space-y-6">
              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <Video size={16} className="text-red-500" />
                  Link do Vídeo
                </label>
                <input
                  ref={el => inputRefs.current['link_video'] = el}
                  type="url"
                  name="link_video"
                  value={formData.link_video}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handleKeyDown(e, 'observacoes')}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="https://youtube.com/..."
                  disabled={isDisabled}
                />
              </div>

              {organizadorAtivo?.produtos_premium?.includes('upload_video_lote') && (
                (loteId || loteAtualLeilaoId || leilaoId) && (
                  <VideoUploadLote
                    organizadorId={organizadorAtivo.id}
                    leilaoId={loteAtualLeilaoId || (leilaoId ? parseInt(leilaoId) : null)}
                    loteId={loteId}
                    videoUrl={formData.video_url}
                    posterUrl={formData.video_poster_url}
                    disabled={isDisabled}
                    onChange={(patch) => setFormData(prev => ({
                      ...prev,
                      ...('video_url' in patch ? { video_url: patch.video_url || '' } : {}),
                      ...('video_poster_url' in patch ? { video_poster_url: patch.video_poster_url || '' } : {}),
                      ...('video_pending_key' in patch ? { video_pending_key: patch.video_pending_key || '' } : {}),
                      ...('poster_pending_key' in patch ? { poster_pending_key: patch.poster_pending_key || '' } : {}),
                    }))}
                  />
                )
              )}

              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <FileText size={16} className="text-gray-500" />
                  Observações
                </label>
                <textarea
                  ref={el => inputRefs.current['observacoes'] = el}
                  name="observacoes"
                  value={formData.observacoes}
                  onChange={handleInputChange}
                  rows={4}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Informações adicionais sobre o lote..."
                  disabled={isDisabled}
                />
              </div>
            </div>
          </div>
        );

      case 5: // Dados Financeiros (só no modo edição)
        // Se é DEFESA, mostra apenas o resumo simplificado
        if (loteStatus === 'DEFESA' && valorVendaDefinido) {
          const vvDef = dadosFinanceiros.valor_total || 0;
          const comissaoBaseDef = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
          const defPctVal = loteComissaoDefesaPct != null ? loteComissaoDefesaPct : calcularPctComissaoDefesa(comissaoBaseDef);
          const defValCalc = vvDef * defPctVal / 100;
          const fmtDef = (v) => Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
          return (
            <div className="space-y-6">
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-5">
                <h4 className="font-semibold text-orange-800 mb-4 text-lg">Resumo da Defesa</h4>
                {defesaIsenta && (
                  <div className="mb-3 flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
                    <span className="text-green-700 font-semibold text-sm">✓ Comissão de defesa isentada</span>
                  </div>
                )}
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-orange-700">
                  <div><strong>Quantidade:</strong> {formData.qtd} animais</div>
                  <div><strong>Valor Unitário:</strong> R$ {fmtDef(valorVendaData.valor_venda_unidade || 0)}</div>
                  <div><strong>Valor Total:</strong> R$ {fmtDef(vvDef)}</div>
                  <div><strong>Comissão Defesa ({defPctVal}%):</strong> {defesaIsenta ? <span className="line-through text-gray-400">R$ {fmtDef(defValCalc)}</span> : <>R$ {fmtDef(defValCalc)}</>}</div>
                  <div><strong>Comissão:</strong> {comissaoBaseDef?.nome || '—'}</div>
                  <div><strong>Vendedor/Comprador:</strong> {compradorSelecionado?.nome || '—'}</div>
                </div>
              </div>
            </div>
          );
        }

        return (
          <div className="space-y-6">
            {!valorVendaDefinido ? (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
                <DollarSign size={48} className="text-yellow-500 mx-auto mb-4" />
                <h3 className="text-lg font-semibold text-yellow-800 mb-2">Defina o Valor de Venda</h3>
                <p className="text-yellow-700 mb-4">
                  Para prosseguir com os dados financeiros, defina primeiro o valor de venda.
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setShowValorVendaModal(true);
                    setTimeout(() => {
                      if (valorVendaInputRef.current) {
                        valorVendaInputRef.current.focus();
                      }
                    }, 100);
                  }}
                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Definir Valor de Venda
                </button>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Comprador, Modalidade, Preview */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    {/* Campo Comprador */}
                    <div className="relative">
                      <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                        <div className="flex items-center gap-2">
                          <User size={16} className="text-purple-500" />
                          Comprador *
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setQuickCreateData(prev => ({ ...prev, grupo: 'comprador' }));
                            setShowNovoClienteModal(true);
                          }}
                          className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          title="Criar novo comprador"
                          disabled={isDisabled || compradorTravado}
                        >
                          <Plus size={16} />
                        </button>
                      </label>
                      <div className="relative">
                        <input
                          ref={compradorInputRef}
                          name="comprador_search"
                          value={searchCompradorState.search || getCompradorDisplay()}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSearchCompradorState({ show: value.length > 0, search: value });

                            if (!value.trim()) {
                              setCompradorSelecionado(null); // reseta ignorarIndividualCompra via efeito em compradorSelecionado?.id
                              setDadosFinanceiros(prev => ({ ...prev, comprador_id: '' }));
                              setFazendasComprador([]);
                              return;
                            }

                            buscarClientesComprador(value);
                          }}
                          onFocus={() => setSearchCompradorState(prev => ({ ...prev, show: true }))}
                          onBlur={() => setTimeout(() => setSearchCompradorState(prev => ({ ...prev, show: false })), 200)}
                          type="text"
                          placeholder="Digite para buscar comprador..."
                          className={`w-full px-4 py-3 pr-16 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${
                            compradorSelecionado
                              ? (compradorSelecionado.restrito_compra ? 'border-orange-500 bg-orange-50' : 'border-green-500 bg-green-50')
                              : 'border-gray-300'
                          } ${isDisabled || compradorTravado ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                          required
                          disabled={isDisabled || compradorTravado}
                        />
                        {compradorSelecionado && (
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-2">
                            {!compradorTravado && (
                              <button
                                type="button"
                                onClick={() => {
                                  setCompradorSelecionado(null);
                                  setDadosFinanceiros(prev => ({ ...prev, comprador_id: '' }));
                                  setFazendasComprador([]);
                                  setSearchCompradorState({ show: false, search: '' });
                                }}
                                className="p-1 hover:bg-red-100 rounded-full transition-colors"
                                title="Limpar seleção"
                              >
                                <X size={16} className="text-red-500" />
                              </button>
                            )}
                            <Check size={20} className="text-green-600" />
                          </div>
                        )}
                      </div>
                      {compradorSelecionado?.origem_pisteiro_remoto && (
                        <p className="text-xs text-gray-500 mt-1">
                          🚀 Cliente Rematei — comprador informado pelo pisteiro remoto{compradorTravado ? ', não pode ser alterado' : ''}.
                        </p>
                      )}

                      {searchCompradorState.show && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                          {loadingComprador ? (
                            <div className="px-4 py-3 text-sm text-gray-400">Buscando...</div>
                          ) : clientesComprador.length === 0 && searchCompradorState.search.length >= 2 ? (
                            <div className="px-4 py-3 text-sm text-gray-400">Nenhum cliente encontrado</div>
                          ) : clientesComprador.length === 0 ? (
                            <div className="px-4 py-3 text-sm text-gray-400">Digite para buscar...</div>
                          ) : (
                          clientesComprador.map(cliente => (
                              <div
                                key={cliente.id}
                                onClick={() => {
                                  if (cliente.restrito_compra) {
                                    setCompradorRestritoModal(cliente);
                                    setSearchCompradorState({ show: false, search: '' });
                                    return;
                                  }
                                  setCompradorSelecionado(cliente);
                                  setDadosFinanceiros(prev => ({
                                    ...prev,
                                    comprador_id: cliente.id.toString()
                                  }));
                                  carregarFazendasComprador(cliente.id);
                                  setSearchCompradorState({ show: false, search: '' });
                                  if (isEditMode) setDadosAlterados(true);
                                }}
                                className={`px-4 py-2 hover:bg-blue-50 cursor-pointer text-lg transition-colors ${cliente.restrito_compra ? 'bg-red-50/50' : ''}`}
                              >
                                <div className="font-medium flex items-center gap-2">
                                  {cliente.apelido && (
                                    <span className="text-gray-500 font-normal">{cliente.apelido} ·</span>
                                  )}
                                  {cliente.nome}
                                  <span className="text-xs font-normal text-gray-400">#{cliente.id}</span>
                                  {cliente.restrito_compra && (
                                    <span className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full font-semibold">
                                      ⚠️ RESTRITO
                                    </span>
                                  )}
                                  {cliente.is_socio && (
                                    <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-semibold">
                                      👥 SÓCIO
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center justify-between mt-1">
                                  {cliente.cpf_cnpj && (
                                    <div className="text-sm text-gray-500">{cliente.cpf_cnpj}</div>
                                  )}
                                  {cliente.restrito_compra && (
                                    <div className="text-xs text-red-600">{cliente.restrito_compra_motivo || 'Restrito'}</div>
                                  )}
                                  {!cliente.restrito_compra && cliente.is_socio && (
                                    <div className="text-xs text-blue-600">Comissão diferenciada</div>
                                  )}
                                </div>
                                {(() => {
                                  const termo = searchCompradorState.search.toLowerCase();
                                  const fazendasMatch = (cliente.fazendas || []).filter(f =>
                                    f.nome && contem(f.nome, termo)
                                  );
                                  if (fazendasMatch.length === 0) return null;
                                  return (
                                    <div className="mt-1 flex flex-wrap gap-1">
                                      {fazendasMatch.map(f => (
                                        <span key={f.id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full">
                                          🏠 {f.nome}{f.cidade ? ` · ${f.cidade}` : ''}
                                        </span>
                                      ))}
                                    </div>
                                  );
                                })()}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    {/* Modal de Comprador Restrito */}
                    {compradorRestritoModal && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setCompradorRestritoModal(null)} />
                        <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                          <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-5 flex items-center gap-3">
                            <div className="p-2 bg-white/20 rounded-xl">
                              <AlertTriangle className="w-5 h-5 text-white" />
                            </div>
                            <div>
                              <h2 className="text-base font-bold text-white">Comprador Restrito</h2>
                              <p className="text-red-100 text-xs">Este cliente possui restrição de compra</p>
                            </div>
                          </div>
                          <div className="p-6 space-y-4">
                            <div>
                              <p className="text-sm font-medium text-gray-900">{compradorRestritoModal.nome}</p>
                              {compradorRestritoModal.cpf_cnpj && (
                                <p className="text-xs text-gray-500">{compradorRestritoModal.cpf_cnpj}</p>
                              )}
                            </div>
                            <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                              <p className="text-sm font-semibold text-red-800 mb-1">Motivo da restrição:</p>
                              <p className="text-sm text-red-700">
                                {compradorRestritoModal.restrito_compra_motivo || 'Não informado'}
                              </p>
                            </div>
                            <div className="flex gap-3 pt-1">
                              <button
                                type="button"
                                onClick={() => setCompradorRestritoModal(null)}
                                className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 text-sm font-medium rounded-xl hover:bg-gray-50 transition-colors"
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  const cliente = compradorRestritoModal;
                                  setCompradorSelecionado(cliente);
                                  setDadosFinanceiros(prev => ({
                                    ...prev,
                                    comprador_id: cliente.id.toString()
                                  }));
                                  carregarFazendasComprador(cliente.id);
                                  if (isEditMode) setDadosAlterados(true);
                                  setCompradorRestritoModal(null);
                                }}
                                className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition-colors"
                              >
                                Assumir risco
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Campo Fazenda do Comprador */}
                    <div>
                      <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                        <MapPin size={16} className="text-green-500" />
                        Fazenda do Comprador
                      </label>
                      <select
                        value={dadosFinanceiros.fazenda_comprador_id}
                        onChange={(e) => {
                          setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: e.target.value }));
                          if (isEditMode) setDadosAlterados(true);
                        }}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled || compradorTravado ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                        disabled={!dadosFinanceiros.comprador_id || isDisabled || compradorTravado}
                      >
                        <option value="">Selecione a fazenda...</option>
                        {fazendasComprador.map(fazenda => (
                          <option key={fazenda.id} value={fazenda.id}>
                            {fazenda.nome}
                            {fazenda.id.toString() === fazendasComprador[fazendasComprador.length - 1]?.id.toString() && ' (Padrão)'}
                          </option>
                        ))}
                      </select>
                      {fazendasComprador.length === 0 && dadosFinanceiros.comprador_id && (
                        <p className="text-sm text-gray-500 mt-1">Nenhuma fazenda cadastrada para este comprador</p>
                      )}
                    </div>
                  </div>
                  
                  {/* Preview do Comprador */}
                  <div>
                    {compradorSelecionado ? (
                      <div className={`p-4 border rounded-lg ${
                        compradorSelecionado.is_socio 
                          ? 'bg-blue-50 border-blue-200' 
                          : 'bg-purple-50 border-purple-200'
                      }`}>
                        <h4 className={`text-sm font-semibold mb-3 flex items-center gap-2 ${
                          compradorSelecionado.is_socio ? 'text-blue-800' : 'text-purple-800'
                        }`}>
                          <User size={16} />
                          Preview do Comprador
                        </h4>
                        <div className="space-y-3">
                          <div className="flex items-center justify-between">
                            <span className={`font-semibold ${
                              compradorSelecionado.is_socio ? 'text-blue-800' : 'text-purple-800'
                            }`}>
                              {compradorSelecionado.nome}
                              <span className="ml-1.5 text-xs font-normal opacity-50">#{compradorSelecionado.id}</span>
                            </span>
                            {compradorSelecionado.is_socio && (
                              <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-semibold">
                                👥 SÓCIO
                              </span>
                            )}
                          </div>
                          
                          {compradorSelecionado.cpf_cnpj && (
                            <div className="flex justify-between">
                              <span className={`text-sm ${
                                compradorSelecionado.is_socio ? 'text-blue-700' : 'text-purple-700'
                              }`}>CPF/CNPJ:</span>
                              <span className={`text-sm font-medium ${
                                compradorSelecionado.is_socio ? 'text-blue-800' : 'text-purple-800'
                              }`}>{compradorSelecionado.cpf_cnpj}</span>
                            </div>
                          )}
                          
                          {compradorSelecionado.telefone && (
                            <div className="flex justify-between">
                              <span className={`text-sm ${
                                compradorSelecionado.is_socio ? 'text-blue-700' : 'text-purple-700'
                              }`}>Telefone:</span>
                              <span className={`text-sm font-medium ${
                                compradorSelecionado.is_socio ? 'text-blue-800' : 'text-purple-800'
                              }`}>{compradorSelecionado.telefone}</span>
                            </div>
                          )}
                          
                          {compradorSelecionado.cidade && (
                            <div className="flex justify-between">
                              <span className={`text-sm ${
                                compradorSelecionado.is_socio ? 'text-blue-700' : 'text-purple-700'
                              }`}>Cidade:</span>
                              <span className={`text-sm font-medium ${
                                compradorSelecionado.is_socio ? 'text-blue-800' : 'text-purple-800'
                              }`}>{compradorSelecionado.cidade}/{compradorSelecionado.estado}</span>
                            </div>
                          )}
                          
                          {compradorSelecionado.is_socio && (
                            <div className="mt-3 pt-3 border-t border-blue-200">
                              <div className="text-xs text-blue-600 font-medium">
                                ✓ Comissão de sócio será aplicada
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <div className="text-center text-gray-500">
                          <User size={24} className="mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Selecione um comprador para ver o preview</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Comissão */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
                  <div>
                    <label className="flex items-center justify-between text-sm font-medium text-gray-700 mb-2">
                      <div className="flex items-center gap-2">
                        <DollarSign size={16} className="text-blue-500" />
                        Comissão
                      </div>
                      <button
                        type="button"
                        onClick={() => setShowNovaComissaoModal(true)}
                        className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Criar nova comissão"
                        disabled={isDisabled}
                      >
                        <Plus size={16} />
                      </button>
                    </label>
                    <select
                      value={dadosFinanceiros.comissao_id}
                      onChange={(e) => {
                        setDadosFinanceiros(prev => ({ ...prev, comissao_id: e.target.value }));
                        const comissao = opcoes.comissoes?.find(c => c.id.toString() === e.target.value);
                        setComissaoSelecionada(comissao);
                        setComissaoAlteradaManualmente(true);
                        if (isEditMode) setDadosAlterados(true);
                      }}
                      className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                      disabled={isDisabled}
                    >
                      <option value="">Selecione a comissão...</option>
                      {Array.isArray(opcoes.comissoes) && opcoes.comissoes.map(comissao => (
                        <option key={comissao.id} value={comissao.id}>
                          {comissao.nome} {comissao.tipo_comissao === 'socios' && '(Sócios)'}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Preview Comissão */}
                  <div>
                    {comissaoCalculada ? (
                      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center gap-2">
                          <DollarSign size={16} />
                          Preview da Comissão
                        </h4>

                        <div className="space-y-2">
                          {/* Verificar se é defesa (mesmo cliente) ou venda (clientes diferentes) */}
                          {formData.vendedor_id === dadosFinanceiros.comprador_id ? (
                            // É DEFESA - mesmo cliente
                            <div className="grid grid-cols-1 gap-3 text-xs text-blue-700">
                              <div className="text-center p-3 bg-red-100 rounded border border-red-200">
                                <div className="font-semibold text-red-800">🛡️ DEFESA</div>
                                <div className="text-xl font-bold text-red-800">{comissaoCalculada.comissao_defesa}%</div>
                                <div className="text-sm font-medium text-red-700 mt-1">
                                  R$ {((dadosFinanceiros.valor_total * comissaoCalculada.comissao_defesa) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                </div>
                                <div className="text-xs text-red-600 mt-1">Mesmo cliente vendendo e comprando</div>
                              </div>
                            </div>
                          ) : (
                            // É VENDA - clientes diferentes. Cada lado (comprador/vendedor)
                            // tem sua própria escolha de comissão, independente do outro —
                            // todos os cartões (individual/sócio/padrão) numa fileira só,
                            // do mesmo tamanho, pra ficar óbvio o que tá selecionado.
                            (() => {
                              const cartoes = [...getCartoesLado('compra', isDisabled), ...getCartoesLado('venda', isDisabled)];
                              const cols = cartoes.length >= 4 ? 'grid-cols-4' : cartoes.length === 3 ? 'grid-cols-3' : 'grid-cols-2';
                              const fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                              return (
                                <div className="text-xs text-blue-700">
                                  <div className={`grid ${cols} gap-1.5`}>
                                    {cartoes.map(renderCartaoComissao)}
                                  </div>
                                  <div className="grid grid-cols-2 gap-3 mt-1.5 text-center">
                                    <div className="text-xs font-medium text-blue-600">Compra: R$ {fmt(valorLadoComissao('compra'))}</div>
                                    <div className="text-xs font-medium text-blue-600">Venda: R$ {fmt(valorLadoComissao('venda'))}</div>
                                  </div>
                                </div>
                              );
                            })()
                          )}
                          {confirmacaoTroca && (
                            <div className="p-3 rounded-lg border border-red-300 bg-red-50 text-xs text-red-800">
                              <div className="font-medium mb-2">
                                Trocar de <strong>{confirmacaoTroca.pctAtual.toFixed(2)}%</strong> para{' '}
                                <strong>{Number(confirmacaoTroca.pctNovo).toFixed(2)}% ({confirmacaoTroca.label})</strong> — confirma a troca?
                              </div>
                              <div className="flex gap-2">
                                <button
                                  type="button"
                                  onClick={() => setConfirmacaoTroca(null)}
                                  className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 font-medium"
                                >
                                  Cancelar
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    confirmacaoTroca.setIgnorando(confirmacaoTroca.destino);
                                    // Log fica registrado mesmo que essa escolha não seja a que
                                    // acaba valendo no faturamento final (ex: usuário troca de
                                    // novo depois) — fire-and-forget, não trava a UI se falhar.
                                    if (isEditMode && loteId && organizadorAtivo?.id) {
                                      faturamentoService.logTrocaComissao(organizadorAtivo.id, loteId, {
                                        lado: confirmacaoTroca.lado,
                                        pct_atual: confirmacaoTroca.pctAtual,
                                        pct_novo: confirmacaoTroca.pctNovo,
                                        label_novo: confirmacaoTroca.label,
                                      }).catch(() => {});
                                    }
                                    setConfirmacaoTroca(null);
                                  }}
                                  className="px-3 py-1 rounded bg-red-600 text-white font-medium"
                                >
                                  Confirmar troca
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <div className="text-center text-gray-500">
                          <DollarSign size={24} className="mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Selecione uma comissão para ver o preview</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Resumo da Venda */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <h4 className="font-semibold text-green-800 mb-3">Resumo da Venda</h4>
                  {(() => {
                    const fluxo = dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela';
                    const isSeparada = ['separada', 'comissao_separada'].includes(String(fluxo?.value || fluxo));
                    const vv = dadosFinanceiros.valor_total || 0;

                    // Usa comissaoCalculada (já considera cenário de sócios) se disponível
                    // senão cai para os valores base da comissão selecionada
                    const comissaoBase = comissoesQtd?.find(c => c.id.toString() === dadosFinanceiros.comissao_id);
                    const comissaoEfetiva = comissaoCalculada || comissaoBase;
                    // Custom override tem prioridade
                    const ccPct = comissaoCustom.compra != null ? comissaoCustom.compra : Number(comissaoEfetiva?.comissao_compra || 0);
                    const cvPct = comissaoCustom.venda != null ? comissaoCustom.venda : Number(comissaoEfetiva?.comissao_venda  || 0);
                    const ccVal = vv * ccPct / 100;
                    const cvVal = vv * cvPct / 100;
                    const totalCom = ccVal + cvVal;
                    const totalDesp = isSeparada ? 0 : despesasLote.reduce((s, d) => s + Number(d.valor || 0), 0);
                    // Valor líquido: fluxo separada = vv, outros = vv - cvVal - despesas
                    const vliq = isSeparada ? vv : vv - cvVal - totalDesp;
                    const fmt = (v) => Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                    const cenario = comissaoCalculada?.cenario;
                    const origemCompra = origemDivergencia(comissaoCustom.compra, comissaoEfetiva?.comissao_compra, compradorSelecionado?.comissao_compra_pct);
                    const origemVenda = origemDivergencia(comissaoCustom.venda, comissaoEfetiva?.comissao_venda, vendedorSelecionado?.comissao_venda_pct);
                    const temCustom = origemCompra !== null || origemVenda !== null;
                    const temManual = origemCompra === 'manual' || origemVenda === 'manual';
                    return (
                      <div className="space-y-3">
                        {temManual && (
                          <div className="text-xs font-medium text-amber-700 bg-amber-50 px-2 py-1 rounded inline-block">
                            ✏️ Comissão alterada manualmente após o faturamento
                          </div>
                        )}
                        {temCustom && !temManual && (
                          <div className="text-xs font-medium text-amber-700 bg-amber-50 px-2 py-1 rounded inline-block">
                            🔒 Comissão congelada no faturamento diverge do cadastro atual do cliente
                          </div>
                        )}
                        {cenario && !temCustom && (
                          <div className="text-xs font-medium text-blue-700 bg-blue-50 px-2 py-1 rounded inline-block">
                            Cenário: {cenario}
                          </div>
                        )}
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm text-green-700">
                          <div><strong>Quantidade:</strong> {formData.qtd} animais</div>
                          <div><strong>{dadosLeilao?.regra_faturamento === 'por_parcela' ? 'Valor por Parcela:' : 'Valor Unitário:'}</strong> R$ {fmt(valorVendaData.valor_venda_unidade || 0)}</div>
                          <div><strong>Valor de Venda:</strong> R$ {fmt(vv)}</div>
                          {dadosLeilao?.regra_faturamento === 'por_parcela' && formData.qtd > 0 && (
                            <div><strong>Valor por Animal:</strong> R$ {fmt(vv / parseInt(formData.qtd))}</div>
                          )}
                          <div><strong>Com. Compra ({ccPct}%):</strong> R$ {fmt(ccVal)}{comissaoDivergente(comissaoCustom.compra, comissaoEfetiva?.comissao_compra) ? ' 🔒' : ''}</div>
                          <div><strong>Com. Venda ({cvPct}%):</strong> R$ {fmt(cvVal)}{comissaoDivergente(comissaoCustom.venda, comissaoEfetiva?.comissao_venda) ? ' 🔒' : ''}</div>
                          <div><strong>Total Comissões:</strong> R$ {fmt(totalCom)}</div>
                          {totalDesp > 0 && (
                            <div className="text-orange-700"><strong>Despesas (1ª parcela):</strong> R$ {fmt(totalDesp)}</div>
                          )}
                          <div className="col-span-2 sm:col-span-3 pt-2 border-t border-green-200">
                            <strong className="text-green-900 text-base">
                              Valor Líquido Vendedor: R$ {fmt(vliq)}
                            </strong>
                            {isSeparada && (
                              <span className="ml-2 text-xs text-green-600">
                                (fluxo separado — vendedor paga comissão e despesas separadamente)
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                </div>

                {/* Modalidade e Forma de Pagamento */}
                <div className="space-y-6">
                  {/* Modalidade de Pagamento */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      {/* Quem Vendeu — o seletor completo (PisteiroSelect) exige o
                          módulo base quem_vendeu_trouxe (lista pisteiros reais via
                          API, que também exige esse módulo). Mas um organizador
                          pode ter só o addon Pisteiro remoto ativo, sem o módulo
                          base — nesse caso mostra a REMATEI travada em texto fixo,
                          sem depender daquela API. */}
                      {(() => {
                        const moduloBaseAtivo = organizadorAtivo?.produtos_premium?.includes('quem_vendeu_trouxe')
                        if (!moduloBaseAtivo && !quemVendeuTravado) return null
                        return (
                          <div>
                            {moduloBaseAtivo ? (
                              <PisteiroSelect
                                organizadorId={organizadorAtivo?.id}
                                value={dadosFinanceiros.quem_vendeu_id}
                                onChange={(val) => {
                                  setDadosFinanceiros(prev => ({ ...prev, quem_vendeu_id: val }));
                                  if (isEditMode) setDadosAlterados(true);
                                }}
                                disabled={isDisabled || quemVendeuTravado}
                                label="Quem Vendeu"
                              />
                            ) : (
                              <div>
                                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                  <Users size={16} className="text-purple-500" /> Quem Vendeu
                                </label>
                                <div className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-lg text-gray-700 cursor-not-allowed">
                                  REMATEI
                                </div>
                              </div>
                            )}
                            {quemVendeuTravado && (
                              <p className="text-xs text-gray-500 mt-1">
                                🚀 Definido automaticamente pelo módulo Pisteiro remoto — não pode ser alterado.
                              </p>
                            )}
                          </div>
                        )
                      })()}
                      <div>
                        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                          <DollarSign size={16} className="text-green-500" />
                          Modalidade de Pagamento
                        </label>
                        <select
                          value={dadosFinanceiros.modalidade_pagamento}
                          onChange={(e) => {
                            const value = e.target.value;
                            
                            // Verificar se é um meio de pagamento salvo
                            const meioSelecionado = meiosPagamento.find(m => m.id.toString() === value);
                            if (meioSelecionado) {
                              carregarMeioPagamento(meioSelecionado);
                              return;
                            }
                            
                            // Modalidade padrão
                            setDadosFinanceiros(prev => ({ 
                              ...prev, 
                              modalidade_pagamento: value,
                              dias_prazo: '',
                              parcelas: []
                            }));
                            if (isEditMode) setDadosAlterados(true);
                          }}
                          className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                          disabled={isDisabled}
                        >
                          <option value="">Selecione a modalidade...</option>
                          <option value="A_VISTA">À Vista</option>
                          <option value="PRAZO">Prazo (dias corridos)</option>
                          <option value="PARCELADO">Parcelado</option>
                          
                          {/* Separador e meios salvos */}
                          {meiosPagamento.length > 0 && (
                            <>
                              <option disabled>──────────────</option>
                              <option disabled>📋 Meios Salvos:</option>
                              {meiosPagamento.map(meio => (
                                <option key={meio.id} value={meio.id}>
                                  {meio.nome}
                                </option>
                              ))}
                            </>
                          )}
                        </select>
                      </div>
                      
                      {/* Campo Dias Prazo */}
                      {dadosFinanceiros.modalidade_pagamento === 'PRAZO' && !mapasConfig?.prazo_dias_diferente && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Dias para Pagamento
                          </label>
                          <input
                            type="number"
                            value={dadosFinanceiros.dias_prazo}
                            onChange={(e) => {
                              setDadosFinanceiros(prev => ({ ...prev, dias_prazo: e.target.value }));
                              if (isEditMode) setDadosAlterados(true);
                            }}
                            className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                            placeholder="Ex: 30, 60, 90..."
                            min="1"
                            disabled={isDisabled}
                          />
                        </div>
                      )}

                      {/* Campos Dias Prazo separados (comprador / vendedor) */}
                      {dadosFinanceiros.modalidade_pagamento === 'PRAZO' && mapasConfig?.prazo_dias_diferente && (
                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Prazo Comprador (dias)
                            </label>
                            <input
                              type="number"
                              value={dadosFinanceiros.dias_prazo_comprador}
                              onChange={(e) => {
                                setDadosFinanceiros(prev => ({ ...prev, dias_prazo_comprador: e.target.value }));
                                if (isEditMode) setDadosAlterados(true);
                              }}
                              className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                              placeholder="Ex: 30"
                              min="1"
                              disabled={isDisabled}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Prazo Vendedor (dias)
                            </label>
                            <input
                              type="number"
                              value={dadosFinanceiros.dias_prazo_vendedor}
                              onChange={(e) => {
                                setDadosFinanceiros(prev => ({ ...prev, dias_prazo_vendedor: e.target.value }));
                                if (isEditMode) setDadosAlterados(true);
                              }}
                              className={`w-full px-4 py-3 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                              placeholder="Ex: 60"
                              min="1"
                              disabled={isDisabled}
                            />
                          </div>
                        </div>
                      )}

                      {/* Desconto À Vista */}
                      {dadosFinanceiros.modalidade_pagamento === 'A_VISTA' && (
                        <div className="space-y-3">
                          <label className="block text-sm font-medium text-gray-700">
                            Desconto À Vista
                          </label>
                          <div className="flex items-center gap-2">
                            <select
                              value={dadosFinanceiros.desconto_tipo}
                              onChange={(e) => {
                                setDadosFinanceiros(prev => ({ ...prev, desconto_tipo: e.target.value, desconto_percentual: '', desconto_valor: '' }));
                                if (isEditMode) setDadosAlterados(true);
                              }}
                              disabled={isDisabled}
                              className={`px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                            >
                              <option value="">Sem desconto</option>
                              <option value="percentual">% Percentual</option>
                              <option value="valor">R$ Valor fixo</option>
                            </select>
                            {dadosFinanceiros.desconto_tipo === 'percentual' && (
                              <div className="flex items-center gap-1 flex-1">
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  max="100"
                                  value={dadosFinanceiros.desconto_percentual}
                                  onChange={(e) => {
                                    setDadosFinanceiros(prev => ({ ...prev, desconto_percentual: e.target.value }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  disabled={isDisabled}
                                  className={`flex-1 px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                  placeholder="Ex: 5"
                                />
                                <span className="text-sm font-bold text-gray-600">%</span>
                              </div>
                            )}
                            {dadosFinanceiros.desconto_tipo === 'valor' && (
                              <div className="flex items-center gap-1 flex-1">
                                <span className="text-sm font-bold text-gray-600">R$</span>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  value={dadosFinanceiros.desconto_valor}
                                  onChange={(e) => {
                                    setDadosFinanceiros(prev => ({ ...prev, desconto_valor: e.target.value }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  disabled={isDisabled}
                                  className={`flex-1 px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                  placeholder="Ex: 1000"
                                />
                              </div>
                            )}
                          </div>
                          {dadosFinanceiros.desconto_tipo && dadosFinanceiros.valor_total > 0 && (
                            <div className="text-xs text-green-700 bg-green-50 px-3 py-1.5 rounded">
                              {dadosFinanceiros.desconto_tipo === 'percentual' && dadosFinanceiros.desconto_percentual
                                ? `Desconto: R$ ${(dadosFinanceiros.valor_total * parseFloat(dadosFinanceiros.desconto_percentual || 0) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} (${dadosFinanceiros.desconto_percentual}% de R$ ${dadosFinanceiros.valor_total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})`
                                : dadosFinanceiros.desconto_tipo === 'valor' && dadosFinanceiros.desconto_valor
                                  ? `Desconto: R$ ${parseFloat(dadosFinanceiros.desconto_valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                                  : ''}
                            </div>
                          )}
                        </div>
                      )}
                      

                      
                      {/* Configuração de Parcelamento Avançado */}
                      {dadosFinanceiros.modalidade_pagamento === 'PARCELADO' && (
                        <div className="space-y-4">

                          {/* Primeira Parcela — toggle visual */}
                          <div>
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                              Vencimento da 1ª Parcela
                            </label>
                            <div className="flex items-center gap-2">
                              <div className="flex rounded-lg border border-gray-300 overflow-hidden text-sm">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setDadosFinanceiros(prev => ({ ...prev, primeira_parcela_tipo: 'A_VISTA', primeira_parcela_dias: '' }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  disabled={isDisabled}
                                  className={`px-3 py-2 font-medium transition-colors ${dadosFinanceiros.primeira_parcela_tipo === 'A_VISTA' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'} disabled:opacity-50 disabled:cursor-not-allowed`}
                                >
                                  À Vista
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setDadosFinanceiros(prev => ({ ...prev, primeira_parcela_tipo: 'DIAS', primeira_parcela_dias: prev.primeira_parcela_dias || '30' }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  disabled={isDisabled}
                                  className={`px-3 py-2 font-medium transition-colors border-l border-gray-300 ${dadosFinanceiros.primeira_parcela_tipo === 'DIAS' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'} disabled:opacity-50 disabled:cursor-not-allowed`}
                                >
                                  A prazo
                                </button>
                              </div>
                              {dadosFinanceiros.primeira_parcela_tipo === 'DIAS' && (
                                <div className="flex items-center gap-2">
                                  <input
                                    type="number"
                                    value={dadosFinanceiros.primeira_parcela_dias}
                                    onChange={(e) => {
                                      setDadosFinanceiros(prev => ({ ...prev, primeira_parcela_dias: e.target.value }));
                                      if (isEditMode) setDadosAlterados(true);
                                    }}
                                    disabled={isDisabled}
                                    className="w-20 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100"
                                    placeholder="30"
                                    min="1"
                                  />
                                  <span className="text-sm text-gray-500">dias</span>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Presets rápidos */}
                          <div>
                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                              Atalhos
                            </label>
                            <div className="flex flex-wrap gap-2">
                              {[
                                { label: '3x iguais', desc: '3 parcelas mensais iguais', grupos: [{ quantidade: 3, peso: 1, dias: 30 }], primeira_tipo: 'A_VISTA', primeira_dias: '' },
                                { label: '6x iguais', desc: '6 parcelas mensais iguais', grupos: [{ quantidade: 6, peso: 1, dias: 30 }], primeira_tipo: 'A_VISTA', primeira_dias: '' },
                                { label: '12x iguais', desc: '12 parcelas mensais iguais', grupos: [{ quantidade: 12, peso: 1, dias: 30 }], primeira_tipo: 'A_VISTA', primeira_dias: '' },
                                { label: '5D + 30S', desc: '5 duplas + 30 simples', grupos: [{ quantidade: 5, peso: 2, dias: 30 }, { quantidade: 30, peso: 1, dias: 30 }], primeira_tipo: 'DIAS', primeira_dias: '30' },
                              ].map((preset) => (
                                <button
                                  key={preset.label}
                                  type="button"
                                  title={preset.desc}
                                  disabled={isDisabled}
                                  onClick={() => {
                                    setDadosFinanceiros(prev => ({
                                      ...prev,
                                      grupos_parcelas: flattenGrupos(preset.grupos),
                                      primeira_parcela_tipo: preset.primeira_tipo,
                                      primeira_parcela_dias: preset.primeira_dias,
                                    }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  className="px-3 py-1.5 text-xs font-medium bg-gray-100 text-gray-700 rounded-full border border-gray-200 hover:bg-blue-50 hover:text-blue-700 hover:border-blue-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  {preset.label}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Parcelar sobre o valor líquido (não se aplica ao fluxo separada) */}
                          {!isFluxoSeparada() && (
                            <label className="flex items-start gap-2 text-sm text-gray-700 cursor-pointer">
                              <input
                                type="checkbox"
                                className="mt-0.5"
                                disabled={isDisabled}
                                checked={!!dadosFinanceiros.parcelar_sobre_liquido}
                                onChange={(e) => {
                                  setDadosFinanceiros(prev => ({ ...prev, parcelar_sobre_liquido: e.target.checked }));
                                  if (isEditMode) setDadosAlterados(true);
                                }}
                              />
                              <span>
                                Parcelar sobre o valor líquido
                                <span className="block text-xs text-gray-400">
                                  Parcelas e valores digitados já consideram o líquido (após comissão e despesas)
                                </span>
                              </span>
                            </label>
                          )}

                          {/* Grupos de Parcelas */}
                          <div>
                            <div className="flex items-center justify-between mb-2">
                              <div>
                                <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                  Parcelas
                                </label>
                                <p className="text-xs text-gray-400 mt-0.5">1 linha por parcela — digite os dias desde a anterior ou escolha a data</p>
                              </div>
                              <div className="flex gap-2">
                                <button
                                  type="button"
                                  onClick={() => setShowSalvarMeioPagamento(true)}
                                  disabled={isDisabled}
                                  className="text-xs px-3 py-1.5 bg-orange-50 text-orange-600 border border-orange-200 rounded-lg hover:bg-orange-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                                >
                                  Salvar como modelo
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setDadosFinanceiros(prev => ({
                                      ...prev,
                                      grupos_parcelas: [...prev.grupos_parcelas, { quantidade: 1, peso: 1, dias: 30 }]
                                    }));
                                    if (isEditMode) setDadosAlterados(true);
                                  }}
                                  disabled={isDisabled}
                                  className="text-xs px-3 py-1.5 bg-blue-50 text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                                >
                                  <Plus size={12} /> Parcela
                                </button>
                              </div>
                            </div>

                            <div className="space-y-2 max-h-[28rem] overflow-y-auto pr-1">
                              {(() => {
                                const parcelasPreview = gerarParcelasAutomaticas();
                                const brutosPreview = calcularBrutosParcelas(dadosFinanceiros.grupos_parcelas, dadosFinanceiros.valor_total || 0);
                                return dadosFinanceiros.grupos_parcelas.map((grupo, index) => {
                                const vv = dadosFinanceiros.valor_total || 0;
                                // Sobre o líquido o valor exibido já é o que o cliente recebe
                                const valorParcela = (parcelarSobreLiquido() ? parcelasPreview[index]?.valor : brutosPreview[index]) ?? 0;
                                const temValorFixo = grupo.valor_fixo != null && grupo.valor_fixo !== '';
                                const dataDestaParcela = parcelasPreview[index]?.data;
                                const dataAnterior = index > 0 ? parcelasPreview[index - 1]?.data : null;
                                const emModoData = !!parcelasEmModoData[index];
                                return (
                                  <div key={index} className="p-3 bg-gray-50 border border-gray-200 rounded-lg">
                                  <div className="flex items-center gap-3">
                                    {/* Badge parcela */}
                                    <div className="flex-shrink-0 w-7 h-7 rounded-full bg-blue-100 text-blue-700 text-xs font-bold flex items-center justify-center">
                                      {index + 1}
                                    </div>

                                    {/* Múltiplo — visível só se > 1 ou ao clicar */}
                                    {grupo.peso > 1 ? (
                                      <div className="flex-1 min-w-0">
                                        <label className="block text-xs text-gray-500 mb-1" title="Múltiplo 1 = simples, 2 = duplo, etc.">Múltiplo</label>
                                        <input
                                          type="number"
                                          value={grupo.peso}
                                          onChange={(e) => {
                                            const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                            novosGrupos[index].peso = parseInt(e.target.value) || 1;
                                            setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                            if (isEditMode) setDadosAlterados(true);
                                          }}
                                          className={`w-full px-2 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-semibold focus:ring-2 focus:ring-blue-500 focus:border-transparent ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                          min="1"
                                          disabled={isDisabled}
                                        />
                                      </div>
                                    ) : null}

                                    {/* Vencimento: 1ª parcela vem do controle acima; as demais têm
                                        dias-desde-anterior OU data direta, alternáveis */}
                                    {index === 0 ? (
                                      <div className="flex-1 min-w-0 text-xs text-gray-400 italic">
                                        Vencimento definido acima (1ª Parcela)
                                      </div>
                                    ) : emModoData ? (
                                      <div className="flex-1 min-w-0">
                                        <label className="block text-xs text-gray-500 mb-1">Data de vencimento</label>
                                        <input
                                          type="date"
                                          value={dataDestaParcela ? dataDestaParcela.toISOString().split('T')[0] : ''}
                                          onChange={(e) => {
                                            if (!e.target.value || !dataAnterior) return;
                                            const novaData = new Date(e.target.value + 'T00:00:00');
                                            const diffDias = Math.round((novaData - dataAnterior) / (1000 * 60 * 60 * 24));
                                            const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                            novosGrupos[index].dias = Math.max(1, diffDias);
                                            setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                            if (isEditMode) setDadosAlterados(true);
                                          }}
                                          disabled={isDisabled}
                                          className={`w-full px-2 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                        />
                                      </div>
                                    ) : (
                                      <div className="flex-1 min-w-0">
                                        <label className="block text-xs text-gray-500 mb-1">Dias desde a anterior</label>
                                        <input
                                          type="number"
                                          value={grupo.dias ?? 30}
                                          placeholder="30"
                                          onChange={(e) => {
                                            const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                            novosGrupos[index].dias = parseInt(e.target.value) || 1;
                                            setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                            if (isEditMode) setDadosAlterados(true);
                                          }}
                                          className={`w-full px-2 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-semibold focus:ring-2 focus:ring-blue-500 focus:border-transparent ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                          min="1"
                                          disabled={isDisabled}
                                        />
                                      </div>
                                    )}

                                    {/* Alterna dias <-> data (só faz sentido a partir da 2ª parcela) */}
                                    {index > 0 && !isDisabled && (
                                      <button
                                        type="button"
                                        onClick={() => setParcelasEmModoData(prev => ({ ...prev, [index]: !prev[index] }))}
                                        title={emModoData ? 'Digitar quantidade de dias' : 'Escolher data no calendário'}
                                        className="flex-shrink-0 self-end mb-1.5 p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                      >
                                        <Calendar size={14} />
                                      </button>
                                    )}

                                    {/* Valor calculado */}
                                    {dadosFinanceiros.valor_total > 0 && (
                                      <div className="flex-shrink-0 text-right">
                                        <div className="text-xs text-gray-400">
                                          {temValorFixo ? (parcelarSobreLiquido() ? 'líquido digitado' : 'valor digitado') : 'por parcela'}
                                        </div>
                                        <div className="flex items-center justify-end gap-1">
                                          <span className={`text-sm font-bold ${temValorFixo ? 'text-blue-700' : 'text-green-700'}`}>R$</span>
                                          <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            disabled={isDisabled}
                                            value={temValorFixo ? grupo.valor_fixo : Number(valorParcela.toFixed(2))}
                                            onChange={(e) => {
                                              const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                              const v = e.target.value;
                                              if (v === '') delete novosGrupos[index].valor_fixo;
                                              else novosGrupos[index].valor_fixo = parseFloat(v);
                                              setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                              if (isEditMode) setDadosAlterados(true);
                                            }}
                                            className={`w-32 px-2 py-1 border rounded-lg text-sm font-bold text-right focus:ring-2 focus:ring-blue-500 ${temValorFixo ? 'border-blue-300 bg-blue-50 text-blue-700' : 'border-transparent bg-transparent text-green-700 hover:border-gray-300'} ${isDisabled ? 'cursor-not-allowed' : ''}`}
                                            title="Digite o valor desta parcela; as demais dividem o restante"
                                          />
                                          {temValorFixo && !isDisabled && (
                                            <button
                                              type="button"
                                              onClick={() => {
                                                const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                                delete novosGrupos[index].valor_fixo;
                                                setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                                if (isEditMode) setDadosAlterados(true);
                                              }}
                                              className="text-xs text-gray-400 hover:text-red-500"
                                              title="Voltar ao cálculo automático"
                                            >↺</button>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Remover */}
                                    {dadosFinanceiros.grupos_parcelas.length > 1 && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          const novosGrupos = dadosFinanceiros.grupos_parcelas.filter((_, i) => i !== index);
                                          setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                          if (isEditMode) setDadosAlterados(true);
                                        }}
                                        disabled={isDisabled}
                                        className="flex-shrink-0 p-1.5 text-red-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                      >
                                        <X size={14} />
                                      </button>
                                    )}
                                  </div>

                                  {/* Vencimento calculado + atalho de múltiplo */}
                                  <div className="mt-2 pl-10 flex items-center gap-2 flex-wrap">
                                    {dataDestaParcela && (
                                      <span className="text-xs text-gray-400">
                                        vence em <b className="text-gray-600">{dataDestaParcela.toLocaleDateString('pt-BR')}</b>
                                      </span>
                                    )}
                                    {grupo.peso === 1 && !isDisabled && (
                                      <>
                                        {dataDestaParcela && <span className="text-xs text-gray-300">·</span>}
                                        <button
                                          type="button"
                                          onClick={() => {
                                            const novosGrupos = [...dadosFinanceiros.grupos_parcelas];
                                            novosGrupos[index].peso = 2;
                                            setDadosFinanceiros(prev => ({ ...prev, grupos_parcelas: novosGrupos }));
                                            if (isEditMode) setDadosAlterados(true);
                                          }}
                                          className="text-xs text-gray-400 hover:text-blue-600 underline underline-offset-2 whitespace-nowrap"
                                          title="Definir múltiplo (parcelas com valor diferente)"
                                        >
                                          + múltiplo
                                        </button>
                                      </>
                                    )}
                                  </div>
                                  </div>
                                );
                                });
                              })()}
                            </div>

                            {/* Resumo total */}
                            {dadosFinanceiros.grupos_parcelas.length > 0 && (
                              <div className="mt-2 px-3 py-2 bg-blue-50 border border-blue-100 rounded-lg flex justify-between items-center">
                                <span className="text-xs text-blue-600 font-medium">
                                  Total: {dadosFinanceiros.grupos_parcelas.reduce((acc, g) => acc + g.quantidade, 0)} parcelas
                                </span>
                                {dadosFinanceiros.valor_total > 0 && (
                                  <span className="text-xs text-blue-600">
                                    Líquido: R$ {calcularValorLiquido().toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    </div>

                    {/* Preview do Pagamento */}
                    <div>
                      {dadosFinanceiros.modalidade_pagamento ? (
                        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                          <h4 className="text-sm font-semibold text-green-800 mb-3 flex items-center gap-2">
                            <DollarSign size={16} />
                            Preview do Pagamento
                          </h4>
                          <div className="space-y-3">
                            <div className="flex justify-between items-center">
                              <span className="text-sm text-green-700">Modalidade:</span>
                              <span className="font-semibold text-green-800">
                                {dadosFinanceiros.modalidade_pagamento === 'A_VISTA' && 'À Vista'}
                                {dadosFinanceiros.modalidade_pagamento === 'PRAZO' && (
                                  mapasConfig?.prazo_dias_diferente
                                    ? `Prazo C:${dadosFinanceiros.dias_prazo_comprador || '?'} / V:${dadosFinanceiros.dias_prazo_vendedor || '?'} dias`
                                    : `Prazo ${dadosFinanceiros.dias_prazo} dias`
                                )}
                                {dadosFinanceiros.modalidade_pagamento === 'PARCELADO' && (() => {
                                  const totalParcelas = dadosFinanceiros.grupos_parcelas.reduce((acc, grupo) => acc + grupo.quantidade, 0);
                                  return `Parcelado - ${totalParcelas} parcelas`;
                                })()}
                              </span>
                            </div>

                            {/* Preview da data base para À Vista */}
                            {dadosFinanceiros.modalidade_pagamento === 'A_VISTA' && (
                              <div className="mt-3 pt-3 border-t border-green-200">
                                <div className="text-xs text-green-600 mb-1">📅 Data de Pagamento</div>
                                <div className="text-sm text-green-700">
                                  {(() => {
                                    let dataBase;
                                    if (configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' && dataLeilao) {
                                      dataBase = new Date(dataLeilao);
                                    } else {
                                      dataBase = new Date();
                                    }
                                    return dataBase.toLocaleDateString('pt-BR');
                                  })()
                                  } ({configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' ? 'Data do Leilão' : 'Data Atual'})
                                </div>
                              </div>
                            )}



                            {/* Desconto À Vista */}
                            {dadosFinanceiros.modalidade_pagamento === 'A_VISTA' && dadosFinanceiros.desconto_tipo && (
                              <div className="flex justify-between items-center text-sm">
                                <span className="text-orange-600">
                                  Desconto À Vista ({dadosFinanceiros.desconto_tipo === 'percentual' ? `${dadosFinanceiros.desconto_percentual || 0}%` : 'fixo'}):
                                </span>
                                <span className="font-semibold text-orange-700">
                                  - R$ {(() => {
                                    const vv = dadosFinanceiros.valor_total || 0;
                                    if (dadosFinanceiros.desconto_tipo === 'percentual' && dadosFinanceiros.desconto_percentual) {
                                      return (vv * parseFloat(dadosFinanceiros.desconto_percentual) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                                    } else if (dadosFinanceiros.desconto_tipo === 'valor' && dadosFinanceiros.desconto_valor) {
                                      return parseFloat(dadosFinanceiros.desconto_valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                                    }
                                    return '0,00';
                                  })()}
                                </span>
                              </div>
                            )}

                            <div className="flex justify-between items-center">
                              <span className="text-sm text-green-700">Valor Líquido:</span>
                              <span className="font-bold text-green-800 text-lg">
                                R$ {calcularValorLiquido().toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                              </span>
                            </div>

                            {/* Preview das Parcelas */}
                            {dadosFinanceiros.modalidade_pagamento === 'PARCELADO' && (() => {
                              // Lote já faturado/defesa: usa o array real salvo no faturamento em vez
                              // de regerar via grupos_parcelas — que em lotes migrados de outro sistema
                              // pode ser só um placeholder genérico (não reflete os pesos reais originais)
                              const usarHistorico = (loteStatus === 'FATURADO' || loteStatus === 'DEFESA') && dadosFinanceiros.parcelas?.length > 0;
                              const parcelasCalculadas = usarHistorico
                                ? dadosFinanceiros.parcelas.map(p => ({ ...p, data: new Date(p.data) }))
                                : gerarParcelasAutomaticas();

                              // Agrupa parcelas consecutivas de mesmo valor — reflete o meio de
                              // pagamento e os pesos reais historicamente aplicados
                              const gruposReais = [];
                              if (usarHistorico) {
                                for (const p of parcelasCalculadas) {
                                  const ultimo = gruposReais[gruposReais.length - 1];
                                  if (ultimo && Math.abs(ultimo.valor - p.valor) < 0.01) {
                                    ultimo.quantidade++;
                                  } else {
                                    gruposReais.push({ quantidade: 1, valor: p.valor });
                                  }
                                }
                              }

                              return parcelasCalculadas.length > 0 && (
                                <div className="mt-3 pt-3 border-t border-green-200">
                                  <div className="text-xs text-green-600 mb-2">
                                    📅 Cronograma de Pagamento{usarHistorico ? ' (histórico real do faturamento)' : ''}
                                  </div>

                                  {/* Resumo dos Grupos */}
                                  <div className="mb-3 space-y-1">
                                    {usarHistorico
                                      ? gruposReais.map((grupo, index) => (
                                          <div key={index} className="text-xs text-green-700 bg-green-100 px-2 py-1 rounded">
                                            Grupo {index + 1}: {grupo.quantidade} parcela(s) de R$ {grupo.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                          </div>
                                        ))
                                      : dadosFinanceiros.grupos_parcelas.map((grupo, index) => (
                                          <div key={index} className="text-xs text-green-700 bg-green-100 px-2 py-1 rounded">
                                            Parcela {index + 1}{grupo.peso > 1 ? ` (Peso ${grupo.peso})` : ''}
                                          </div>
                                        ))}
                                  </div>

                                  {/* Primeira Parcela Info */}
                                  {!usarHistorico && (
                                    <div className="mb-2 text-xs text-green-700">
                                      <strong>1ª Parcela:</strong> {dadosFinanceiros.primeira_parcela_tipo === 'A_VISTA' ? 'À Vista' : `${dadosFinanceiros.primeira_parcela_dias} dias`}
                                      {configuracoesFaturamento && (
                                        <span className="ml-1 text-green-600">
                                          ({configuracoesFaturamento.data_base_calculo === 'DATA_LEILAO' ? 'Data do Leilão' : 'Data Atual'})
                                        </span>
                                      )}
                                    </div>
                                  )}

                                  {/* Lista de Parcelas */}
                                  <div className="max-h-32 overflow-y-auto space-y-1">
                                    {parcelasCalculadas.slice(0, 8).map((parcela, index) => (
                                      <div key={index} className="flex justify-between text-xs text-green-700">
                                        <span>{parcela.numero}ª Parc</span>
                                        <span>R$ {parcela.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} - {parcela.data.toLocaleDateString('pt-BR')}</span>
                                      </div>
                                    ))}
                                    {parcelasCalculadas.length > 8 && (
                                      <div className="text-xs text-green-600 italic text-center">
                                        ... e mais {parcelasCalculadas.length - 8} parcelas
                                      </div>
                                    )}
                                  </div>

                                  <div className="mt-2 pt-2 border-t border-green-300">
                                    <div className="flex justify-between text-xs text-green-700 mb-1">
                                      <span>Total de Parcelas:</span>
                                      <span>{parcelasCalculadas.length}</span>
                                    </div>
                                    <div className="flex justify-between text-xs text-green-700 mb-1">
                                      <span>Valor Médio/Parcela:</span>
                                      <span>R$ {(parcelasCalculadas.reduce((s,p) => s + p.valor, 0) / parcelasCalculadas.length).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                                    </div>
                                    <div className="flex justify-between text-xs font-semibold text-green-800">
                                      <span>Valor Líquido Total:</span>
                                      <span>R$ {parcelasCalculadas.reduce((s,p) => s + p.valor, 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}

                            {/* Preview do Prazo */}
                            {dadosFinanceiros.modalidade_pagamento === 'PRAZO' && (mapasConfig?.prazo_dias_diferente ? dadosFinanceiros.dias_prazo_comprador : dadosFinanceiros.dias_prazo) && (
                              <div className="mt-3 pt-3 border-t border-green-200">
                                <div className="text-xs text-green-600 mb-1">📅 Data de Vencimento (Comprador)</div>
                                <div className="text-sm text-green-700">
                                  {(() => {
                                    const diasComp = mapasConfig?.prazo_dias_diferente ? parseInt(dadosFinanceiros.dias_prazo_comprador) : parseInt(dadosFinanceiros.dias_prazo)
                                    let dataBase;
                                    if (configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' && dataLeilao) {
                                      dataBase = new Date(dataLeilao);
                                    } else {
                                      dataBase = new Date();
                                    }
                                    const dataVencimento = new Date(dataBase);
                                    dataVencimento.setDate(dataBase.getDate() + diasComp);
                                    return dataVencimento.toLocaleDateString('pt-BR');
                                  })()
                                  } ({configuracoesFaturamento?.data_base_calculo === 'DATA_LEILAO' ? 'Data do Leilão' : 'Data Atual'} + {mapasConfig?.prazo_dias_diferente ? dadosFinanceiros.dias_prazo_comprador : dadosFinanceiros.dias_prazo} dias)
                                </div>
                                {mapasConfig?.prazo_dias_diferente && dadosFinanceiros.dias_prazo_vendedor && (
                                  <div className="text-xs text-blue-600 mt-1">Vendedor: {dadosFinanceiros.dias_prazo_vendedor} dias</div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                          <div className="text-center text-gray-500">
                            <DollarSign size={24} className="mx-auto mb-2 opacity-50" />
                            <p className="text-sm">Selecione uma modalidade de pagamento para ver o preview</p>
                          </div>
                        </div>
                      )}

                      {/* Leiloeiro */}
                      {leileirosDoLeilaoList.length > 0 && (
                        <div className="mt-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Leiloeiro</label>
                          <div className="flex items-center gap-3">
                            <select
                              value={dadosFinanceiros.fora_do_leilao ? '' : (dadosFinanceiros.leiloeiro_id || '')}
                              onChange={e => {
                                setDadosFinanceiros(prev => ({ ...prev, leiloeiro_id: e.target.value ? parseInt(e.target.value) : null }))
                                if (isEditMode) setDadosAlterados(true)
                              }}
                              disabled={isDisabled || dadosFinanceiros.fora_do_leilao}
                              className={`flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 ${isDisabled || dadosFinanceiros.fora_do_leilao ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                            >
                              <option value="">Sem leiloeiro</option>
                              {leileirosDoLeilaoList.map(ll => (
                                <option key={ll.leiloeiro_id} value={ll.leiloeiro_id}>{ll.nome}</option>
                              ))}
                            </select>
                            <label className="flex items-center gap-1.5 text-sm text-gray-600 whitespace-nowrap cursor-pointer">
                              <input
                                type="checkbox"
                                checked={dadosFinanceiros.fora_do_leilao || false}
                                onChange={e => {
                                  setDadosFinanceiros(prev => ({
                                    ...prev,
                                    fora_do_leilao: e.target.checked,
                                    leiloeiro_id: e.target.checked ? null : prev.leiloeiro_id,
                                  }))
                                  if (isEditMode) setDadosAlterados(true)
                                }}
                                disabled={isDisabled}
                                className="rounded"
                              />
                              Fora do leilão
                            </label>
                          </div>
                          {dadosFinanceiros.fora_do_leilao && (
                            <p className="text-xs text-amber-600 mt-1">Venda fora do martelo — não gera comissão para o leiloeiro.</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            )}
          </div>
        );



      case 4: // Despesas (antes do Financeiro)
        return (
          <DespesasLote
            loteId={loteId}
            organizadorId={organizadorAtivo?.id}
            loteStatus={loteStatus}
            fluxo={dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao || 'primeira_parcela'}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="page-content">
      {/* Header */}
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <button
              onClick={() => navigate('/lotes')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
            >
              <ArrowLeft size={18} />
            </button>
            <div className="min-w-0">
              <h1 className="text-lg sm:text-2xl font-bold text-gray-900 truncate">
                {isEditMode ? `Editar Lote ${formData.numero_lote}` : 'Novo Lote'}
              </h1>
              <p className="text-gray-500 text-sm hidden sm:block">
                {isEditMode ? 'Edite as informações do lote' : 'Cadastre um novo lote de gado de corte'}
              </p>
            </div>
          </div>

        {/* Ações Rápidas no header - só no modo edição */}
        {isEditMode && (
          <div className="flex items-center gap-2 w-full sm:w-auto flex-wrap pb-1 sm:pb-0">

            {/* Badge de refugo */}
            {refugoInfo.foi_refugado && (
              <RefugoBadge
                organizadorId={organizadorAtivo?.id}
                loteId={loteId}
                qtdTotalRefugada={refugoInfo.qtd_total_refugada}
              />
            )}

            {/* NOVO */}
            {loteStatus === 'NOVO' && (
              <>
                <button type="button" onClick={() => setShowValorVendaModal(true)}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-amber-500 text-white hover:bg-amber-600 active:scale-95 transition-all shadow-sm">
                  <DollarSign size={15} /> Definir Venda
                </button>
                <button type="button" onClick={abrirModalDefesa}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-red-500 text-white hover:bg-red-600 active:scale-95 transition-all shadow-sm">
                  <AlertTriangle size={15} /> Defesa
                </button>
                {currentStep === 5 && valorVendaDefinido && dadosFinanceiros.comprador_id && dadosFinanceiros.comissao_id && dadosFinanceiros.modalidade_pagamento && (
                  <button type="button" onClick={faturarLote}
                    className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-bold rounded-lg bg-green-600 text-white hover:bg-green-700 active:scale-95 transition-all shadow-md ring-2 ring-green-300">
                    <DollarSign size={15} /> Faturar Lote
                  </button>
                )}
              </>
            )}

            {/* EDITADO */}
            {loteStatus === 'EDITADO' && (
              <>
                {valorVendaDefinido && dadosFinanceiros.comprador_id && dadosFinanceiros.comissao_id && dadosFinanceiros.modalidade_pagamento && (
                  <button type="button" onClick={faturarLote}
                    className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-bold rounded-lg bg-green-600 text-white hover:bg-green-700 active:scale-95 transition-all shadow-md ring-2 ring-green-300">
                    <DollarSign size={15} /> Faturar Lote
                  </button>
                )}
                <button type="button" onClick={() => setShowValorVendaModal(true)}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-amber-500 text-white hover:bg-amber-600 active:scale-95 transition-all shadow-sm">
                  <DollarSign size={15} /> Alterar Venda
                </button>
                <button type="button" onClick={abrirModalDefesa}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-red-500 text-white hover:bg-red-600 active:scale-95 transition-all shadow-sm">
                  <AlertTriangle size={15} /> Defesa
                </button>
                {parseInt(formData.qtd) > 1 && (
                  <button type="button" onClick={() => setShowRefugarModal(true)}
                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-orange-500 text-white hover:bg-orange-600 active:scale-95 transition-all shadow-sm">
                    <SplitSquareHorizontal size={15} /> Refugar
                  </button>
                )}
                <button type="button" onClick={resetarLote}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-gray-500 text-white hover:bg-gray-600 active:scale-95 transition-all shadow-sm">
                  <ArrowLeft size={15} /> Resetar
                </button>
              </>
            )}

            {/* FATURADO */}
            {loteStatus === 'FATURADO' && (
              <>
                <button type="button" onClick={desfazerNegociacao}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-red-600 text-white hover:bg-red-700 active:scale-95 transition-all shadow-sm">
                  Desfazer
                </button>
                {parseInt(formData.qtd) > 1 && (
                  <button type="button" onClick={() => setShowRefugarModal(true)}
                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-orange-500 text-white hover:bg-orange-600 active:scale-95 transition-all shadow-sm">
                    <SplitSquareHorizontal size={15} /> Refugar
                  </button>
                )}
                {String(dadosLeilao?.tipo_leilao || '').includes('beneficente') && (
                  <button type="button" onClick={() => setShowDoarNovamenteModal(true)}
                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-pink-600 text-white hover:bg-pink-700 active:scale-95 transition-all shadow-sm">
                    <Gift size={15} /> Doar Novamente
                  </button>
                )}
                {(dadosLeilao?.fluxo_comissao || organizadorAtivo?.fluxo_leilao) === 'gta_nota' && (() => {
                  const label = gtaIsento && notaIsento ? 'GTA/Nota: isentos'
                    : gtaIsento ? 'GTA isento · Nota cobrando'
                    : notaIsento ? 'Nota isenta · GTA cobrando'
                    : 'Isentar GTA/Nota'
                  const algumIsento = gtaIsento || notaIsento
                  return (
                    <button type="button" onClick={() => setShowIsentarGtaModal(true)}
                      className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg text-white active:scale-95 transition-all shadow-sm ${algumIsento ? 'bg-blue-500 hover:bg-blue-600' : 'bg-teal-600 hover:bg-teal-700'}`}>
                      {algumIsento ? <ShieldCheck size={15} /> : <ShieldOff size={15} />} {label}
                    </button>
                  )
                })()}
                {/* Dropdown Contratos */}
                <div ref={contratosDropdownRef} className="relative inline-flex">
                  <button
                    type="button"
                    onClick={() => setShowContratosDropdown(v => !v)}
                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700 active:scale-95 transition-all shadow-sm"
                  >
                    <FileText size={16} /> Contratos ▾
                  </button>
                  {showContratosDropdown && (
                    <div className="absolute top-full left-0 mt-1 z-[9999] bg-white border border-gray-200 rounded-lg shadow-lg min-w-[180px]">
                      <div className="py-1">
                        <div className="px-2 py-1">
                          <ContratoUnicoButton
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                        <div className="px-2 py-1">
                          <ContratoUmaVia
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                        <div className="px-2 py-1">
                          <ContratoNotaButton
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                        <div className="px-2 py-1">
                          <Contrato3ViasButton
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Dropdown Notas */}
                <div ref={notasDropdownRef} className="relative inline-flex">
                  <button
                    type="button"
                    onClick={() => setShowNotasDropdown(v => !v)}
                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-green-600 text-white hover:bg-green-700 active:scale-95 transition-all shadow-sm"
                  >
                    <FileText size={16} /> Notas ▾
                  </button>
                  {showNotasDropdown && (
                    <div className="absolute top-full left-0 mt-1 z-[9999] bg-white border border-gray-200 rounded-lg shadow-lg min-w-[180px]">
                      <div className="py-1">
                        <div className="px-2 py-1">
                          <NotaPromissoriaButton
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                        <div className="px-2 py-1">
                          <NotaCompromissoButton
                            lote={{ id: loteId, numero_lote: formData.numero_lote }}
                            organizador={organizadorAtivo}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* DEFESA */}
            {loteStatus === 'DEFESA' && (
              <>
                <button type="button" onClick={desfazerNegociacao}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-lg bg-red-600 text-white hover:bg-red-700 active:scale-95 transition-all shadow-sm">
                  Desfazer Defesa
                </button>
                <div className="inline-flex">
                  <ContratoUnicoButton
                    lote={{ id: loteId, numero_lote: formData.numero_lote }}
                    organizador={organizadorAtivo}
                  />
                </div>
                <div className="inline-flex">
                  <ContratoUmaVia
                    lote={{ id: loteId, numero_lote: formData.numero_lote }}
                    organizador={organizadorAtivo}
                  />
                </div>
              </>
            )}

            {/* Sempre disponível - Imprimir Ficha */}
            <div className="inline-flex">
              <FichaLeiloeiroButton
                lote={{ id: loteId, numero_lote: formData.numero_lote }}
                organizador={organizadorAtivo}
              />
            </div>
          </div>
        )}
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        {/* Steps Navigation */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 px-4 py-4">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-1 sm:gap-2 lg:gap-1">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isActive = index === currentStep;
              const isCompleted = completedSteps.has(index) || (index < currentStep);
              const isValid = isStepValid(index);
              
              return (
                <div key={step.id} className="flex items-center">
                  <button
                    onClick={() => goToStep(index)}
                    className={`flex items-center gap-1 lg:gap-2 px-2 py-2 sm:px-3 lg:px-4 sm:py-2 lg:py-3 rounded-xl transition-all text-xs sm:text-sm font-medium whitespace-nowrap ${
                      isActive 
                        ? 'bg-blue-600 text-white shadow-lg'
                        : isCompleted || isValid
                        ? 'bg-green-100 text-green-700 hover:bg-green-200'
                        : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                    }`}
                  >
                    <div className={`p-1.5 sm:p-2 rounded-full ${
                      isActive 
                        ? 'bg-blue-500' 
                        : isCompleted || isValid
                        ? 'bg-green-500'
                        : 'bg-gray-400'
                    }`}>
                      {isCompleted ? (
                        <Check size={14} className="text-white" />
                      ) : (
                        <Icon size={14} className="text-white" />
                      )}
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">{step.title}</div>
                      <div className="text-xs opacity-75 hidden sm:block">
                        {index + 1} de {steps.length}
                      </div>
                    </div>
                  </button>
                  {index < steps.length - 1 && (
                    <ChevronRight size={14} className="mx-1 text-gray-400 hidden sm:block" />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Step Content */}
        <form onSubmit={handleSubmit}>
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-3 sm:p-6 mb-4 sm:mb-6">
            <div className="mb-4 sm:mb-6">
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
                {React.createElement(steps[currentStep].icon, { size: 20, className: 'text-blue-600' })}
                {steps[currentStep].title}
              </h2>
              <p className="text-gray-600 mt-1 text-sm sm:text-base">
                {currentStep === 0 && 'Informe os dados básicos do lote'}
                {currentStep === 1 && 'Defina as características dos animais'}
                {currentStep === 2 && 'Selecione o vendedor e fazenda'}
                {currentStep === 3 && 'Adicione informações extras (opcional)'}
                {currentStep === 4 && 'Gerencie as despesas deste lote'}
                {currentStep === 5 && ''}
                {currentStep === 5 && 'Gerencie as despesas deste lote'}
              </p>
            </div>
            
            {/* Aviso de lote faturado */}
            {loteStatus === 'FATURADO' && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                <div className="flex items-center gap-2 text-red-800">
                  <AlertTriangle size={20} />
                  <h3 className="font-semibold">Lote Faturado</h3>
                </div>
                <p className="text-red-700 mt-1">
                  Este lote já foi faturado e não pode ser editado. Para fazer alterações, é necessário desfazer a negociação primeiro.
                </p>
              </div>
            )}
            
            {renderStepContent()}
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <button
              type="button"
              onClick={prevStep}
              disabled={currentStep === 0}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 sm:px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
            >
              <ChevronLeft size={18} />
              Anterior
            </button>

            <div className="flex flex-wrap gap-2 w-full sm:w-auto justify-end">
              <button
                type="button"
                onClick={() => navigate('/lotes')}
                className="w-full sm:w-auto px-4 sm:px-6 py-3 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors text-sm sm:text-base"
                disabled={saving}
              >
                Cancelar
              </button>

              {/* Desfazer no rodapé */}
              {loteStatus === 'FATURADO' && (
                <button
                  type="button"
                  onClick={desfazerNegociacao}
                  className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors text-sm sm:text-base"
                >
                  Desfazer Negociação
                </button>
              )}
              {loteStatus === 'DEFESA' && (
                <button
                  type="button"
                  onClick={desfazerNegociacao}
                  className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors text-sm sm:text-base"
                >
                  Desfazer Defesa
                </button>
              )}
              
              {/* Toggle Duplicar — visível quando pode salvar */}
              {(loteStatus === 'EDITADO' || loteStatus === 'NOVO' || !isEditMode) && (
                <button
                  type="button"
                  onClick={() => setDuplicar(d => !d)}
                  className={`flex items-center gap-2 px-4 py-3 rounded-lg border-2 transition-all font-medium text-sm ${
                    duplicar
                      ? 'bg-purple-600 border-purple-600 text-white shadow-md'
                      : 'bg-white border-gray-300 text-gray-600 hover:border-purple-400 hover:text-purple-600'
                  }`}
                  title="Ao salvar, cria uma cópia deste lote pré-preenchida para editar"
                >
                  <Copy size={16} />
                  <span className="hidden sm:inline">Duplicar ao salvar</span>
                  <span className="sm:hidden">Duplicar</span>
                  {duplicar && (
                    <span className="text-xs bg-white/20 px-1.5 py-0.5 rounded font-bold">
                      {gerarNumeroLoteDuplicado(formData.numero_lote) || '…'}
                    </span>
                  )}
                </button>
              )}

              {/* Aviso de alterações não salvas */}
              {dadosAlterados && isEditMode && (loteStatus === 'NOVO' || loteStatus === 'EDITADO') && (
                <div className="w-full sm:w-auto flex items-center gap-2 px-4 py-3 bg-amber-50 border-2 border-amber-400 rounded-lg text-sm font-semibold text-amber-800">
                  <AlertTriangle size={18} className="flex-shrink-0 text-amber-500" />
                  <span>Salve antes de faturar ou registrar defesa!</span>
                </div>
              )}

              {/* Salvar Alterações - steps 0-4, sempre visível no modo edição */}
              {isEditMode && currentStep <= 4 && (loteStatus === 'EDITADO' || loteStatus === 'NOVO') && (
                <button
                  type="submit"
                  className={`w-full sm:w-auto px-4 sm:px-6 py-3 rounded-lg flex items-center justify-center gap-2 transition-all disabled:opacity-50 font-semibold text-sm sm:text-base ${
                    dadosAlterados
                      ? 'bg-amber-500 hover:bg-amber-600 text-white ring-2 ring-amber-300 shadow-md'
                      : 'bg-green-600 hover:bg-green-700 text-white'
                  }`}
                  disabled={saving}
                >
                  <Save size={18} />
                  {saving ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              )}

              {/* Faturar - step Financeiro (index 4), modo edição */}
              {isEditMode && currentStep === 5 && (loteStatus === 'NOVO' || loteStatus === 'EDITADO') && valorVendaDefinido && dadosFinanceiros.comprador_id && dadosFinanceiros.comissao_id && dadosFinanceiros.modalidade_pagamento && (
                <button
                  type="button"
                  onClick={faturarLote}
                  className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center justify-center gap-2 transition-colors font-bold text-sm sm:text-base shadow-md ring-2 ring-green-300"
                  disabled={saving}
                >
                  <DollarSign size={18} />
                  {saving ? 'Faturando...' : 'Faturar Lote'}
                </button>
              )}

              {currentStep < steps.length - 1 ? (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    nextStep();
                  }}
                  disabled={!isStepValid(currentStep)}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 sm:px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm sm:text-base"
                >
                  Próximo
                  <ChevronRight size={18} />
                </button>
              ) : (
                // Botão Salvar no último step (modo criação)
                !isEditMode && (
                  <button
                    type="submit"
                    className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center justify-center gap-2 transition-colors disabled:opacity-50 font-medium text-sm sm:text-base"
                    disabled={saving}
                  >
                    <Save size={18} />
                    {saving ? 'Salvando...' : 'Salvar Lote'}
                  </button>
                )
              )}
            </div>
          </div>
        </form>
      </div>


      {/* Quick Create Modals */}
      {Object.entries(quickCreateModals).map(([type, isOpen]) => {
        if (!isOpen) return null;
        
        const titles = {
          tipo: 'Novo Tipo de Animal',
          raca: 'Nova Raça',
          idade: 'Nova Idade'
        };
        
        const placeholders = {
          tipo: 'Ex: Novilho, Vaca Prenha...',
          raca: 'Ex: Nelore PO, Angus Red...',
          idade: 'Ex: 37-48M, Acima de 60M...'
        };
        
        return (
          <div key={type} className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
              <h2 className="text-xl font-semibold mb-4">{titles[type]}</h2>
              
              <form onSubmit={async (e) => {
                e.preventDefault();
                if (!quickCreateData.nome.trim()) return;
                
                setQuickCreateSaving(true);
                try {
                  let newItem;
                  if (type === 'tipo') {
                    newItem = await lotesService.criarTipoAnimal(organizadorAtivo.id, {
                      nome: quickCreateData.nome.trim(),
                      sexo_padrao: quickCreateData.sexo_padrao || null,
                      idade_padrao_id: quickCreateData.idade_padrao_id || null
                    });
                    setOpcoes(prev => ({ ...prev, tiposAnimais: [...prev.tiposAnimais, newItem] }));
                    setFormData(prev => ({ ...prev, tipo_animal_id: newItem.id.toString() }));
                  } else if (type === 'raca') {
                    newItem = await lotesService.criarRaca(organizadorAtivo.id, { nome: quickCreateData.nome.trim() });
                    setOpcoes(prev => ({ ...prev, racas: [...prev.racas, newItem] }));
                    setFormData(prev => ({ ...prev, raca_id: newItem.id.toString() }));
                  } else if (type === 'idade') {
                    newItem = await lotesService.criarIdade(organizadorAtivo.id, { nome: quickCreateData.nome.trim() });
                    setOpcoes(prev => ({ ...prev, idades: [...prev.idades, newItem] }));
                    setFormData(prev => ({ ...prev, idade_id: newItem.id.toString() }));
                  }
                  
                  toast.success(`${titles[type]} criado com sucesso!`);
                  setQuickCreateModals(prev => ({ ...prev, [type]: false }));
                  setQuickCreateData({ nome: '', sexo_padrao: '', idade_padrao_id: '', cpf_cnpj: '', telefone: '', email: '', is_socio: false });
                } catch (error) {
                  console.error('Erro ao criar:', error);
                  toast.error('Erro ao criar item');
                } finally {
                  setQuickCreateSaving(false);
                }
              }} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nome *
                  </label>
                  <input
                    type="text"
                    value={quickCreateData.nome}
                    onChange={(e) => setQuickCreateData(prev => ({ ...prev, nome: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder={placeholders[type]}
                    required
                    autoFocus
                    disabled={quickCreateSaving}
                  />
                </div>
                
                {type === 'tipo' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Sexo Padrão
                      </label>
                      <select
                        value={quickCreateData.sexo_padrao}
                        onChange={(e) => setQuickCreateData(prev => ({ ...prev, sexo_padrao: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        disabled={quickCreateSaving}
                      >
                        <option value="">Selecione...</option>
                        <option value="Macho">Macho</option>
                        <option value="Fêmea">Fêmea</option>
                        <option value="Misto">Misto</option>
                        <option value="Prendas">Prendas</option>
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Idade Padrão
                      </label>
                      <select
                        value={quickCreateData.idade_padrao_id}
                        onChange={(e) => setQuickCreateData(prev => ({ ...prev, idade_padrao_id: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        disabled={quickCreateSaving}
                      >
                        <option value="">Selecione...</option>
                        {opcoes.idades.map(idade => (
                          <option key={idade.id} value={idade.id}>{idade.nome}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}
                


                <div className="flex justify-end gap-3 pt-4 border-t">
                  <button
                    type="button"
                    onClick={() => {
                      setQuickCreateModals(prev => ({ ...prev, [type]: false }));
                      setQuickCreateData({ nome: '', sexo_padrao: '', idade_padrao_id: '', cpf_cnpj: '', telefone: '', email: '', is_socio: false });
                    }}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                    disabled={quickCreateSaving}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors disabled:opacity-50"
                    disabled={quickCreateSaving}
                  >
                    {quickCreateSaving ? 'Criando...' : 'Criar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
      })}

      {/* Novo Cliente Modal */}
      <NovoClienteModal
        isOpen={showNovoClienteModal}
        onClose={() => setShowNovoClienteModal(false)}
        onClienteCreated={(newCliente) => {
          setOpcoes(prev => ({ ...prev, clientes: [...prev.clientes, newCliente] }));
          
          if (quickCreateData.grupo === 'comprador') {
            setDadosFinanceiros(prev => ({ ...prev, comprador_id: newCliente.id.toString() }));
            setCompradorSelecionado(newCliente);
            if (newCliente.fazendas && newCliente.fazendas.length > 0) {
              setFazendasComprador(newCliente.fazendas);
              setDadosFinanceiros(prev => ({ ...prev, fazenda_comprador_id: newCliente.fazendas[0].id.toString() }));
            }
            toast.success('Comprador criado e selecionado!');
          } else {
            setFormData(prev => ({ ...prev, vendedor_id: newCliente.id.toString() }));
            setVendedorSelecionado(newCliente);
            setSearchStates(prev => ({ ...prev, vendedor: { show: false, search: '' } }));
            if (newCliente.fazendas && newCliente.fazendas.length > 0) {
              setOpcoes(prev => ({ ...prev, fazendas: newCliente.fazendas }));
              setFormData(prev => ({ ...prev, fazenda_id: newCliente.fazendas[0].id.toString() }));
            }
            toast.success('Vendedor criado e selecionado!');
          }
          
          setQuickCreateData(prev => ({ ...prev, grupo: 'vendedor' }));
        }}
        organizadorId={organizadorAtivo?.id}
        defaultGrupo={quickCreateData.grupo}
        title={quickCreateData.grupo === 'comprador' ? 'Novo Comprador' : 'Novo Vendedor'}
      />

      {/* Nova Comissão Modal */}
      <NovaComissaoModal
        isOpen={showNovaComissaoModal}
        onClose={() => setShowNovaComissaoModal(false)}
        onSave={async (dadosComissao) => {
          try {
            const resp = await comissoesService.criar(organizadorAtivo.id, dadosComissao);
            const novaComissao = resp?.data || resp;
            if (novaComissao && novaComissao.id) {
              setOpcoes(prev => ({ ...prev, comissoes: [...(prev.comissoes || []), novaComissao] }));
              setDadosFinanceiros(prev => ({ ...prev, comissao_id: novaComissao.id.toString() }));
              setComissaoSelecionada(novaComissao);
              setComissaoAlteradaManualmente(true);
              toast.success('Comissão criada com sucesso!');
            }
            setShowNovaComissaoModal(false);
          } catch (error) {
            console.error('Erro ao criar comissão:', error);
            toast.error('Erro ao criar comissão');
          }
        }}
      />

      {/* Modal Valor de Venda */}
      {showValorVendaModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between p-5 border-b border-gray-100">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">Definir Valor de Venda</h2>
                <p className="text-sm text-gray-500 mt-0.5">Lote {formData.numero_lote} — {formData.qtd} {parseInt(formData.qtd) === 1 ? 'animal' : 'animais'}</p>
              </div>
              <button onClick={() => { setShowValorVendaModal(false); setValorVendaExcecaoPorCabeca(false); }} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            <div className="p-5 space-y-4">
              {/* Toggle exceção */}
              {dadosLeilao?.regra_faturamento === 'por_parcela' && (
                <label className="flex items-center gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer">
                  <input
                    type="checkbox"
                    checked={valorVendaExcecaoPorCabeca}
                    onChange={(e) => setValorVendaExcecaoPorCabeca(e.target.checked)}
                    className="h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded"
                  />
                  <span className="text-sm text-amber-800 font-medium">Exceção: faturar por cabeça neste lote</span>
                </label>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  {(dadosLeilao?.regra_faturamento === 'por_parcela' && !valorVendaExcecaoPorCabeca)
                    ? 'Valor por Parcela (R$)'
                    : 'Valor por Cabeça (R$)'}
                </label>
                <input
                  ref={valorVendaInputRef}
                  type="text"
                  value={valorVendaData.valor_venda_unidade}
                  onChange={(e) => setValorVendaData(prev => ({ ...prev, valor_venda_unidade: e.target.value }))}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (!valorVendaData.valor_venda_unidade) {
                        toast.error('Informe o valor de venda');
                        return;
                      }
                      const valorInput = parseFloat(valorVendaData.valor_venda_unidade.replace(',', '.'));
                      let valorTotal;
                      if (dadosLeilao?.regra_faturamento === 'por_parcela' && !valorVendaExcecaoPorCabeca && dadosLeilao?.meio_pagamento_padrao_id) {
                        const meioPadrao = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
                        const qtdParcelas = meioPadrao?.grupos_parcelas?.reduce((acc, g) => acc + g.quantidade * (g.peso || 1), 0) || 1;
                        valorTotal = valorInput * qtdParcelas * parseInt(formData.qtd);
                      } else {
                        valorTotal = valorInput * parseInt(formData.qtd);
                      }
                      setDadosFinanceiros(prev => ({ ...prev, valor_total: valorTotal }));
                      if (valorVendaExcecaoPorCabeca) {
                        setDadosFinanceiros(prev => ({
                          ...prev,
                          valor_total: valorTotal,
                          modalidade_pagamento: 'A_VISTA',
                          dias_prazo: '',
                          primeira_parcela_tipo: 'A_VISTA',
                          primeira_parcela_dias: '',
                          grupos_parcelas: parcelasIguais(3)
                        }));
                      }
                      setValorVendaDefinido(true);
                      setCurrentStep(5);
                      setShowValorVendaModal(false);
                      toast.success('Valor definido! Complete os dados financeiros.');
                      setTimeout(() => compradorInputRef.current?.focus(), 150);
                    }
                  }}
                  placeholder="0,00"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 text-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                  autoFocus
                />
              </div>
              {valorVendaData.valor_venda_unidade && parseFloat(valorVendaData.valor_venda_unidade.replace(',', '.') || 0) > 0 && (() => {
                const isPorParcela = dadosLeilao?.regra_faturamento === 'por_parcela' && !valorVendaExcecaoPorCabeca;
                const valorUnit = parseFloat(valorVendaData.valor_venda_unidade.replace(',', '.'));
                const qtd = parseInt(formData.qtd) || 1;

                let qtdParcelas = 1;
                let valorTotal = valorUnit * qtd;
                if (isPorParcela && dadosLeilao?.meio_pagamento_padrao_id) {
                  const meio = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
                  qtdParcelas = meio?.grupos_parcelas?.reduce((acc, g) => acc + g.quantidade * (g.peso || 1), 0) || 1;
                  valorTotal = valorUnit * qtdParcelas * qtd;
                }

                return (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 space-y-1">
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>Quantidade</span>
                      <span className="font-medium">{qtd} {qtd === 1 ? 'animal' : 'animais'}</span>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>{isPorParcela ? 'Valor por Parcela' : 'Valor unitário'}</span>
                      <span className="font-medium">R$ {valorUnit.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                    </div>
                    {isPorParcela && (
                      <div className="flex justify-between text-sm text-gray-600">
                        <span>Unidades (c/ peso)</span>
                        <span className="font-medium">{qtdParcelas}x</span>
                      </div>
                    )}
                    <div className="flex justify-between text-base font-semibold text-yellow-800 border-t border-yellow-200 pt-2 mt-1">
                      <span>Valor Total</span>
                      <span>R$ {valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                );
              })()}
            </div>
            <div className="flex gap-3 p-5 pt-0">
              <button
                onClick={() => { setShowValorVendaModal(false); setValorVendaExcecaoPorCabeca(false); }}
                className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-medium"
              >
                Cancelar
              </button>
              <button
                disabled={!valorVendaData.valor_venda_unidade || parseFloat(valorVendaData.valor_venda_unidade.replace(',', '.') || 0) <= 0}
                onClick={() => {
                  if (!valorVendaData.valor_venda_unidade) {
                    toast.error('Informe o valor de venda');
                    return;
                  }
                  const valorInput = parseFloat(valorVendaData.valor_venda_unidade.replace(',', '.'));
                  let valorTotal;
                  if (dadosLeilao?.regra_faturamento === 'por_parcela' && !valorVendaExcecaoPorCabeca && dadosLeilao?.meio_pagamento_padrao_id) {
                    const meioPadrao = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
                    const qtdParcelas = meioPadrao?.grupos_parcelas?.reduce((acc, g) => acc + g.quantidade * (g.peso || 1), 0) || 1;
                    valorTotal = valorInput * qtdParcelas * parseInt(formData.qtd);
                  } else {
                    valorTotal = valorInput * parseInt(formData.qtd);
                  }
                  setDadosFinanceiros(prev => ({ ...prev, valor_total: valorTotal }));
                  if (valorVendaExcecaoPorCabeca) {
                    setDadosFinanceiros(prev => ({
                      ...prev,
                      valor_total: valorTotal,
                      modalidade_pagamento: 'A_VISTA',
                      dias_prazo: '',
                      primeira_parcela_tipo: 'A_VISTA',
                      primeira_parcela_dias: '',
                      grupos_parcelas: parcelasIguais(3)
                    }));
                  }
                  setValorVendaDefinido(true);
                  setCurrentStep(5);
                  setShowValorVendaModal(false);
                  toast.success('Valor definido! Complete os dados financeiros.');
                  setTimeout(() => compradorInputRef.current?.focus(), 150);
                }}
                className="flex-1 px-4 py-3 bg-yellow-500 hover:bg-yellow-600 disabled:bg-gray-200 disabled:cursor-not-allowed text-white rounded-xl transition-colors font-medium flex items-center justify-center gap-2"
              >
                Ir para Financeiro
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Salvar Meio de Pagamento */}
      {showSalvarMeioPagamento && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Salvar Meio de Pagamento</h2>
              <button
                onClick={() => {
                  setShowSalvarMeioPagamento(false);
                  setNomeMeioPagamento('');
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome do Meio de Pagamento *
                </label>
                <input
                  type="text"
                  value={nomeMeioPagamento}
                  onChange={(e) => setNomeMeioPagamento(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Ex: 5 Duplas + 30 Simples"
                  autoFocus
                />
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <div className="text-sm text-blue-700">
                  <strong>Configuração atual:</strong>
                  <div className="mt-1">
                    1ª Parcela: {dadosFinanceiros.primeira_parcela_tipo === 'A_VISTA' ? 'À Vista' : `${dadosFinanceiros.primeira_parcela_dias} dias`}
                  </div>
                  <div>
                    Grupos: {dadosFinanceiros.grupos_parcelas.map((g, i) => `${g.quantidade}x${g.peso}`).join(', ')}
                  </div>
                </div>
              </div>
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setShowSalvarMeioPagamento(false);
                    setNomeMeioPagamento('');
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={salvarMeioPagamento}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                >
                  Salvar Meio de Pagamento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Meios de Pagamento */}
      {showMeiosPagamentoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Meios de Pagamento</h2>
              <button
                onClick={() => setShowMeiosPagamentoModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            <div className="p-6">
              {meiosPagamento.filter(m => m.tipo === 'PARCELADO').length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <p>Nenhum meio de pagamento parcelado salvo ainda.</p>
                  <p className="text-sm mt-1">Configure um parcelamento e clique em "Salvar" para criar seu primeiro meio de pagamento.</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {meiosPagamento.filter(m => m.tipo === 'PARCELADO').map((meio) => (
                    <div key={meio.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <h3 className="font-medium text-gray-900">{meio.nome}</h3>
                          <div className="text-sm text-gray-600 mt-1">
                            1ª Parcela: {meio.primeira_parcela_tipo === 'A_VISTA' ? 'À Vista' : `${meio.primeira_parcela_dias} dias`} • 
                            Grupos: {meio.grupos_parcelas?.map((g, i) => `${g.quantidade}x${g.peso}`).join(', ')}
                          </div>
                        </div>
                        <div className="flex gap-2 ml-4">
                          <button
                            onClick={() => carregarMeioPagamento(meio)}
                            className="px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors text-sm"
                          >
                            Usar
                          </button>
                          <button
                            onClick={() => excluirMeioPagamento(meio.id)}
                            className="px-3 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors text-sm"
                          >
                            Excluir
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Defesa */}
      {showDefesaModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-red-100 rounded-lg">
                  <AlertTriangle size={24} className="text-red-600" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">Marcar como Defesa</h2>
                  <p className="text-sm text-gray-600">Lote {formData.numero_lote}</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowDefesaModal(false);
                  setValorDefesa('');
                  setComissaoDefesa('');
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Valor por Unidade (R$) *
                </label>
                <input
                  type="text"
                  value={valorDefesa}
                  onChange={(e) => setValorDefesa(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); marcarComoDefesa(); } }}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-lg"
                  placeholder="1500,00"
                  required
                  autoFocus
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Comissão de Defesa (Opcional)
                </label>
                <select
                  value={comissaoDefesa}
                  onChange={(e) => setComissaoDefesa(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-lg"
                >
                  <option value="">Sem comissão (Defesa gratuita)</option>
                  {Array.isArray(opcoes.comissoes) && opcoes.comissoes.map(comissao => (
                    <option key={comissao.id} value={comissao.id}>
                      {comissao.nome} {comissao.tipo_comissao === 'socios' && '(Sócios)'}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="text-sm text-red-700">
                  <div><strong>Quantidade:</strong> {formData.qtd} animais</div>
                  <div><strong>Valor Unitário:</strong> R$ {valorDefesa || '0,00'}</div>
                  <div className="text-lg font-bold text-red-800 mt-2">
                    <strong>Valor Total:</strong> R$ {(parseFloat(valorDefesa?.replace(',', '.') || 0) * parseInt(formData.qtd || 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </div>
                  
                  {/* Preview da Comissão */}
                  {comissaoDefesa && (() => {
                    const comissaoSelecionada = opcoes.comissoes?.find(c => c.id.toString() === comissaoDefesa);
                    if (comissaoSelecionada) {
                      const valorTotal = parseFloat(valorDefesa?.replace(',', '.') || 0) * parseInt(formData.qtd || 0);
                      const pctDefesa = calcularPctComissaoDefesa(comissaoSelecionada);
                      const valorComissao = (valorTotal * pctDefesa) / 100;
                      return (
                        <div className="mt-3 pt-3 border-t border-red-300">
                          <div className="flex justify-between items-center">
                            <span className="text-sm font-medium text-red-700">🛡️ Comissão Defesa:</span>
                            <div className="text-right">
                              <div className="text-sm font-bold text-red-800">{pctDefesa}%</div>
                              <div className="text-xs text-red-600">R$ {valorComissao.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })()}
                  
                  <div className="text-xs text-red-600 mt-2">
                    ⚠️ Comprador será definido como o mesmo vendedor
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setShowDefesaModal(false);
                    setValorDefesa('');
                    setComissaoDefesa('');
                  }}
                  className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={marcarComoDefesa}
                  className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium"
                >
                  Marcar como Defesa
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Overlay: Desfazendo Negociação ── */}
      {desfazendo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 min-w-[260px]">
            <div className="w-12 h-12 border-4 border-red-200 border-t-red-600 rounded-full animate-spin" />
            <div className="text-center">
              <p className="text-base font-semibold text-gray-800">Desfazendo negociação...</p>
              <p className="text-xs text-gray-500 mt-1">Aguarde, isso pode levar alguns segundos</p>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal: Refugar ── */}
      <RefugarModal
        isOpen={showRefugarModal}
        onClose={() => setShowRefugarModal(false)}
        onSuccess={() => {
          setShowRefugarModal(false);
          navigate(-1);
        }}
        organizadorId={organizadorAtivo?.id}
        lote={{
          id: loteId,
          numero_lote: formData.numero_lote,
          qtd: parseInt(formData.qtd) || 0,
          status: loteStatus,
          valor_venda_unidade: formData.valor_venda_unidade,
        }}
      />

      {/* ── Modal: Doar Novamente (leilão beneficente) ── */}
      <DoarNovamenteModal
        isOpen={showDoarNovamenteModal}
        onClose={() => setShowDoarNovamenteModal(false)}
        onSuccess={(resultado) => {
          setShowDoarNovamenteModal(false);
          const novoId = resultado?.lote_novo?.id;
          if (novoId) {
            navigate(`/lotes/editar/${novoId}`, { state: { step: 4 } });
          }
        }}
        organizadorId={organizadorAtivo?.id}
        lote={{
          id: loteId,
          numero_lote: formData.numero_lote,
          qtd: parseInt(formData.qtd) || 0,
          valor_venda_unidade: formData.valor_venda_unidade,
          valor_venda_total: formData.valor_venda_total,
        }}
      />

      {/* ── Modal: Isentar/Reverter GTA / Nota do lote ── */}
      {showIsentarGtaModal && (
        <IsentarGTAModal
          escopo="lote"
          numeroLote={formData.numero_lote}
          loteId={loteId}
          orgId={organizadorAtivo?.id}
          gtaIsento={gtaIsento}
          notaIsento={notaIsento}
          onClose={() => setShowIsentarGtaModal(false)}
          onSaved={() => {
            setShowIsentarGtaModal(false);
            carregarLote();
          }}
        />
      )}

      {/* ── Modal: Faturar outro lote ── */}
      {faturarOutroModal && (() => {
        const loteFiltrado = faturarOutroLotes.filter(l => {
          const q = faturarOutroSearch.toLowerCase();
          return !q ||
            contem(l.numero_lote, q) ||
            contem(l.vendedor?.nome, q) ||
            contem(l.vendedor?.apelido, q) ||
            contem(l.curral, q) ||
            contem(l.tipo_animal?.nome, q);
        });

        const confirmarFaturarOutro = () => {
          if (!faturarOutroSelecionado || !faturarOutroValor || parseFloat(faturarOutroValor) <= 0) return;
          const valorUnit = parseFloat(faturarOutroValor);
          const qtd = faturarOutroSelecionado.qtd || 1;
          const isPorParcela = dadosLeilao?.regra_faturamento === 'por_parcela';
          let valorTotalPrecalculado = valorUnit * qtd;
          if (isPorParcela && dadosLeilao?.meio_pagamento_padrao_id) {
            const meio = meiosPagamento.find(m => m.id === dadosLeilao.meio_pagamento_padrao_id);
            const qtdParcelas = meio?.grupos_parcelas?.reduce((acc, g) => acc + g.quantidade * (g.peso || 1), 0) || 1;
            valorTotalPrecalculado = valorUnit * qtdParcelas * qtd;
          }
          navigate(`/lotes/editar/${faturarOutroSelecionado.id}`, {
            state: { step: 4, valorVendaUnidade: valorUnit, valorTotalPrecalculado }
          });
          setFaturarOutroModal(false);
        };

        return (
          <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg flex flex-col max-h-[90vh]">

              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-gray-100 flex-shrink-0">
                <div>
                  <h2 className="text-lg font-bold text-gray-900">
                    {faturarOutroSelecionado ? 'Definir Valor de Venda' : 'Faturar outro lote?'}
                  </h2>
                  <p className="text-sm text-gray-500 mt-0.5">
                    {faturarOutroSelecionado
                      ? `Lote ${faturarOutroSelecionado.numero_lote} — ${faturarOutroSelecionado.qtd} animais`
                      : `${faturarOutroLotes.length} lote(s) disponível(is) neste leilão`}
                  </p>
                </div>
                <button
                  onClick={() => setFaturarOutroModal(false)}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <X size={20} className="text-gray-500" />
                </button>
              </div>

              {faturarOutroLotes.length === 0 ? (
                /* Sem lotes disponíveis — leilão finalizado */
                <div className="p-8 text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Check size={32} className="text-green-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Leilão finalizado! 🎉</h3>
                  <p className="text-sm text-gray-500 mb-6">Todos os lotes deste leilão já foram faturados.</p>
                  <button
                    onClick={() => setFaturarOutroModal(false)}
                    className="w-full py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl font-medium transition-colors"
                  >
                    Fechar
                  </button>
                </div>
              ) : !faturarOutroSelecionado ? (
                /* Step 1 — buscar lote */
                <>
                  <div className="p-4 border-b border-gray-100 flex-shrink-0">
                    <input
                      type="text"
                      autoFocus
                      placeholder={`Buscar por número, vendedor, ${labelCurral.toLowerCase()}...`}
                      value={faturarOutroSearch}
                      onChange={e => setFaturarOutroSearch(e.target.value)}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-400 focus:border-transparent"
                    />
                  </div>

                  <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-1.5">
                    {loteFiltrado.length === 0 ? (
                      <p className="text-center text-gray-400 text-sm py-8">Nenhum lote encontrado</p>
                    ) : loteFiltrado.map(l => (
                      <button
                        key={l.id}
                        onClick={() => { setFaturarOutroSelecionado(l); setFaturarOutroValor(''); }}
                        className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 hover:border-green-400 hover:bg-green-50 transition-all text-left group"
                      >
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="font-bold text-gray-900">Lote {l.numero_lote}</span>
                            {l.curral && (
                              <span className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded font-medium">
                                {labelCurral} {l.curral}
                              </span>
                            )}
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                              l.status === 'EDITADO' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'
                            }`}>{l.status}</span>
                          </div>
                          <div className="text-sm text-gray-500 mt-0.5">
                            {l.qtd} {l.tipo_animal?.nome} · {l.vendedor?.nome || '—'}
                          </div>
                        </div>
                        <ArrowRight size={16} className="text-gray-300 group-hover:text-green-500 transition-colors flex-shrink-0" />
                      </button>
                    ))}
                  </div>

                  <div className="p-4 border-t border-gray-100 flex-shrink-0">
                    <button
                      onClick={() => setFaturarOutroModal(false)}
                      className="w-full py-2.5 border border-gray-300 text-gray-600 rounded-xl hover:bg-gray-50 transition-colors font-medium text-sm"
                    >
                      Não, obrigado
                    </button>
                  </div>
                </>
              ) : (
                /* Step 2 — valor de venda */
                <div className="p-5 space-y-4">
                  {/* Resumo do lote selecionado */}
                  <div className="bg-gray-50 rounded-xl p-3 flex items-center justify-between">
                    <div>
                      <p className="font-bold text-gray-900">Lote {faturarOutroSelecionado.numero_lote}</p>
                      <p className="text-xs text-gray-500">
                        {faturarOutroSelecionado.qtd} {faturarOutroSelecionado.tipo_animal?.nome} · {faturarOutroSelecionado.vendedor?.nome}
                      </p>
                    </div>
                    <button
                      onClick={() => setFaturarOutroSelecionado(null)}
                      className="text-xs text-blue-600 hover:text-blue-800 font-medium"
                    >
                      Trocar
                    </button>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Valor por Cabeça (R$)</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={faturarOutroValor}
                      onChange={e => setFaturarOutroValor(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') confirmarFaturarOutro(); }}
                      placeholder="0,00"
                      autoFocus
                      className="w-full border border-gray-300 rounded-xl px-4 py-3 text-lg focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-transparent"
                    />
                  </div>

                  {faturarOutroValor && parseFloat(faturarOutroValor) > 0 && (
                    <div className="bg-green-50 border border-green-200 rounded-xl p-4 space-y-1.5">
                      <div className="flex justify-between text-sm text-gray-600">
                        <span>Valor unitário</span>
                        <span className="font-medium">R$ {parseFloat(faturarOutroValor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="flex justify-between text-sm text-gray-600">
                        <span>Quantidade</span>
                        <span className="font-medium">{faturarOutroSelecionado.qtd} animais</span>
                      </div>
                      <div className="flex justify-between text-base font-bold text-green-800 border-t border-green-200 pt-2 mt-1">
                        <span>Total estimado</span>
                        <span>R$ {(parseFloat(faturarOutroValor) * faturarOutroSelecionado.qtd).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  )}

                  <div className="flex gap-3 pt-1">
                    <button
                      onClick={() => setFaturarOutroModal(false)}
                      className="flex-1 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-medium"
                    >
                      Cancelar
                    </button>
                    <button
                      disabled={!faturarOutroValor || parseFloat(faturarOutroValor) <= 0}
                      onClick={confirmarFaturarOutro}
                      className="flex-1 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-200 disabled:cursor-not-allowed text-white rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
                    >
                      Ir para Financeiro
                      <ArrowRight size={18} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Toast Messages */}
      <div className="fixed top-4 right-4 z-[9999] space-y-2">
        {toast.toasts.map((t) => (
          <div
            key={t.id}
            className={`px-6 py-3 rounded-xl shadow-2xl text-white text-sm font-semibold min-w-64 ${
              t.type === 'success' ? 'bg-green-500' :
              t.type === 'error' ? 'bg-red-500' :
              t.type === 'warning' ? 'bg-yellow-500' :
              'bg-blue-500'
            }`}
          >
            {t.message}
          </div>
        ))}
      </div>

      {/* Modal Impressão Pós-Faturamento */}
      {showModalImpressao && (
        <ModalImpressaoPosFaturamento
          lote={{ id: loteId, numero_lote: formData.numero_lote }}
          organizador={organizadorAtivo}
          opcoesSelecionadas={contratoConfig?.modal_impressao_opcoes || []}
          mostrarNovoLote={!!contratoConfig?.modal_impressao_novo_lote}
          leilaoId={loteAtualLeilaoId || (leilaoId ? parseInt(leilaoId) : null)}
          onIrParaLote={(alvo) => {
            setShowModalImpressao(false);
            navigate(`/lotes/editar/${alvo.id}`, { state: { step: 4 } });
          }}
          onClose={() => setShowModalImpressao(false)}
        />
      )}
    </div>
  );
};

export default NovoLote;


